// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const BO: IClientSubSystemModel = {
  Code: 'BO',
  DisplayLabel: 'Bokning',
  BusinessModels: {
    BONarvaro: {
      CollectionName: 'BONarvaro',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Narvaro',
        Abstract: false,
        SOLabel: 'Närvaro',
        SOGLabel: 'Närvaro',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BONarvaros primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BONarvaros versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BONarvaros fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NARVARANDE: {
          AttributeName: 'NARVARANDE',
          DisplayLabel: 'Närvarande',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        Telefon2: {
          AttributeName: 'Telefon2',
          DisplayLabel: 'Telefon2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Telefon: {
          AttributeName: 'Telefon',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Mobiltelefon: {
          AttributeName: 'Mobiltelefon',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PersNr: {
          AttributeName: 'PersNr',
          DisplayLabel: 'Personnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Gatuadress: {
          AttributeName: 'Gatuadress',
          DisplayLabel: 'Gatuadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        CO: {
          AttributeName: 'CO',
          DisplayLabel: 'CO',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Postnummer: {
          AttributeName: 'Postnummer',
          DisplayLabel: 'Postnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Ort: {
          AttributeName: 'Ort',
          DisplayLabel: 'Ort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Fornamn: {
          AttributeName: 'Fornamn',
          DisplayLabel: 'Förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Efternamn: {
          AttributeName: 'Efternamn',
          DisplayLabel: 'Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SMTP: {
          AttributeName: 'SMTP',
          DisplayLabel: 'E-post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Telefonarbetet: {
          AttributeName: 'Telefonarbetet',
          DisplayLabel: 'Telefon arbetet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Sammankomst: {
          AssociationName: 'Sammankomst',
          DisplayLabel: 'Sammankomst',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOSammankomst',
          AssociatedComponentName: 'Sammankomst',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Medlem: {
          AssociationName: 'Medlem',
          DisplayLabel: 'Medlem',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOTEDBOGruppmedlemOP',
          AssociatedComponentName: 'GruppmedlemOP',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Grupp: {
          AssociationName: 'Grupp',
          DisplayLabel: 'Grupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOGruppOP',
          AssociatedComponentName: 'GruppOP',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOGruppBehorighet: {
      CollectionName: 'BOGruppBehorighet',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GruppBehorighet',
        Abstract: true,
        SOLabel: 'Behörighet',
        SOGLabel: 'Behörighets',
        SBLabel: 'Behörigheten',
        SBGLabel: 'Behörighetens',
        POLabel: 'Behörigheter',
        POGLabel: 'Behörigheters',
        PBLabel: 'Behörigheterna',
        PBGLabel: 'Behörigheternas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'GruppBehAnvandare',
            Abstract: false,
            SOLabel: 'Behörig användare',
            SOGLabel: 'Behörig användare',
            SBLabel: '',
            SBGLabel: '',
            POLabel: '',
            POGLabel: '',
            PBLabel: '',
            PBGLabel: '',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'GruppBehGrupp',
            Abstract: false,
            SOLabel: 'Behörig grupp',
            SOGLabel: 'Behörig grupp',
            SBLabel: '',
            SBGLabel: '',
            POLabel: '',
            POGLabel: '',
            PBLabel: '',
            PBGLabel: '',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'GruppBehMedlem',
            Abstract: false,
            SOLabel: 'Behörig medlem',
            SOGLabel: 'Behörig medlem',
            SBLabel: '',
            SBGLabel: '',
            POLabel: '',
            POGLabel: '',
            PBLabel: '',
            PBGLabel: '',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Behörighetens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Behörighetens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ av gruppanvändare',
          DataType: 'Enum',
          EnumValues: new Map([['GRUPPBEHANVANDARE', 'Behörig användare'], ['GRUPPBEHGRUPP', 'Behörig grupp'], ['GRUPPBEHMEDLEM', 'Behörig medlem']]),
          EnumSortValues: new Map([['GRUPPBEHANVANDARE', 'A'], ['GRUPPBEHGRUPP', 'G'], ['GRUPPBEHMEDLEM', 'M']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Behörighetens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Behörighetens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANSVARIG: {
          AttributeName: 'ANSVARIG',
          DisplayLabel: 'Ansvarig',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        BEH_NARVARO: {
          AttributeName: 'BEH_NARVARO',
          DisplayLabel: 'Behörig närvaro',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BEH_ANDRA: {
          AttributeName: 'BEH_ANDRA',
          DisplayLabel: 'Behörig ändra',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        BEH_UTSKICK: {
          AttributeName: 'BEH_UTSKICK',
          DisplayLabel: 'Behörig utskick',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användar id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppBehAnvandare'],
        },
        BehAnvandarNamn: {
          AttributeName: 'BehAnvandarNamn',
          DisplayLabel: 'Behörig användare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppBehAnvandare'],
        },
        BEH_GRUPP_ID: {
          AttributeName: 'BEH_GRUPP_ID',
          DisplayLabel: 'Behörig grupp id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppBehGrupp'],
        },
        BehGruppNamn: {
          AttributeName: 'BehGruppNamn',
          DisplayLabel: 'Behörig grupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppBehGrupp'],
        },
        MEDL_GRUPP_ID: {
          AttributeName: 'MEDL_GRUPP_ID',
          DisplayLabel: 'Medlems grupp id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppBehMedlem'],
        },
        MEDL_LOPNR: {
          AttributeName: 'MEDL_LOPNR',
          DisplayLabel: 'Medlems löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppBehMedlem'],
        },
        BehMedlemNamn: {
          AttributeName: 'BehMedlemNamn',
          DisplayLabel: 'Behörig medlem',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppBehMedlem'],
        },
        BehMedlemGruppNamn: {
          AttributeName: 'BehMedlemGruppNamn',
          DisplayLabel: 'Gruppnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppBehMedlem'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grupp: {
          AssociationName: 'Grupp',
          DisplayLabel: 'Grupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOGruppOP',
          AssociatedComponentName: 'GruppOP',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BehAnvandare: {
          AssociationName: 'BehAnvandare',
          DisplayLabel: 'Behörig användare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: ['GruppBehAnvandare'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BehGrupp: {
          AssociationName: 'BehGrupp',
          DisplayLabel: 'Behörig grupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOGruppOP',
          AssociatedComponentName: 'GruppOP',
          JoinAssociation: true,
          ValidInComps: ['GruppBehGrupp'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BehMedlem: {
          AssociationName: 'BehMedlem',
          DisplayLabel: 'Behörig medlem',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOTEDBOGruppmedlemOP',
          AssociatedComponentName: 'GruppMedlemOP',
          JoinAssociation: true,
          ValidInComps: ['GruppBehMedlem'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOPlankatBokngrupp: {
      CollectionName: 'BOPlankatBokngrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'PlankatBokngrupp',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOPlankatBokngrupps primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOPlankatBokngrupps versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOPlankatBokngrupps fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLANKAT_ID: {
          AttributeName: 'PLANKAT_ID',
          DisplayLabel: 'Planeringskategori',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNGRUPP_ID: {
          AttributeName: 'BOKNGRUPP_ID',
          DisplayLabel: 'Bokningsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokngrupp: {
          AssociationName: 'Bokngrupp',
          DisplayLabel: 'Bokningsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSBokngrupp',
          AssociatedComponentName: 'Bokngrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kategori: {
          AssociationName: 'Kategori',
          DisplayLabel: 'Kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOPlaneringskategori',
          AssociatedComponentName: 'Planeringskategori',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktPsalmer: {
      CollectionName: 'BOAktPsalmer',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktPsalmer',
        Abstract: false,
        SOLabel: 'Aktivitet psalm',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOAktPsalmers primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOAktPsalmers versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'BOAktPsalmers id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOAktPsalmers fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PSALMNR: {
          AttributeName: 'PSALMNR',
          DisplayLabel: 'Psalmnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PsalmTitel: {
          AttributeName: 'PsalmTitel',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Psalm: {
          AssociationName: 'Psalm',
          DisplayLabel: 'Psalm',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOPsalm',
          AssociatedComponentName: 'Psalm',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktAlderindelning: {
      CollectionName: 'BOAktAlderindelning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktAlderindelning',
        Abstract: false,
        SOLabel: 'Aktivitetens ålderintervall',
        SOGLabel: 'Aktivitetens ålderintervall',
        SBLabel: 'Aktivitetens ålderintervall',
        SBGLabel: 'Aktivitetens ålderintervall',
        POLabel: 'Aktivitetens ålderintervall',
        POGLabel: 'Aktivitetens ålderintervall',
        PBLabel: 'Aktivitetens ålderintervall',
        PBGLabel: 'Aktivitetens ålderintervall',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Aktivitetens ålderintervall primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Aktivitetens ålderintervall versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Aktivitetens ålderintervall fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: '"MinValue=0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Aldersindelning: {
          AssociationName: 'Aldersindelning',
          DisplayLabel: 'Åldersindelning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAldersindelning',
          AssociatedComponentName: 'Aldersindelning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktivitet: {
      CollectionName: 'BOAktivitet',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['EmailPaths', 'Beställare=Bestallare.Adress.SMTP1'], ['USER_DEF_REPORT_ROUTINE', '1001'], ['AllowEdit', '1001,1038,1039,16001']]),
      RootType: {
        TypeValue: 'Aktivitet',
        Abstract: true,
        SOLabel: 'Aktivitet',
        SOGLabel: 'Aktivitet',
        SBLabel: 'Aktiviteten',
        SBGLabel: 'Aktiviteten',
        POLabel: 'Aktiviteter',
        POGLabel: 'Aktiviteter',
        PBLabel: 'Aktiviteterna',
        PBGLabel: 'Aktiviteterna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'KyrkAkt',
            Abstract: true,
            SOLabel: 'Kyrklig aktivitet',
            SOGLabel: 'Kyrklig aktivitet',
            SBLabel: 'Kyrkliga aktiviteten',
            SBGLabel: 'Kyrkliga aktiviteten',
            POLabel: 'Kyrkliga aktiviteter',
            POGLabel: 'Kyrkliga aktiviteter',
            PBLabel: 'Kyrkliga aktiviteterna',
            PBGLabel: 'Kyrkliga aktiviteterna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'BegrGrav',
                Abstract: true,
                SOLabel: 'Begravning/Gravsättning',
                SOGLabel: 'Begravning/Gravsättning',
                SBLabel: 'Begravningen/Gravsättningen',
                SBGLabel: 'Begravningen/Gravsättningen',
                POLabel: 'Begravningar/Gravsättningar',
                POGLabel: 'Begravningar/Gravsättningar',
                PBLabel: 'Begravningarna/Gravsättningarna',
                PBGLabel: 'Begravningarna/Gravsättningarna',
                Visible: true,
                ChildTypes: [
                  {
                    TypeValue: 'Gravsattning',
                    Abstract: false,
                    SOLabel: 'Gravsättning',
                    SOGLabel: 'Gravsättning',
                    SBLabel: 'Gravsättningen',
                    SBGLabel: 'Gravsättningen',
                    POLabel: 'Gravsättningar',
                    POGLabel: 'Gravsättningar',
                    PBLabel: 'Gravsättningarna',
                    PBGLabel: 'Gravsättningarna',
                    Visible: true,
                    ChildTypes: [
                    ],
                  },
                  {
                    TypeValue: 'Begravning',
                    Abstract: false,
                    SOLabel: 'Begravning',
                    SOGLabel: 'Begravning',
                    SBLabel: 'Begravningen',
                    SBGLabel: 'Begravningen',
                    POLabel: 'Begravningar',
                    POGLabel: 'Begravningar',
                    PBLabel: 'Begravningarna',
                    PBGLabel: 'Begravningarna',
                    Visible: true,
                    ChildTypes: [
                    ],
                  },
                ],
              },
              {
                TypeValue: 'Dop',
                Abstract: false,
                SOLabel: 'Dop',
                SOGLabel: 'Dop',
                SBLabel: 'Dopet',
                SBGLabel: 'Dopet',
                POLabel: 'Dop',
                POGLabel: 'Dop',
                PBLabel: 'Dopen',
                PBGLabel: 'Dopen',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Vigsel',
                Abstract: false,
                SOLabel: 'Vigsel',
                SOGLabel: 'Vigsel',
                SBLabel: 'Vigseln',
                SBGLabel: 'Vigseln',
                POLabel: 'Vigslar',
                POGLabel: 'Vigslar',
                PBLabel: 'Vigslarna',
                PBGLabel: 'Vigslarna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Gudstjanst',
                Abstract: false,
                SOLabel: 'Gudstjänst',
                SOGLabel: 'Gudstjänst',
                SBLabel: 'Gudstjänsten',
                SBGLabel: 'Gudstjänsten',
                POLabel: 'Gudstjänster',
                POGLabel: 'Gudstjänster',
                PBLabel: 'Gudstjänsterna',
                PBGLabel: 'Gudstjänsterna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Konfirmation',
                Abstract: false,
                SOLabel: 'Konfirmation',
                SOGLabel: 'Konfirmation',
                SBLabel: 'Konfirmationen',
                SBGLabel: 'Konfirmationen',
                POLabel: 'Konfirmationer',
                POGLabel: 'Konfirmationer',
                PBLabel: 'Konfirmationerna',
                PBGLabel: 'Konfirmationerna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'AktOvrLok',
            Abstract: true,
            SOLabel: 'Övrig aktivitet/Lokaluthyrning',
            SOGLabel: 'Övrig aktivitets/Lokaluthyrnings',
            SBLabel: 'Övriga aktiviteten/Lokaluthyrningen',
            SBGLabel: 'Övriga aktivitetens/Lokaluthyrningen',
            POLabel: 'Övriga aktiviteter/Lokaluthyrningar',
            POGLabel: 'Övriga aktiviteters/Lokaluthyrningars',
            PBLabel: 'Övriga aktiviteterna/Lokaluthyrningarna',
            PBGLabel: 'Övriga aktiviteternas/Lokaluthyrningarnas',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Lokaluthyrning',
                Abstract: false,
                SOLabel: 'Lokaluthyrning',
                SOGLabel: 'Lokaluthyrning',
                SBLabel: 'Lokaluthyrningen',
                SBGLabel: 'Lokaluthyrningen',
                POLabel: 'Lokaluthyrningar',
                POGLabel: 'Lokaluthyrningar',
                PBLabel: 'Lokaluthyrningarna',
                PBGLabel: 'Lokaluthyrningarna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'AktOvrigt',
                Abstract: false,
                SOLabel: 'Övrig aktivitet',
                SOGLabel: 'Övrig aktivitets',
                SBLabel: 'Övriga aktiviteten',
                SBGLabel: 'Övriga aktivitetens',
                POLabel: 'Övriga aktiviteter',
                POGLabel: 'Övriga aktiviteters',
                PBLabel: 'Övriga aktiviteterna',
                PBGLabel: 'Övriga aktiviteternas',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Snabbokning',
            Abstract: false,
            SOLabel: 'Snabbokning',
            SOGLabel: 'Snabbokning',
            SBLabel: 'Snabbokningen',
            SBGLabel: 'Snabbokningen',
            POLabel: 'Snabbokningar',
            POGLabel: 'Snabbokningar',
            PBLabel: 'Snabbokningarna',
            PBGLabel: 'Snabbokningarna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Outlook',
            Abstract: false,
            SOLabel: 'Outlook',
            SOGLabel: 'Outlook',
            SBLabel: 'Outlooken',
            SBGLabel: 'Outlooken',
            POLabel: 'Outlook',
            POGLabel: 'Outlook',
            PBLabel: 'Outlook',
            PBGLabel: 'Outlook',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'Planering',
            Abstract: false,
            SOLabel: 'Planering',
            SOGLabel: 'Planerings',
            SBLabel: 'Planeringen',
            SBGLabel: 'Planeringens',
            POLabel: '',
            POGLabel: '',
            PBLabel: '',
            PBGLabel: '',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Aktiviteten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Aktiviteten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Aktivitetstyp',
          DataType: 'Enum',
          EnumValues: new Map([['GRAVSATTNING', 'Gravsättning'], ['BEGRAVNING', 'Begravning'], ['DOP', 'Dop'], ['VIGSEL', 'Vigsel'], ['GUDSTJANST', 'Gudstjänst'], ['KONFIRMATION', 'Konfirmation'], ['LOKALUTHYRNING', 'Lokaluthyrning'], ['AKTOVRIGT', 'Övrig aktivitet'], ['SNABBOKNING', 'Snabbokning'], ['OUTLOOK', 'Outlook'], ['PLANERING', 'Planering']]),
          EnumSortValues: new Map([['GRAVSATTNING', 'G'], ['BEGRAVNING', 'B'], ['DOP', 'D'], ['VIGSEL', 'V'], ['GUDSTJANST', 'U'], ['KONFIRMATION', 'K'], ['LOKALUTHYRNING', 'L'], ['AKTOVRIGT', 'Ö'], ['SNABBOKNING', 'S'], ['OUTLOOK', 'O'], ['PLANERING', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="GRAVSATTNING=Gravsättning;BEGRAVNING=Begravning;DOP=Dop;VIGSEL=Vigsel;GUDSTJANST=Gudstjänst;KONFIRMATION=Konfirmation;LOKALUTHYRNING=Lokaluthyrning;AKTOVRIGT=Övrig aktivitet;SNABBOKNING=Snabbokning;OUTLOOK=Outlook;PLANERING=Planering"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Aktiviteten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Aktiviteten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNGRUPP_ID: {
          AttributeName: 'BOKNGRUPP_ID',
          DisplayLabel: 'Bokningsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Fråndatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        TILLDATUM: {
          AttributeName: 'TILLDATUM',
          DisplayLabel: 'Tilldatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          Required: true,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        BOKNINGSNUMMER: {
          AttributeName: 'BOKNINGSNUMMER',
          DisplayLabel: 'Bokningsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BOKNINGSNRINDEX: {
          AttributeName: 'BOKNINGSNRINDEX',
          DisplayLabel: 'Index för boknnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TIDSTEXT: {
          AttributeName: 'TIDSTEXT',
          DisplayLabel: 'Tidstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Extern notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BOKNINGSSIGNATUR: {
          AttributeName: 'BOKNINGSSIGNATUR',
          DisplayLabel: 'Bokningssignatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BOKNINGSDATUM: {
          AttributeName: 'BOKNINGSDATUM',
          DisplayLabel: 'Bokningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PRELBOKAD: {
          AttributeName: 'PRELBOKAD',
          DisplayLabel: 'Preliminärbokad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        UTSKRIVEN: {
          AttributeName: 'UTSKRIVEN',
          DisplayLabel: 'Utskriven',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        AKTIVITETSGRUPP: {
          AttributeName: 'AKTIVITETSGRUPP',
          DisplayLabel: 'Aktivitetsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        BESTALLARE_ID: {
          AttributeName: 'BESTALLARE_ID',
          DisplayLabel: 'Beställare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Beställare',
        },
        BESTALLARE_TYP: {
          AttributeName: 'BESTALLARE_TYP',
          DisplayLabel: 'Beställartyp',
          Hint: 'Annan person/Annan organisation/Anhörig/Begravningsbyrå/Person 1/Person 2/Vårdnadshavare 1/Vårdnadshavare 2',
          DataType: 'Enum',
          EnumValues: new Map([['ANNAN_PERSON', 'Annan person'], ['ANNAN_ORGANISATION', 'Annan organisation'], ['ANHORIG', 'Anhörig'], ['BEGRAVNINGSBYRA', 'Begravningsbyrå'], ['PERSON_1', 'Person 1'], ['PERSON_2', 'Person 2'], ['VARDNADSHAVARE_1', 'Vårdnadshavare 1'], ['VARDNADSHAVARE_2', 'Vårdnadshavare 2']]),
          EnumSortValues: new Map([['ANNAN_PERSON', 'P'], ['ANNAN_ORGANISATION', 'O'], ['ANHORIG', 'A'], ['BEGRAVNINGSBYRA', 'B'], ['PERSON_1', 'R'], ['PERSON_2', 'U'], ['VARDNADSHAVARE_1', 'M'], ['VARDNADSHAVARE_2', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ANNAN_PERSON=Annan person;ANNAN_ORGANISATION=Annan organisation;ANHORIG=Anhörig;BEGRAVNINGSBYRA=Begravningsbyrå;PERSON_1=Person 1;PERSON_2=Person 2;VARDNADSHAVARE_1=Vårdnadshavare 1;VARDNADSHAVARE_2=Vårdnadshavare 2"',
          AttributeGroup: 'Beställare',
        },
        BESTALLARE_KONTAKT: {
          AttributeName: 'BESTALLARE_KONTAKT',
          DisplayLabel: 'Beställarens kontakt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Beställare',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OTIMESTAMP: {
          AttributeName: 'OTIMESTAMP',
          DisplayLabel: 'Outlook timestamp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        WEBBOKAD: {
          AttributeName: 'WEBBOKAD',
          DisplayLabel: 'Webbokad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ANTAL_BESOKARE: {
          AttributeName: 'ANTAL_BESOKARE',
          DisplayLabel: 'Antal besökare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          AttributeGroup: 'Statistik',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        STATISTIKUPPGIFT: {
          AttributeName: 'STATISTIKUPPGIFT',
          DisplayLabel: 'Statistikuppgift',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Statistik',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NOTERING2: {
          AttributeName: 'NOTERING2',
          DisplayLabel: 'Intern notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEVAKNING: {
          AttributeName: 'BEVAKNING',
          DisplayLabel: 'Bevakning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEVAKNING_DATUM: {
          AttributeName: 'BEVAKNING_DATUM',
          DisplayLabel: 'Bevakningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MinDate="-0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notgreater,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEVAKNING_TEXT: {
          AttributeName: 'BEVAKNING_TEXT',
          DisplayLabel: 'Bevakningstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        REPAKTNR: {
          AttributeName: 'REPAKTNR',
          DisplayLabel: 'Repeterande aktivitetsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BESTALLARE_KONTAKT_INFO: {
          AttributeName: 'BESTALLARE_KONTAKT_INFO',
          DisplayLabel: 'Beställarens kontaktinformation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
          AttributeGroup: 'Beställare',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        PUBL_STATUS: {
          AttributeName: 'PUBL_STATUS',
          DisplayLabel: 'Publiceringsstatus',
          Hint: 'Skapad/Publiceras/Publiceras för anmälning/Publiceras ej/Avvakta',
          DataType: 'Enum',
          EnumValues: new Map([['SKAPAD', 'Skapad'], ['PUBLICERAS', 'Publiceras'], ['PUBLICERAS_FOR_ANMALNING', 'Publiceras för anmälning'], ['PUBLICERAS_EJ', 'Publiceras ej'], ['AVVAKTA', 'Avvakta']]),
          EnumSortValues: new Map([['SKAPAD', 'S'], ['PUBLICERAS', 'P'], ['PUBLICERAS_FOR_ANMALNING', 'PA'], ['PUBLICERAS_EJ', 'PE'], ['AVVAKTA', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKAPAD=Skapad;PUBLICERAS=Publiceras;PUBLICERAS_FOR_ANMALNING=Publiceras för anmälning;PUBLICERAS_EJ=Publiceras ej;AVVAKTA=Avvakta"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        BESTALLNINGS_ID: {
          AttributeName: 'BESTALLNINGS_ID',
          DisplayLabel: 'Beställnings id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WEB_PUBL_STATUS: {
          AttributeName: 'WEB_PUBL_STATUS',
          DisplayLabel: 'Web beställning',
          Hint: 'Publiceras ej/Publicerad/Beställd/Mottagen/Komplettera',
          DataType: 'Enum',
          EnumValues: new Map([['PUBLICERAS_EJ', 'Publiceras ej'], ['PUBLICERAD', 'Publicerad'], ['BESTALLD', 'Beställd'], ['MOTTAGEN', 'Mottagen'], ['KOMPLETTERA', 'Komplettera']]),
          EnumSortValues: new Map([['PUBLICERAS_EJ', 'E'], ['PUBLICERAD', 'P'], ['BESTALLD', 'W'], ['MOTTAGEN', 'B'], ['KOMPLETTERA', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PUBLICERAS_EJ=Publiceras ej;PUBLICERAD=Publicerad;BESTALLD=Beställd;MOTTAGEN=Mottagen;KOMPLETTERA=Komplettera"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        PRELBEST_DATUM: {
          AttributeName: 'PRELBEST_DATUM',
          DisplayLabel: 'Preliminärt beställningsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Preliminär beställning',
          Properties: new Map([['ffIgnoreUpdates', 'Y;']]),
        },
        PRELBEST_TID: {
          AttributeName: 'PRELBEST_TID',
          DisplayLabel: 'Preliminär beställningstid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          AttributeGroup: 'Preliminär beställning',
          Properties: new Map([['ffIgnoreUpdates', 'Y;']]),
        },
        PRELBEST_USER_ID: {
          AttributeName: 'PRELBEST_USER_ID',
          DisplayLabel: 'Preliminär beställare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Preliminär beställning',
          Properties: new Map([['ffIgnoreUpdates', 'Y;']]),
        },
        DOLJ_KALENDERTID: {
          AttributeName: 'DOLJ_KALENDERTID',
          DisplayLabel: 'Dölj tid i kalendern',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        AKTKAT_ANNONS: {
          AttributeName: 'AKTKAT_ANNONS',
          DisplayLabel: 'Aktivitetskategori, hanteras av annonsering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SENAST_ANDRAD_SIGNATUR: {
          AttributeName: 'SENAST_ANDRAD_SIGNATUR',
          DisplayLabel: 'Senast ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Tid: {
          AttributeName: 'Tid',
          DisplayLabel: 'KyrkligTid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KyrkligTidUtanSluttid: {
          AttributeName: 'KyrkligTidUtanSluttid',
          DisplayLabel: 'Kyrklig tid (utan sluttid)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NormalTid: {
          AttributeName: 'NormalTid',
          DisplayLabel: 'Tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TidUtanSluttid: {
          AttributeName: 'TidUtanSluttid',
          DisplayLabel: 'Tid utan sluttid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        oldAntalKnutnaAkt: {
          AttributeName: 'oldAntalKnutnaAkt',
          DisplayLabel: 'Antal knutna aktiviteter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalKnutnaAktiviteter: {
          AttributeName: 'AntalKnutnaAktiviteter',
          DisplayLabel: 'Antal knutna aktiviteter',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Pos1: {
          AttributeName: 'Pos1',
          DisplayLabel: 'Pos1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos2: {
          AttributeName: 'Pos2',
          DisplayLabel: 'Pos2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos3: {
          AttributeName: 'Pos3',
          DisplayLabel: 'Pos3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos4: {
          AttributeName: 'Pos4',
          DisplayLabel: 'Pos4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos5: {
          AttributeName: 'Pos5',
          DisplayLabel: 'Pos5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos6: {
          AttributeName: 'Pos6',
          DisplayLabel: 'Pos6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bokningsgrupp: {
          AttributeName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        OldVeckodag: {
          AttributeName: 'OldVeckodag',
          DisplayLabel: 'Veckodag',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fakt_skapat: {
          AttributeName: 'Fakt_skapat',
          DisplayLabel: 'Faktureringsunderlag skapat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        StatistikTyp: {
          AttributeName: 'StatistikTyp',
          DisplayLabel: 'Statistiktyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DisplayTitle: {
          AttributeName: 'DisplayTitle',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TitelBokNr: {
          AttributeName: 'TitelBokNr',
          DisplayLabel: 'Titel och bok.nr.',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Veckodag: {
          AttributeName: 'Veckodag',
          DisplayLabel: 'Veckodag',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BevakasAv: {
          AttributeName: 'BevakasAv',
          DisplayLabel: 'Bevakas av',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['UsesAssociations', 'Bevakning;']]),
        },
        Titel2: {
          AttributeName: 'Titel2',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Aktivitetskategorier: {
          AttributeName: 'Aktivitetskategorier',
          DisplayLabel: 'Aktivitetskategorier',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SenastAndrad: {
          AttributeName: 'SenastAndrad',
          DisplayLabel: 'Senast ändrad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MARKERAD_FAKTURERAD: {
          AttributeName: 'MARKERAD_FAKTURERAD',
          DisplayLabel: 'Markerad som fakturerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ClearingEjFakt: {
          AttributeName: 'ClearingEjFakt',
          DisplayLabel: 'Clearing, ej fakturerad',
          Hint: '(visar ej framtida bokningar) - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KyrkAkt'],
        },
        GRAVPLATS: {
          AttributeName: 'GRAVPLATS',
          DisplayLabel: 'Gravplats (annan ort)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Gravplats (annan ort)',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          ValidInComps: ['BegrGrav'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        RELATION: {
          AttributeName: 'RELATION',
          DisplayLabel: 'Relation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BegrGrav'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KREMERING: {
          AttributeName: 'KREMERING',
          DisplayLabel: 'Kremering/Jordbegravning',
          Hint: 'Kremering/Jordbegravning',
          DataType: 'Enum',
          EnumValues: new Map([['KREMERING', 'Kremering'], ['JORDBEGRAVNING', 'Jordbegravning']]),
          EnumSortValues: new Map([['KREMERING', 'Y'], ['JORDBEGRAVNING', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KREMERING=Kremering;JORDBEGRAVNING=Jordbegravning"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['BegrGrav'],
          Properties: new Map([['ffIgnoreChanges', 'Y;'], ['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        INTYG: {
          AttributeName: 'INTYG',
          DisplayLabel: 'Intyg gravsättning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['BegrGrav'],
        },
        INTYG2: {
          AttributeName: 'INTYG2',
          DisplayLabel: 'Intyg kremering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['BegrGrav'],
        },
        ANHORIG_ID: {
          AttributeName: 'ANHORIG_ID',
          DisplayLabel: 'Anhörig',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
        },
        BEGRBYRA_ID: {
          AttributeName: 'BEGRBYRA_ID',
          DisplayLabel: 'Begravningsbyrå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Begravningsbyrå',
        },
        BEGRBYRA_KONTAKT: {
          AttributeName: 'BEGRBYRA_KONTAKT',
          DisplayLabel: 'Begravningsbyråns kontak',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Begravningsbyrå',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRBYRA_KONTAKT_INFO: {
          AttributeName: 'BEGRBYRA_KONTAKT_INFO',
          DisplayLabel: 'Begravningsbyråns kontaktinformation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Begravningsbyrå',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KVARTER_KGARD_ID: {
          AttributeName: 'KVARTER_KGARD_ID',
          DisplayLabel: 'Kyrkogård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Gravplats',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Gravplats',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVDELNING_ID: {
          AttributeName: 'AVDELNING_ID',
          DisplayLabel: 'Avdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Gravplats',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVNUMMER: {
          AttributeName: 'GRAVNUMMER',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Gravplats',
        },
        REDAN_KREMERAD: {
          AttributeName: 'REDAN_KREMERAD',
          DisplayLabel: 'Redan kremerad',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Kremering',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        REDAN_GRAVSATT: {
          AttributeName: 'REDAN_GRAVSATT',
          DisplayLabel: 'Redan gravsatt',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        KREMERING_ANNAN_ORT: {
          AttributeName: 'KREMERING_ANNAN_ORT',
          DisplayLabel: 'Kremering annan ort',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Kremering',
        },
        KGARD_ANNANORT_ID: {
          AttributeName: 'KGARD_ANNANORT_ID',
          DisplayLabel: 'Kyrkogård (annan ort)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Gravplats (annan ort)',
        },
        BEGRAVNINGSTYP_ID: {
          AttributeName: 'BEGRAVNINGSTYP_ID',
          DisplayLabel: 'BegravningstypID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
        },
        KremNr: {
          AttributeName: 'KremNr',
          DisplayLabel: 'Kremationsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Kremering',
        },
        KremDatum: {
          AttributeName: 'KremDatum',
          DisplayLabel: 'Kremationsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit="0"',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Kremering',
        },
        KremAvhamtDatum: {
          AttributeName: 'KremAvhamtDatum',
          DisplayLabel: 'Kremation avhämtningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          AttributeGroup: 'Kremering',
        },
        Begravningstyp: {
          AttributeName: 'Begravningstyp',
          DisplayLabel: 'Begravningsordning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['BegrGrav'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegravningsclearingEjFakt: {
          AttributeName: 'BegravningsclearingEjFakt',
          DisplayLabel: 'Begravning/Statlig clearing, ej fakturerad',
          Hint: '(visar ej aktiviteter framåt i tiden) - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['BegrGrav'],
        },
        JORDBEGRAVNING: {
          AttributeName: 'JORDBEGRAVNING',
          DisplayLabel: 'Jordbegravning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Gravsattning'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        URNSATTNING: {
          AttributeName: 'URNSATTNING',
          DisplayLabel: 'Urnsättning',
          Hint: 'Urnsättning/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'TrueText="Urnsättning"',
          FormatterDisplayParams: 'TrueText="Urnsättning"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Gravsattning'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        MINNESLUND: {
          AttributeName: 'MINNESLUND',
          DisplayLabel: 'Minneslund',
          Hint: 'Minneslund/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'TrueText="Minneslund"',
          FormatterDisplayParams: 'TrueText="Minneslund"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Gravsattning'],
        },
        AN_NARVARANDE: {
          AttributeName: 'AN_NARVARANDE',
          DisplayLabel: 'Anhöriga närvarande',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Gravsattning'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Begravningsdatum: {
          AttributeName: 'Begravningsdatum',
          DisplayLabel: 'Begravningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BegrGrav'],
        },
        Begravningstid: {
          AttributeName: 'Begravningstid',
          DisplayLabel: 'Begravningstid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTime',
          ValidInComps: ['BegrGrav'],
        },
        GravsBegrplats: {
          AttributeName: 'GravsBegrplats',
          DisplayLabel: 'Begravningsplats (gravsättning)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Gravsattning'],
        },
        Gravsattningsplats: {
          AttributeName: 'Gravsattningsplats',
          DisplayLabel: 'Gravsättningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Gravsattning'],
        },
        Gravsattningsdatum: {
          AttributeName: 'Gravsattningsdatum',
          DisplayLabel: 'Gravsättningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BegrGrav'],
        },
        BegravningsplatsID: {
          AttributeName: 'BegravningsplatsID',
          DisplayLabel: 'BegravningsplatsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Begravning'],
        },
        Begravningsplats: {
          AttributeName: 'Begravningsplats',
          DisplayLabel: 'Begravningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Begravning'],
        },
        Gravsattningstid: {
          AttributeName: 'Gravsattningstid',
          DisplayLabel: 'Gravsattningstid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTime',
          ValidInComps: ['BegrGrav'],
        },
        DOPBARN_ID: {
          AttributeName: 'DOPBARN_ID',
          DisplayLabel: 'Dopkandidat',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Dop', 'AktOvrLok'],
        },
        MODER_ID: {
          AttributeName: 'MODER_ID',
          DisplayLabel: 'Moder',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Dop'],
        },
        FADER_ID: {
          AttributeName: 'FADER_ID',
          DisplayLabel: 'Fader',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Dop'],
        },
        ENSKILT_DOP: {
          AttributeName: 'ENSKILT_DOP',
          DisplayLabel: 'Enskilt dop',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Dop'],
        },
        DopclearingEjFakt: {
          AttributeName: 'DopclearingEjFakt',
          DisplayLabel: 'Dopclearing, ej fakturerad',
          Hint: '(visar ej framtida bokningar) - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterValidateParams: 'ValidValues="Y;N"',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Dop'],
        },
        BRUDGUM_ID: {
          AttributeName: 'BRUDGUM_ID',
          DisplayLabel: 'Person 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Vigsel', 'AktOvrLok'],
        },
        BRUD_ID: {
          AttributeName: 'BRUD_ID',
          DisplayLabel: 'Person 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Vigsel', 'AktOvrLok'],
        },
        VIGSELORDNING: {
          AttributeName: 'VIGSELORDNING',
          DisplayLabel: 'Vigselordning',
          Hint: 'Svenska kyrkans ordning/Välsignelse över ingånget äktenskap/Välsignelse över registrerat partnerskap/Annan ordning',
          DataType: 'Enum',
          EnumValues: new Map([['SVENSKA_KYRKANS_ORDNING', 'Svenska kyrkans ordning'], ['VALSIGNELSE_OVER_INGANGET_AKTENSKAP', 'Välsignelse över ingånget äktenskap'], ['VALSIGNELSE_OVER_REGISTRERAT_PARTNERSKAP', 'Välsignelse över registrerat partnerskap'], ['ANNAN_ORDNING', 'Annan ordning']]),
          EnumSortValues: new Map([['SVENSKA_KYRKANS_ORDNING', 'S'], ['VALSIGNELSE_OVER_INGANGET_AKTENSKAP', 'B'], ['VALSIGNELSE_OVER_REGISTRERAT_PARTNERSKAP', 'P'], ['ANNAN_ORDNING', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SVENSKA_KYRKANS_ORDNING=Svenska kyrkans ordning;VALSIGNELSE_OVER_INGANGET_AKTENSKAP=Välsignelse över ingånget äktenskap;VALSIGNELSE_OVER_REGISTRERAT_PARTNERSKAP=Välsignelse över registrerat partnerskap;ANNAN_ORDNING=Annan ordning"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          ValidInComps: ['Vigsel'],
        },
        VigselEjFakt: {
          AttributeName: 'VigselEjFakt',
          DisplayLabel: 'Vigselclearing, ej fakturerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Vigsel'],
        },
        GUDSTJANSTTYP_ID: {
          AttributeName: 'GUDSTJANSTTYP_ID',
          DisplayLabel: 'Gudstjänsttyp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Gudstjanst'],
        },
        KOLLEKT: {
          AttributeName: 'KOLLEKT',
          DisplayLabel: 'Kollekt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Gudstjanst'],
        },
        ANTAL_KOMMUNIONER: {
          AttributeName: 'ANTAL_KOMMUNIONER',
          DisplayLabel: 'Antal kommunioner',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Statistik',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        INGAR_PREDIKOTUR: {
          AttributeName: 'INGAR_PREDIKOTUR',
          DisplayLabel: 'Ingår i predikotur',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Gudstjanst'],
        },
        HUVUDGUDSTJANST: {
          AttributeName: 'HUVUDGUDSTJANST',
          DisplayLabel: 'Huvudgudstjänst',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Gudstjanst'],
        },
        Antal_Konfirmander: {
          AttributeName: 'Antal_Konfirmander',
          DisplayLabel: 'Antal konfirmander',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.greater,
          ValidInComps: ['Konfirmation'],
        },
        KonfirmationsClearingEjFakt: {
          AttributeName: 'KonfirmationsClearingEjFakt',
          DisplayLabel: 'Konfirmationsclearing, ej fakturerad',
          Hint: '(visar ej framtida bokningar) - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Konfirmation'],
        },
        MAXANTDELT: {
          AttributeName: 'MAXANTDELT',
          DisplayLabel: 'Max antal deltagare',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          ValidInComps: ['AktOvrLok'],
        },
        FAKTDELT: {
          AttributeName: 'FAKTDELT',
          DisplayLabel: 'Fakturera deltagare',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['AktOvrLok'],
        },
        ANNONSERA: {
          AttributeName: 'ANNONSERA',
          DisplayLabel: 'Annonsera',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['AktOvrLok'],
        },
        VERKSAMHETSTYP_ID: {
          AttributeName: 'VERKSAMHETSTYP_ID',
          DisplayLabel: 'Verksamhetstyp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['AktOvrLok'],
        },
        AntalDelt: {
          AttributeName: 'AntalDelt',
          DisplayLabel: 'Antal deltagare',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
          ValidInComps: ['AktOvrLok'],
        },
        AntalKontakter: {
          AttributeName: 'AntalKontakter',
          DisplayLabel: 'Antal kursdeltagare',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.greater,
          ValidInComps: ['AktOvrLok'],
        },
        SENASTE_ANM_DATUM: {
          AttributeName: 'SENASTE_ANM_DATUM',
          DisplayLabel: 'Senaste anmälningsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['AktOvrLok'],
        },
        ANM_KRAV_PERSNR: {
          AttributeName: 'ANM_KRAV_PERSNR',
          DisplayLabel: 'Anmälan kräver personnummer',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          ValidInComps: ['AktOvrLok'],
        },
        AntalDeltBekr: {
          AttributeName: 'AntalDeltBekr',
          DisplayLabel: 'Antal bekräftade deltagare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['AktOvrLok'],
        },
        AntalDeltPrel: {
          AttributeName: 'AntalDeltPrel',
          DisplayLabel: 'Antal preliminära deltagare',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['AktOvrLok'],
        },
        AntalDeltLediga: {
          AttributeName: 'AntalDeltLediga',
          DisplayLabel: 'Antal lediga platser',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['AktOvrLok'],
        },
        LOKALUTHYR_INFO: {
          AttributeName: 'LOKALUTHYR_INFO',
          DisplayLabel: 'Lokaluthyrningsinformation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Lokaluthyrning'],
        },
        NYCKELNUMMER: {
          AttributeName: 'NYCKELNUMMER',
          DisplayLabel: 'Nyckelnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Lokaluthyrning'],
        },
        NYCKEL_UTLAMNINGSDATUM: {
          AttributeName: 'NYCKEL_UTLAMNINGSDATUM',
          DisplayLabel: 'Nyckel utlämnad, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+1d";MinRecommendedDate="-1m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Lokaluthyrning'],
        },
        NYCKEL_ATERLAMNINGSDATUM: {
          AttributeName: 'NYCKEL_ATERLAMNINGSDATUM',
          DisplayLabel: 'Nyckel återlämnad, datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxRecommendedDate="+1m";MinRecommendedDate="-1m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Lokaluthyrning'],
        },
        NYCKEL_AVHAMTARE_ID: {
          AttributeName: 'NYCKEL_AVHAMTARE_ID',
          DisplayLabel: 'NyckelavhämtareID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Lokaluthyrning'],
          AttributeGroup: 'Nyckelavhämtare',
        },
        NYCKEL_UTLAMNAD_SIGN: {
          AttributeName: 'NYCKEL_UTLAMNAD_SIGN',
          DisplayLabel: 'Nyckel utlämnad, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Lokaluthyrning'],
        },
        NYCKEL_ATERLAMNAD_SIGN: {
          AttributeName: 'NYCKEL_ATERLAMNAD_SIGN',
          DisplayLabel: 'Nyckel återlämnad, signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Lokaluthyrning'],
        },
        NYCKEL_NOTERING: {
          AttributeName: 'NYCKEL_NOTERING',
          DisplayLabel: 'Nyckelnotering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Lokaluthyrning'],
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        NYCKEL_AVHAMTARE_TYP: {
          AttributeName: 'NYCKEL_AVHAMTARE_TYP',
          DisplayLabel: 'Nyckelavhämtartyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['Lokaluthyrning'],
          AttributeGroup: 'Nyckelavhämtare',
        },
        ANDRAD: {
          AttributeName: 'ANDRAD',
          DisplayLabel: 'Ändrad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SKK_ID: {
          AttributeName: 'SKK_ID',
          DisplayLabel: 'Svenskakyrkans Kalender remote id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SKKALENDER_ID: {
          AttributeName: 'SKKALENDER_ID',
          DisplayLabel: 'Svenskakyrkans Kalender remote id',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SKK_SPRIDNINGSTYP_INTERN: {
          AttributeName: 'SKK_SPRIDNINGSTYP_INTERN',
          DisplayLabel: 'Intern spridningstyp',
          Hint: 'Publicerad internt - Inomkyrklig/SemiIntern/Intern',
          DataType: 'Enum',
          EnumValues: new Map([['INOMKYRKLIG', 'Inomkyrklig'], ['SEMIINTERN', 'SemiIntern'], ['INTERN', 'Intern']]),
          EnumSortValues: new Map([['INOMKYRKLIG', 'K'], ['SEMIINTERN', 'S'], ['INTERN', 'I']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="INOMKYRKLIG=Inomkyrklig;SEMIINTERN=SemiIntern;INTERN=Intern"',
          AttributeGroup: 'Publicering',
        },
        SKK_SPRIDNINGSTYP_EXTERN: {
          AttributeName: 'SKK_SPRIDNINGSTYP_EXTERN',
          DisplayLabel: 'Extern publicering',
          Hint: 'Publicerad externt - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_KONTAKT_NAMN: {
          AttributeName: 'SKK_KONTAKT_NAMN',
          DisplayLabel: 'Kontakt, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SKK_KONTAKT_TELEFON: {
          AttributeName: 'SKK_KONTAKT_TELEFON',
          DisplayLabel: 'Kontakt, telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTelNr',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SKK_KONTAKT_SMTP: {
          AttributeName: 'SKK_KONTAKT_SMTP',
          DisplayLabel: 'Kontakt, e-post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SKK_URL1_TITEL: {
          AttributeName: 'SKK_URL1_TITEL',
          DisplayLabel: 'Länk 1, titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_URL1: {
          AttributeName: 'SKK_URL1',
          DisplayLabel: 'Länk 1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_URL1_DIGITALT_MOTE: {
          AttributeName: 'SKK_URL1_DIGITALT_MOTE',
          DisplayLabel: 'Länk 1, digital möteslänk',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Publicering',
        },
        SKK_URL2_TITEL: {
          AttributeName: 'SKK_URL2_TITEL',
          DisplayLabel: 'Länk 2, titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_URL2: {
          AttributeName: 'SKK_URL2',
          DisplayLabel: 'Länk 2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_URL3_TITEL: {
          AttributeName: 'SKK_URL3_TITEL',
          DisplayLabel: 'Länk 3, titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_URL3: {
          AttributeName: 'SKK_URL3',
          DisplayLabel: 'Länk 3',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_PUBL_STATUS_INTERN: {
          AttributeName: 'SKK_PUBL_STATUS_INTERN',
          DisplayLabel: 'Intern publicering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          AttributeGroup: 'Publicering',
        },
        SKK_IS_PUBLISHED: {
          AttributeName: 'SKK_IS_PUBLISHED',
          DisplayLabel: 'isPublished',
          Hint: 'Kollar om en aktivitet ska vara publicerad - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Publicering',
        },
        SKK_IS_PUBLISHED2: {
          AttributeName: 'SKK_IS_PUBLISHED2',
          DisplayLabel: 'Externt/Internt publicerad',
          Hint: 'Finns aktiviteten på hemsidan? - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          AttributeGroup: 'Publicering',
        },
        SKK_SENAST_EXPORTERAD_TID: {
          AttributeName: 'SKK_SENAST_EXPORTERAD_TID',
          DisplayLabel: 'Senast exporterad, tid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SKK_SENAST_EXPORTERAD_DATUM: {
          AttributeName: 'SKK_SENAST_EXPORTERAD_DATUM',
          DisplayLabel: 'Senast exporterad, datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SKK_SLUTTID: {
          AttributeName: 'SKK_SLUTTID',
          DisplayLabel: 'Visa sluttid',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          AttributeGroup: 'Publicering',
        },
        BrudClearing: {
          AttributeName: 'BrudClearing',
          DisplayLabel: 'Clearing mot brudens församling',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VeckodagFork: {
          AttributeName: 'VeckodagFork',
          DisplayLabel: 'Veckodag, kortnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Frandatumddmm: {
          AttributeName: 'Frandatumddmm',
          DisplayLabel: 'Fråndatum dag/mån',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Handelsetyper: {
          AttributeName: 'Handelsetyper',
          DisplayLabel: 'Händelsetyper',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Amnesomraden: {
          AttributeName: 'Amnesomraden',
          DisplayLabel: 'Ämnesområden',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DokFinns: {
          AttributeName: 'DokFinns',
          DisplayLabel: 'Dokument finns',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        XB_SENAST_EXPORTERAD: {
          AttributeName: 'XB_SENAST_EXPORTERAD',
          DisplayLabel: 'XBridge, senast exporterad',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateTime',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        AKT_MED_URNA: {
          AttributeName: 'AKT_MED_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['BegrGrav'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegrGravsPlats: {
          AttributeName: 'BegrGravsPlats',
          DisplayLabel: 'Gravsättningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Begravning'],
        },
        XB_UNIQUE_THREAD_VALUE: {
          AttributeName: 'XB_UNIQUE_THREAD_VALUE',
          DisplayLabel: 'Trådhantering xbridge',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SKK_UNIQUE_THREAD_VALUE: {
          AttributeName: 'SKK_UNIQUE_THREAD_VALUE',
          DisplayLabel: 'Trådhantering skk',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Publicering',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        Pos7: {
          AttributeName: 'Pos7',
          DisplayLabel: 'Pos7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos8: {
          AttributeName: 'Pos8',
          DisplayLabel: 'Pos8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos9: {
          AttributeName: 'Pos9',
          DisplayLabel: 'Pos9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Pos10: {
          AttributeName: 'Pos10',
          DisplayLabel: 'Pos10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ASKGRAVLUND: {
          AttributeName: 'ASKGRAVLUND',
          DisplayLabel: 'Askgravlund',
          Hint: 'Askgravlund/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'TrueText="Askgravlund"',
          FormatterDisplayParams: 'TrueText="Askgravlund"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        Begravningsclearing: {
          AttributeName: 'Begravningsclearing',
          DisplayLabel: 'Begravningsclearing, ej fakturerad',
          Hint: '(visar ej aktiviteter framåt i tiden) - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Begravning'],
        },
        StatligClearing: {
          AttributeName: 'StatligClearing',
          DisplayLabel: 'Statlig clearing, ej fakturerad',
          Hint: '(visar ej aktiviteter framåt - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          ValidInComps: ['BegrGrav'],
        },
        InternfaktBegr: {
          AttributeName: 'InternfaktBegr',
          DisplayLabel: 'Internfakturering, begravning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Begravning'],
          AttributeGroup: 'Internfakturering',
        },
        InternDopclearing: {
          AttributeName: 'InternDopclearing',
          DisplayLabel: 'Interfakturering, dop',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Dop'],
          AttributeGroup: 'Internfakturering',
        },
        InternClearingVigsel: {
          AttributeName: 'InternClearingVigsel',
          DisplayLabel: 'Internfakturering, vigsel',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['Vigsel'],
          AttributeGroup: 'Internfakturering',
        },
        DagensNamn: {
          AttributeName: 'DagensNamn',
          DisplayLabel: 'Dagens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DagensTema: {
          AttributeName: 'DagensTema',
          DisplayLabel: 'Dagens tema',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DagensFarg: {
          AttributeName: 'DagensFarg',
          DisplayLabel: 'Dagens liturgiska färg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AktivitetCaption: {
          AttributeName: 'AktivitetCaption',
          DisplayLabel: 'Aktivitetsrubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRBYRA_NARVARAR: {
          AttributeName: 'BEGRBYRA_NARVARAR',
          DisplayLabel: 'Begravningsbyrån närvarar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BegrGrav'],
        },
        INTYG_GRAVS: {
          AttributeName: 'INTYG_GRAVS',
          DisplayLabel: 'Intyg gravsättning',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BegrGrav'],
        },
        INTYG_KREM: {
          AttributeName: 'INTYG_KREM',
          DisplayLabel: 'Intyg kremering',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BegrGrav'],
        },
        INTYG_ML: {
          AttributeName: 'INTYG_ML',
          DisplayLabel: 'Medgivande ML/AL',
          Hint: 'Medgivande Minneslund/Askgravlund',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BegrGrav'],
        },
        INTYG_GRAVOPPNING: {
          AttributeName: 'INTYG_GRAVOPPNING',
          DisplayLabel: 'Medgivande gravöppning',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BegrGrav'],
        },
        OLD_BESTALLNINGS_ID: {
          AttributeName: 'OLD_BESTALLNINGS_ID',
          DisplayLabel: 'Borttagen BeställningsID',
          Hint: 'ID till beställning som tagits bort eller nekats.',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL_DOP: {
          AttributeName: 'ANTAL_DOP',
          DisplayLabel: 'Antal dop',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Gudstjanst'],
        },
        ANTAL_VIGSLAR: {
          AttributeName: 'ANTAL_VIGSLAR',
          DisplayLabel: 'Antal vigslar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['Gudstjanst'],
        },
        AntalBestalldaAkt: {
          AttributeName: 'AntalBestalldaAkt',
          DisplayLabel: 'Antal beställda aktiviteter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalMottagnaAkt: {
          AttributeName: 'AntalMottagnaAkt',
          DisplayLabel: 'Antal mottagna aktiviteter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalRefuseradeAkt: {
          AttributeName: 'AntalRefuseradeAkt',
          DisplayLabel: 'Antal refuserade aktiviteter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        bestPersNamn: {
          AttributeName: 'bestPersNamn',
          DisplayLabel: 'Huvudpersonens namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL_LEDIGA_DOP: {
          AttributeName: 'ANTAL_LEDIGA_DOP',
          DisplayLabel: 'Antal lediga dop',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        ANTAL_LEDIGA_VIGSLAR: {
          AttributeName: 'ANTAL_LEDIGA_VIGSLAR',
          DisplayLabel: 'Antal lediga vigslar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="100"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        StatistikSenastUppdaterad: {
          AttributeName: 'StatistikSenastUppdaterad',
          DisplayLabel: 'Statistik, senast uppdaterad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        AVLIDEN_REF_ID: {
          AttributeName: 'AVLIDEN_REF_ID',
          DisplayLabel: 'Avliden GUID',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL_BARN: {
          AttributeName: 'ANTAL_BARN',
          DisplayLabel: 'Antal barn 0-15 år',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Statistik',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'Grupp ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FranvaroFlex: {
          AttributeName: 'FranvaroFlex',
          DisplayLabel: 'Frånvaro i Flex',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        FAKTURERAS: {
          AttributeName: 'FAKTURERAS',
          DisplayLabel: 'Ska Faktureras',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['AktOvrLok'],
        },
        StatRapSenast: {
          AttributeName: 'StatRapSenast',
          DisplayLabel: 'Sista dagen för att rapportera statistik',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
          ValidInComps: ['KyrkAkt', 'AktOvrLok'],
          AttributeGroup: 'Statistik',
        },
        ANTAL_TILLFALLEN: {
          AttributeName: 'ANTAL_TILLFALLEN',
          DisplayLabel: 'Antal tillfällen',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Statistik',
        },
        StatEjRap: {
          AttributeName: 'StatEjRap',
          DisplayLabel: 'Antal ej rapporterat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifFilter',
          AttributeGroup: 'Statistik',
        },
        StatRap: {
          AttributeName: 'StatRap',
          DisplayLabel: 'Antal rapporterat',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifFilter',
          AttributeGroup: 'Statistik',
        },
        DatumOchTid: {
          AttributeName: 'DatumOchTid',
          DisplayLabel: 'Datum och tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DigitalAktivitet: {
          AttributeName: 'DigitalAktivitet',
          DisplayLabel: 'Digital aktivitet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Statistik',
        },
        AldersindeladAktivitet: {
          AttributeName: 'AldersindeladAktivitet',
          DisplayLabel: 'Åldersindelad aktivitet',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Statistik',
        },
        TotalaBesokare: {
          AttributeName: 'TotalaBesokare',
          DisplayLabel: 'Antal besökare',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsFloat',
          FormatterValidateParams: 'MinValue="0"',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Statistik',
        },
        StatistikStatus: {
          AttributeName: 'StatistikStatus',
          DisplayLabel: 'Statistik status',
          Hint: 'Ska rapporteras/Det är mindre än 7 dagar kvar att rapportera statistik på aktiviteten/Statistik rapporterad/Statistik exporterad/Misslyckad export, kontrollera bokningen/Sista rapporteringsdag har passerat',
          DataType: 'Enum',
          EnumValues: new Map([['SKA_RAPPORTERAS', 'Ska rapporteras'], ['DET_AR_MINDRE_AN_7_DAGAR_KVAR_ATT_RAPPORTERA_STATISTIK_PA_AKTIVITETEN', 'Det är mindre än 7 dagar kvar att rapportera statistik på aktiviteten'], ['STATISTIK_RAPPORTERAD', 'Statistik rapporterad'], ['STATISTIK_EXPORTERAD', 'Statistik exporterad'], ['MISSLYCKAD_EXPORT__KONTROLLERA_BOKNINGEN', 'Misslyckad export, kontrollera bokningen'], ['SISTA_RAPPORTERINGSDAG_HAR_PASSERAT', 'Sista rapporteringsdag har passerat']]),
          EnumSortValues: new Map([['SKA_RAPPORTERAS', 'A'], ['DET_AR_MINDRE_AN_7_DAGAR_KVAR_ATT_RAPPORTERA_STATISTIK_PA_AKTIVITETEN', 'B'], ['STATISTIK_RAPPORTERAD', 'C'], ['STATISTIK_EXPORTERAD', 'D'], ['MISSLYCKAD_EXPORT__KONTROLLERA_BOKNINGEN', 'E'], ['SISTA_RAPPORTERINGSDAG_HAR_PASSERAT', 'F']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SKA_RAPPORTERAS=Ska rapporteras;DET_AR_MINDRE_AN_7_DAGAR_KVAR_ATT_RAPPORTERA_STATISTIK_PA_AKTIVITETEN=Det är mindre än 7 dagar kvar att rapportera statistik på aktiviteten;STATISTIK_RAPPORTERAD=Statistik rapporterad;STATISTIK_EXPORTERAD=Statistik exporterad;MISSLYCKAD_EXPORT__KONTROLLERA_BOKNINGEN=Misslyckad export, kontrollera bokningen;SISTA_RAPPORTERINGSDAG_HAR_PASSERAT=Sista rapporteringsdag har passerat"',
          InterfaceType: 'ifChecklist',
          AttributeGroup: 'Statistik',
        },
        AlderAntal: {
          AttributeName: 'AlderAntal',
          DisplayLabel: 'Totalt antal åldersindelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          AttributeGroup: 'Statistik',
        },
        LopandeStatistik: {
          AttributeName: 'LopandeStatistik',
          DisplayLabel: 'Löpande statistik',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['KyrkAkt', 'AktOvrigt'],
          AttributeGroup: 'Statistik',
        },
        ArsbaseradStatistik: {
          AttributeName: 'ArsbaseradStatistik',
          DisplayLabel: 'Årsbaserad statistik',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['AktOvrigt'],
          AttributeGroup: 'Statistik',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORSAMLINGS_ID: {
          AttributeName: 'FORSAMLINGS_ID',
          DisplayLabel: 'Församling, enhets-ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ForsamlingNamn: {
          AttributeName: 'ForsamlingNamn',
          DisplayLabel: 'Församling, namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        XBridgeSenastUppdaterad: {
          AttributeName: 'XBridgeSenastUppdaterad',
          DisplayLabel: 'XBridge, senast uppdaterad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        XBridgeFel: {
          AttributeName: 'XBridgeFel',
          DisplayLabel: 'XBridge, felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.hasvalue,
        },
        NOTERING_PUBL_GUDSTJANST: {
          AttributeName: 'NOTERING_PUBL_GUDSTJANST',
          DisplayLabel: 'Notering för publicerade gudstjänster',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['Gudstjanst'],
        },
        Bokningsbar: {
          AttributeName: 'Bokningsbar',
          DisplayLabel: 'Bokningsbar',
          Hint: 'Är den publicerade aktiviteten fortfarande bokningsbar - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        AntalRepeteradeAktiviteter: {
          AttributeName: 'AntalRepeteradeAktiviteter',
          DisplayLabel: 'Antal repeterade aktiviteter',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.notgreater],
          DefaultCondOperator: T.interval,
        },
        StatTyp: {
          AttributeName: 'StatTyp',
          DisplayLabel: 'Typ av statistik',
          Hint: 'Årsbaserad/Löpande',
          DataType: 'Enum',
          EnumValues: new Map([['ARSBASERAD', 'Årsbaserad'], ['LOPANDE', 'Löpande']]),
          EnumSortValues: new Map([['ARSBASERAD', 'Å'], ['LOPANDE', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ARSBASERAD=Årsbaserad;LOPANDE=Löpande"',
          ValidInComps: ['KyrkAkt', 'AktOvrigt'],
          AttributeGroup: 'Statistik',
        },
        BokadAv: {
          AttributeName: 'BokadAv',
          DisplayLabel: 'Bokad av (name)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        FranDatumTid: {
          AttributeName: 'FranDatumTid',
          DisplayLabel: 'Fråndatum och tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TillDatumTid: {
          AttributeName: 'TillDatumTid',
          DisplayLabel: 'Tilldatum och tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BegrByraKontaktEpost: {
          AttributeName: 'BegrByraKontaktEpost',
          DisplayLabel: 'Begr Byrå Kontakt Epost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegrByraKontaktTelefon2: {
          AttributeName: 'BegrByraKontaktTelefon2',
          DisplayLabel: 'Begr Byrå Kontakt Telefon2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegrByraKontaktTelefon1: {
          AttributeName: 'BegrByraKontaktTelefon1',
          DisplayLabel: 'Begr Byrå Kontakt Telefon1',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegrByraKontaktMobil: {
          AttributeName: 'BegrByraKontaktMobil',
          DisplayLabel: 'Begr Byrå Kontakt Mobil',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SEKRETESSMARKERAD: {
          AttributeName: 'SEKRETESSMARKERAD',
          DisplayLabel: 'Sekretessmarkerad av förvaltningen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="L=Tillfälligt spärrad"',
          GUIEditable: true,
          MaxInputLength: 1,
          AttributeGroup: 'Dolda uppgifter',
          Properties: new Map([['UsesMask', 'Y']]),
        },
        StatPsalm: {
          AttributeName: 'StatPsalm',
          DisplayLabel: 'Statistik psalmer',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Huvudakt: {
          AttributeName: 'Huvudakt',
          DisplayLabel: 'Huvudaktivitet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AktAkttyp: {
          AssociationName: 'AktAkttyp',
          DisplayLabel: 'Aktivitetstyp per aktivitet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetstyp',
          AssociatedComponentName: 'Aktivitetstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['READONLY_NA', 'Y']]),
        },
        Bestallare: {
          AssociationName: 'Bestallare',
          DisplayLabel: 'Beställare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON2,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.TELEFAX,Adress.SMTP1;'], ['OverrideDisplayLabels', 'G:*="Beställare",PREFIX:*="Beställare ";'], ['NOT_ATAGANDE', 'Y']]),
        },
        Bokningsgrupp: {
          AssociationName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokngrupp',
          AssociatedComponentName: 'Bokngrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Resurs1: {
          AssociationName: 'Resurs1',
          DisplayLabel: 'Rubrik 1',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs2: {
          AssociationName: 'Resurs2',
          DisplayLabel: 'Rubrik 2',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs3: {
          AssociationName: 'Resurs3',
          DisplayLabel: 'Rubrik 3',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs4: {
          AssociationName: 'Resurs4',
          DisplayLabel: 'Rubrik 4',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs5: {
          AssociationName: 'Resurs5',
          DisplayLabel: 'Rubrik 5',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs6: {
          AssociationName: 'Resurs6',
          DisplayLabel: 'Rubrik 6',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        PrelBestallare: {
          AssociationName: 'PrelBestallare',
          DisplayLabel: 'Preliminär beställare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anhorig: {
          AssociationName: 'Anhorig',
          DisplayLabel: 'Anhörig',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BegrGrav'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,LKFStatus,Forsamlingsbo,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Anhörig",PREFIX:*="Anhörig ";'], ['NOT_ATAGANDE', 'Y;'], ['SQLHint', 'READUNCOMMITTED,FORCESEEK;']]),
        },
        Begrbyra: {
          AssociationName: 'Begrbyra',
          DisplayLabel: 'Begravningsbyrå',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: ['BegrGrav'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON2,Adress.TELEFAX,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Organisationsnummer",OrgNrPersNr="Organisationsnummer",OP_Namn="Namn",G:*="Begravningsbyrå",PREFIX:*="Begravningsbyrå ";'], ['NOT_ATAGANDE', 'Y;'], ['SQLHint', 'READUNCOMMITTED,FORCESEEK;']]),
        },
        KyrkogardAnnanOrt: {
          AssociationName: 'KyrkogardAnnanOrt',
          DisplayLabel: 'Kyrkogård (annan ort)',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: ['BegrGrav'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'BO_RESURS_NAMN,BO_RESURS_ID;'], ['OverrideDisplayLabels', 'BO_RESURS_NAMN="Kyrkogård (annan ort)",BO_RESURS_ID="Kyrkogård Resurs-ID (annan ort)",G:*="Gravplats (annan ort)";']]),
        },
        Begravningstyp: {
          AssociationName: 'Begravningstyp',
          DisplayLabel: 'Begravningsordning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBegravningstyp',
          AssociatedComponentName: 'Begravningstyp',
          JoinAssociation: true,
          ValidInComps: ['BegrGrav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dopkandidat: {
          AssociationName: 'Dopkandidat',
          DisplayLabel: 'Dopkandidat',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Dop', 'AktOvrLok'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,KYRKOLKF,KYRKOLKF_BENAMNING,LKFStatus,Forsamlingsbo,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Dopkandidat",PREFIX:*="Dopkandidat ";'], ['NOT_ATAGANDE', 'Y;'], ['SQLHint', 'READUNCOMMITTED,FORCESEEK;']]),
        },
        Fader: {
          AssociationName: 'Fader',
          DisplayLabel: 'Vårdnadshavare 2',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Dop'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Vårdnadshavare 2 (dop)",PREFIX:*="Vårdnadshavare 2 ";'], ['NOT_ATAGANDE', 'Y;'], ['SQLHint', 'READUNCOMMITTED,FORCESEEK;']]),
        },
        Moder: {
          AssociationName: 'Moder',
          DisplayLabel: 'Vårdnadshavare 1',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Dop'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Vårdnadshavare 1 (dop)",PREFIX:*="Vårdnadshavare 1 ";'], ['NOT_ATAGANDE', 'Y;'], ['SQLHint', 'READUNCOMMITTED,FORCESEEK;']]),
        },
        Brudgum: {
          AssociationName: 'Brudgum',
          DisplayLabel: 'Person 2',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Vigsel', 'AktOvrLok'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,KYRKOLKF,KYRKOLKF_BENAMNING,LKFStatus,Forsamlingsbo,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Person 2 (vigsel)",PREFIX:*="Person 2 ";'], ['NOT_ATAGANDE', 'Y;'], ['SQLHint', 'READUNCOMMITTED,FORCESEEK;']]),
        },
        Brud: {
          AssociationName: 'Brud',
          DisplayLabel: 'Person 1',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Vigsel', 'AktOvrLok'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,KYRKOLKF,KYRKOLKF_BENAMNING,LKFStatus,Forsamlingsbo,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Person 1 (vigsel)",PREFIX:*="Person 1 ";'], ['NOT_ATAGANDE', 'Y;'], ['SQLHint', 'READUNCOMMITTED,FORCESEEK;']]),
        },
        GudstjanstTyp: {
          AssociationName: 'GudstjanstTyp',
          DisplayLabel: 'Gudstjänsttyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGudstjansttyp',
          AssociatedComponentName: 'Gudstjansttyp',
          JoinAssociation: true,
          ValidInComps: ['Gudstjanst'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Verksamhetstyp: {
          AssociationName: 'Verksamhetstyp',
          DisplayLabel: 'Verksamhetstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOVerksamhetstyper',
          AssociatedComponentName: 'Verksamhetstyper',
          JoinAssociation: true,
          ValidInComps: ['AktOvrLok'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Nyckelavhamtare: {
          AssociationName: 'Nyckelavhamtare',
          DisplayLabel: 'Nyckelavhämtare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['Lokaluthyrning'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON2,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.TELEFAX,Adress.SMTP1;'], ['OverrideDisplayLabels', 'G:*="Nyckelavhämtare",PREFIX:*="Nyckelavhämtare ";'], ['NOT_ATAGANDE', 'Y']]),
        },
        BoknBestallning: {
          AssociationName: 'BoknBestallning',
          DisplayLabel: 'Beställning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBoknBestallning',
          AssociatedComponentName: 'BoknBestallning',
          JoinAssociation: true,
          ValidInComps: ['BegrGrav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs7: {
          AssociationName: 'Resurs7',
          DisplayLabel: 'Rubrik 7',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs8: {
          AssociationName: 'Resurs8',
          DisplayLabel: 'Rubrik 8',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs9: {
          AssociationName: 'Resurs9',
          DisplayLabel: 'Rubrik 9',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs10: {
          AssociationName: 'Resurs10',
          DisplayLabel: 'Rubrik 10',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktAktTypBokngrupp: {
          AssociationName: 'AktAktTypBokngrupp',
          DisplayLabel: 'Aktivitetstyp per bokningsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOTEDBOAkttypBokngrupp',
          AssociatedComponentName: 'AktTypBoknGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['READONLY_NA', 'Y']]),
        },
        Kalenderinfo: {
          AssociationName: 'Kalenderinfo',
          DisplayLabel: 'Kalenderinfo',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitetkalenderinfo',
          AssociatedComponentName: 'Aktivitetkalenderinfo',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        OldBoknBestallning: {
          AssociationName: 'OldBoknBestallning',
          DisplayLabel: 'Gammal Bokningsbeställning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBoknBestallning',
          AssociatedComponentName: 'BoknBestallning',
          JoinAssociation: true,
          ValidInComps: ['BegrGrav'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avlidna: {
          AssociationName: 'Avlidna',
          DisplayLabel: 'Avlidna',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAvliden',
          AssociatedComponentName: 'Avliden',
          JoinAssociation: true,
          ValidInComps: ['BegrGrav', 'AktOvrLok'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['IntegratedFilter', 'OP_NR;'], ['OverrideDisplayLabels', 'Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.OP_Namn="Efternamn",Avlidna.Person.NamnME="Efternamn",G:Person="";']]),
        },
        OpGrupp: {
          AssociationName: 'OpGrupp',
          DisplayLabel: 'Grupp av personer',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGruppOP',
          AssociatedComponentName: 'GruppOP',
          JoinAssociation: true,
          ValidInComps: ['AktOvrigt'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        DigitalaVisningar: {
          AssociationName: 'DigitalaVisningar',
          DisplayLabel: 'Digitala visningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktDigitalaVisningar',
          AssociatedComponentName: 'AktDigitalaVisningar',
          JoinAssociation: true,
          ValidInComps: ['Aktivitet'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        SKK: {
          AssociationName: 'SKK',
          DisplayLabel: 'Nationella kalendern',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKK',
          AssociatedComponentName: 'SKK',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Forsamling: {
          AssociationName: 'Forsamling',
          DisplayLabel: 'Församling',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSStatistikinstallningar',
          AssociatedComponentName: 'Statistikinstallningar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SkickadStatistik: {
          AssociationName: 'SkickadStatistik',
          DisplayLabel: 'Skickad löpande statistik',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKS',
          AssociatedComponentName: 'SKS',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AktBokRubrik: {
          AssociationName: 'AktBokRubrik',
          DisplayLabel: 'Bokningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AktResrubrik: {
          AssociationName: 'AktResrubrik',
          DisplayLabel: 'Resursrubrik per aktivitet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitetResrubrik',
          AssociatedComponentName: 'AktivitetResrubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Faktomg: {
          AssociationName: 'Faktomg',
          DisplayLabel: 'Faktureringsomgång',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOFaktOmg',
          AssociatedComponentName: 'FaktOmg',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        KnutnaAktiviteter: {
          AssociationName: 'KnutnaAktiviteter',
          DisplayLabel: 'Knutna aktiviteter',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.AKTIVITETSGRUPP} = {FromAlias.AKTIVITETSGRUPP} and {Alias.AKTIVITETSGRUPP} <> 0 and {Alias.AKT_ID} <> {FromAlias.AKT_ID}']]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetDok',
          AssociatedComponentName: 'AktivitetDok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Aktivitetskategorier: {
          AssociationName: 'Aktivitetskategorier',
          DisplayLabel: 'Framsidan kategorier',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktKategori',
          AssociatedComponentName: 'AktKategori',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bevakning: {
          AssociationName: 'Bevakning',
          DisplayLabel: 'Bevakning',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBevakning',
          AssociatedComponentName: 'Bevakningsgrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Konfirmander: {
          AssociationName: 'Konfirmander',
          DisplayLabel: 'Konfirmander',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktDeltagar',
          AssociatedComponentName: 'AktDeltagare',
          JoinAssociation: false,
          ValidInComps: ['Konfirmation'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Deltagare: {
          AssociationName: 'Deltagare',
          DisplayLabel: 'Deltagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktDeltagar',
          AssociatedComponentName: 'AktDeltagare',
          JoinAssociation: false,
          ValidInComps: ['AktOvrigt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontakter: {
          AssociationName: 'Kontakter',
          DisplayLabel: 'Kursdeltagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktKontakt',
          AssociatedComponentName: 'AktKontakt',
          JoinAssociation: false,
          ValidInComps: ['AktOvrigt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AktAlderindelning: {
          AssociationName: 'AktAlderindelning',
          DisplayLabel: 'Aktivitetens åldersindelning',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktAlderindelning',
          AssociatedComponentName: 'AktAlderindelning',
          JoinAssociation: false,
          ValidInComps: ['AktOvrigt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Amnesomraden: {
          AssociationName: 'Amnesomraden',
          DisplayLabel: 'Ämnesområde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKKAktivitetAmnesomrade',
          AssociatedComponentName: 'SKKAktivitetAmnesomrade',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelsetyper: {
          AssociationName: 'Handelsetyper',
          DisplayLabel: 'Händelsetyper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitetHandelsetyp',
          AssociatedComponentName: 'AktivitetHandelsetyp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        BoknBestallningar: {
          AssociationName: 'BoknBestallningar',
          DisplayLabel: 'Beställningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBoknBestallning2',
          AssociatedComponentName: 'Best',
          JoinAssociation: false,
          ValidInComps: ['BegrGrav', 'Dop', 'Vigsel', 'Gudstjanst'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        XBridge: {
          AssociationName: 'XBridge',
          DisplayLabel: 'XBridge',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOXBridge',
          AssociatedComponentName: 'XBridge',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        RepeteradeAktiviteter: {
          AssociationName: 'RepeteradeAktiviteter',
          DisplayLabel: 'Repeterade aktiviteter',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['CustomExtended', '{Alias.REPAKTNR} = {FromAlias.REPAKTNR} and {Alias.REPAKTNR} is not null']]),
        },
        Utskick: {
          AssociationName: 'Utskick',
          DisplayLabel: 'Utskick',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktPsalmer: {
          AssociationName: 'AktPsalmer',
          DisplayLabel: 'Aktivitetens psalmer',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktPsalmer',
          AssociatedComponentName: 'AktPsalmer',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOSKK: {
      CollectionName: 'BOSKK',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SKK',
        Abstract: false,
        SOLabel: 'Aktivitet',
        SOGLabel: 'Aktivitets',
        SBLabel: 'Aktiviteten',
        SBGLabel: 'Aktivitetens',
        POLabel: 'Aktiviteter',
        POGLabel: 'Aktiviteters',
        PBLabel: 'Aktiviteterna',
        PBGLabel: 'Aktiviteternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Aktivitetens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Aktivitetens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Aktivitetens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Aktivitetens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_ID: {
          AttributeName: 'AKT_ID',
          DisplayLabel: 'Aktivitets-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKK_ID: {
          AttributeName: 'SKK_ID',
          DisplayLabel: 'Externt ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNINGSNUMMER: {
          AttributeName: 'BOKNINGSNUMMER',
          DisplayLabel: 'Bokningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENAST_SKICKAD: {
          AttributeName: 'SENAST_SKICKAD',
          DisplayLabel: 'Publicerad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SENAST_SKICKAD_FEL: {
          AttributeName: 'SENAST_SKICKAD_FEL',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOAktDeltagar: {
      CollectionName: 'BOAktDeltagar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '1030']]),
      RootType: {
        TypeValue: 'AktDeltagare',
        Abstract: false,
        SOLabel: 'Deltagare',
        SOGLabel: 'Deltagare',
        SBLabel: 'Deltagaren',
        SBGLabel: 'Deltagaren',
        POLabel: 'Deltagare',
        POGLabel: 'Deltagare',
        PBLabel: 'Deltagarna',
        PBGLabel: 'Deltagarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Deltagaren primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Deltagaren versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Deltagaren id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Deltagaren fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Organisation/Person id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANMALNINGSDATUM: {
          AttributeName: 'ANMALNINGSDATUM',
          DisplayLabel: 'Anmälningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ANMALNINGSTID: {
          AttributeName: 'ANMALNINGSTID',
          DisplayLabel: 'Anmälningstid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Ej fakturerad/Fakturerad',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_FAKTURERAD', 'Ej fakturerad'], ['FAKTURERAD', 'Fakturerad']]),
          EnumSortValues: new Map([['EJ_FAKTURERAD', 'E'], ['FAKTURERAD', 'F']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_FAKTURERAD=Ej fakturerad;FAKTURERAD=Fakturerad"',
        },
        PRISLISTA_ID: {
          AttributeName: 'PRISLISTA_ID',
          DisplayLabel: 'Prislista',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'Kund',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANMALAN_STATUS: {
          AttributeName: 'ANMALAN_STATUS',
          DisplayLabel: 'Anmälnings status',
          Hint: 'Preliminärt anmäld/Anmälan bekräftad/Avanmäld/Definitivt avanmäld/Anmälan avvisad',
          DataType: 'Enum',
          EnumValues: new Map([['PRELIMINART_ANMALD', 'Preliminärt anmäld'], ['ANMALAN_BEKRAFTAD', 'Anmälan bekräftad'], ['AVANMALD', 'Avanmäld'], ['DEFINITIVT_AVANMALD', 'Definitivt avanmäld'], ['ANMALAN_AVVISAD', 'Anmälan avvisad']]),
          EnumSortValues: new Map([['PRELIMINART_ANMALD', 'P'], ['ANMALAN_BEKRAFTAD', 'B'], ['AVANMALD', 'A'], ['DEFINITIVT_AVANMALD', 'D'], ['ANMALAN_AVVISAD', 'V']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PRELIMINART_ANMALD=Preliminärt anmäld;ANMALAN_BEKRAFTAD=Anmälan bekräftad;AVANMALD=Avanmäld;DEFINITIVT_AVANMALD=Definitivt avanmäld;ANMALAN_AVVISAD=Anmälan avvisad"',
          InterfaceType: 'ifChecklist',
        },
        Prislista: {
          AttributeName: 'Prislista',
          DisplayLabel: 'Prislista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Intern: {
          AttributeName: 'Intern',
          DisplayLabel: 'Intern',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bokningsnummer: {
          AttributeName: 'Bokningsnummer',
          DisplayLabel: 'Bokningsnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Titel: {
          AttributeName: 'Titel',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OPLBorttagen: {
          AttributeName: 'OPLBorttagen',
          DisplayLabel: 'OPLBorttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SortPersNamn: {
          AttributeName: 'SortPersNamn',
          DisplayLabel: 'SortPersNamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AktFranDatum: {
          AttributeName: 'AktFranDatum',
          DisplayLabel: 'Fråndatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        AktFranTid: {
          AttributeName: 'AktFranTid',
          DisplayLabel: 'Från kl',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
        },
        AktSenAmnDatum: {
          AttributeName: 'AktSenAmnDatum',
          DisplayLabel: 'Senaste anmälningsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        Clearing: {
          AttributeName: 'Clearing',
          DisplayLabel: 'Clearing',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FAKT_VARDNADSHAVARE: {
          AttributeName: 'FAKT_VARDNADSHAVARE',
          DisplayLabel: 'Fakturera Vårdnadshavare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        OP: {
          AssociationName: 'OP',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,LKFStatus,Forsamlingsbo,MEDLEMSKOD,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Adress";']]),
        },
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Prislista: {
          AssociationName: 'Prislista',
          DisplayLabel: 'Prislista',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAPrislista',
          AssociatedComponentName: 'Prislista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktOrder: {
          AssociationName: 'AktOrder',
          DisplayLabel: 'AktOrder',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetOrder',
          AssociatedComponentName: 'AktOrder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktivitetstyp: {
      CollectionName: 'BOAktivitetstyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '1001']]),
      RootType: {
        TypeValue: 'Aktivitetstyp',
        Abstract: false,
        SOLabel: 'Aktivitetstyp',
        SOGLabel: 'Aktivitetstyp',
        SBLabel: 'Aktvitetstypen',
        SBGLabel: 'Aktvitetstypen',
        POLabel: 'Aktivitetstyper',
        POGLabel: 'Aktivitetstyper',
        PBLabel: 'Aktivitetstyperna',
        PBGLabel: 'Aktivitetstyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Aktvitetstypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Aktvitetstypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Aktvitetstypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Aktvitetstypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORK: {
          AttributeName: 'FORK',
          DisplayLabel: 'Aktivitetstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Aktivitetstypens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        SORTERINGSORDNING: {
          AttributeName: 'SORTERINGSORDNING',
          DisplayLabel: 'Sorteringsordning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SERIE_ID: {
          AttributeName: 'SERIE_ID',
          DisplayLabel: 'Bokningsnummerserie',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOBESTBEKR: {
          AttributeName: 'DOBESTBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till beställare på dopet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIBESTBEKR: {
          AttributeName: 'VIBESTBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till beställare på vigsel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRBESTBEKR: {
          AttributeName: 'GRBESTBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till beställaren på gravsättningen',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEBESTBEKR: {
          AttributeName: 'BEBESTBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till beställaren på begravningen',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OVBESTBEKR: {
          AttributeName: 'OVBESTBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till beställaren på en övrig aktivitet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANBEKRBE: {
          AttributeName: 'ANBEKRBE',
          DisplayLabel: 'Antal bokningsbekräftelser till anhörig på en begravning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANBEKRGR: {
          AttributeName: 'ANBEKRGR',
          DisplayLabel: 'Antal bokningsbekräftelser till anhörig på en gravsättning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MODERBEKR: {
          AttributeName: 'MODERBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till moder',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FADERBEKR: {
          AttributeName: 'FADERBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till fader',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BRUDBEKR: {
          AttributeName: 'BRUDBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till bruden',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BRUDGUMBEKR: {
          AttributeName: 'BRUDGUMBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser till brudgum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRBYRABEKRGR: {
          AttributeName: 'BEGRBYRABEKRGR',
          DisplayLabel: 'Antal bokningsbekräftelser till begravningsbyrån på en gravsättning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRBYRABEKRBG: {
          AttributeName: 'BEGRBYRABEKRBG',
          DisplayLabel: 'Antal bokningsbekräftelser till begravningsbyrån på en begravning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOINTERNBEKR: {
          AttributeName: 'DOINTERNBEKR',
          DisplayLabel: 'Antal dopbokningsbekräftelser för internt bruk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VIINTERNBEKR: {
          AttributeName: 'VIINTERNBEKR',
          DisplayLabel: 'Antal vigselbokningsbekräftelser för internt bruk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRINTERNBEKR: {
          AttributeName: 'GRINTERNBEKR',
          DisplayLabel: 'Antal gravsättningsbokningsbekräftelser för internt bruk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEINTERNBEKR: {
          AttributeName: 'BEINTERNBEKR',
          DisplayLabel: 'Antal begravningsbokningsbekräftelser för internt bruk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GUINTERNBEKR: {
          AttributeName: 'GUINTERNBEKR',
          DisplayLabel: 'Antal gudstjänstbokningsbekräftelser för internt bruk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SNINTERNBEKR: {
          AttributeName: 'SNINTERNBEKR',
          DisplayLabel: 'Antal snabbokningsbekräftelser för internt bruk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OVINTERNBEKR: {
          AttributeName: 'OVINTERNBEKR',
          DisplayLabel: 'Antal övriga bokningsbekräftelser för internt bruk',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKBEKRNOTERINGAR: {
          AttributeName: 'BOKBEKRNOTERINGAR',
          DisplayLabel: 'Noteringar på bokningsbekräftelsen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        SKRIVAUTPANYTT: {
          AttributeName: 'SKRIVAUTPANYTT',
          DisplayLabel: 'Sätta om utskriftsstatus',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          InterfaceType: 'ifBoolean',
        },
        ANTALBLANKRADEROVR: {
          AttributeName: 'ANTALBLANKRADEROVR',
          DisplayLabel: 'Antal blankrader (Övriga aktiviteter)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PAMINNELSETID: {
          AttributeName: 'PAMINNELSETID',
          DisplayLabel: 'Påminnelsetid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="t=60;m=1";DefaultGroup="m";GroupTexts="t=t;tim=t;timmar=t;m=m;min=m;minut=m;minuter=m"',
          FormatterDisplayParams: 'Groups="timmar/timme=60;minuter/minut=1";GroupNameSep=" "',
        },
        STORSTIL_TITEL: {
          AttributeName: 'STORSTIL_TITEL',
          DisplayLabel: 'Stora tecken på titelraden',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
        },
        AN_NARVARANDE: {
          AttributeName: 'AN_NARVARANDE',
          DisplayLabel: 'Anhöriga närvarande (gravsättning)',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          InterfaceType: 'ifBoolean',
        },
        BOKNINGSBEKRAFTELSETEXT: {
          AttributeName: 'BOKNINGSBEKRAFTELSETEXT',
          DisplayLabel: 'Bokningsbekräftelserubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEVAKNING_DATUM: {
          AttributeName: 'BEVAKNING_DATUM',
          DisplayLabel: 'Bevakningsdatum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BEGRAVNINGSTYP_ID: {
          AttributeName: 'BEGRAVNINGSTYP_ID',
          DisplayLabel: 'Begravningstyp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELT_ANMALAN_TEXT: {
          AttributeName: 'DELT_ANMALAN_TEXT',
          DisplayLabel: 'Anmälan',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELT_BEKRAFTAD_TEXT: {
          AttributeName: 'DELT_BEKRAFTAD_TEXT',
          DisplayLabel: 'Bekräftad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DELT_AVVISAD_TEXT: {
          AttributeName: 'DELT_AVVISAD_TEXT',
          DisplayLabel: 'Avvisad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARNA_JORD_KREM: {
          AttributeName: 'VARNA_JORD_KREM',
          DisplayLabel: 'Varna jordbegravning/kremering',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        MEDLEMSKOD: {
          AttributeName: 'MEDLEMSKOD',
          DisplayLabel: 'Medlemskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PUBLICERINGSDAGAR: {
          AttributeName: 'PUBLICERINGSDAGAR',
          DisplayLabel: 'Publiceringsdagar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEKRAFTELSE_TIMMAR: {
          AttributeName: 'BEKRAFTELSE_TIMMAR',
          DisplayLabel: 'Bekräftelse, antal timmar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: '"MinValue=0";"MaxValue=24"',
        },
        TABORT_WEBPUBL: {
          AttributeName: 'TABORT_WEBPUBL',
          DisplayLabel: 'Ta bort webpublicerade aktiviteter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        IGNORERA_ANTAL_BEKR: {
          AttributeName: 'IGNORERA_ANTAL_BEKR',
          DisplayLabel: 'Ignorera antal bekräftelser',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TID_BESTALLNINGAR: {
          AttributeName: 'TID_BESTALLNINGAR',
          DisplayLabel: 'Hämta beställningar (min)',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="10";MaxValue="1400"',
        },
        StockholmKompaktAdress: {
          AttributeName: 'StockholmKompaktAdress',
          DisplayLabel: 'Stockholms adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Stockholmtelefon: {
          AttributeName: 'Stockholmtelefon',
          DisplayLabel: 'Stockholm telefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StockholmTelefon2: {
          AttributeName: 'StockholmTelefon2',
          DisplayLabel: 'Stockholm telefon 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StockholmEpost: {
          AttributeName: 'StockholmEpost',
          DisplayLabel: 'Stockholm e-post',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StockholmFax: {
          AttributeName: 'StockholmFax',
          DisplayLabel: 'Stockholm fax',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TranasKompaktAdress: {
          AttributeName: 'TranasKompaktAdress',
          DisplayLabel: 'Tranås adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TranasTelefon: {
          AttributeName: 'TranasTelefon',
          DisplayLabel: 'Tranås telefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TranasTelefon2: {
          AttributeName: 'TranasTelefon2',
          DisplayLabel: 'Tranås telefon2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TranasFax: {
          AttributeName: 'TranasFax',
          DisplayLabel: 'Tranås fax',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TranasEpost: {
          AttributeName: 'TranasEpost',
          DisplayLabel: 'Tranås e-post',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGRBYRA_NARVARAR: {
          AttributeName: 'BEGRBYRA_NARVARAR',
          DisplayLabel: 'Begravningsbyrån närvarar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        KOPIERA_NOTERING2: {
          AttributeName: 'KOPIERA_NOTERING2',
          DisplayLabel: 'Kopiera Intern Notering',
          Hint: 'När aktiviteten knyts, kopiera den Interna Noteringen från ursprungsbokningen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        KOPIERA_BESKRIVNING: {
          AttributeName: 'KOPIERA_BESKRIVNING',
          DisplayLabel: 'Kopiera Exten Notering',
          Hint: 'När aktiviteten knyts, kopiera den Externa Noteringen från ursprungsbokningen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        AktivitetsFarg: {
          AttributeName: 'AktivitetsFarg',
          DisplayLabel: 'Aktivitets färg',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BO_GDPR_CLEARING: {
          AttributeName: 'BO_GDPR_CLEARING',
          DisplayLabel: 'Månader att spara underlag för clearing',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="å=12;m=1";DefaultGroup="m";GroupTexts="å=å;år=å;m=m;mån=m;månad=m;månader=m"',
          FormatterDisplayParams: 'Groups="år=12;månader/månad=1";GroupNameSep=" "',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BO_GDPR_OVRIGT: {
          AttributeName: 'BO_GDPR_OVRIGT',
          DisplayLabel: 'Månader att spara underlag övrigt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="å=12;m=1";DefaultGroup="m";GroupTexts="å=å;år=å;m=m;mån=m;månad=m;månader=m"',
          FormatterDisplayParams: 'Groups="år=12;månader/månad=1";GroupNameSep=" "',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TURNOFF_PHONE: {
          AttributeName: 'TURNOFF_PHONE',
          DisplayLabel: 'Stäng av telefonen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        VISA_SLUTTID: {
          AttributeName: 'VISA_SLUTTID',
          DisplayLabel: 'Visa sluttid',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AkttypNrSerie: {
          AssociationName: 'AkttypNrSerie',
          DisplayLabel: 'Bokningsnummerserie',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSNummerserie',
          AssociatedComponentName: 'StandigNummerserie',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktTypBoknGrupp: {
          AssociationName: 'AktTypBoknGrupp',
          DisplayLabel: 'AktTypBoknGrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOTEDBOAkttypBokngrupp',
          AssociatedComponentName: 'AktTypBoknGrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravningstyp: {
          AssociationName: 'Begravningstyp',
          DisplayLabel: 'Begravningstyp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBegravningstyp',
          AssociatedComponentName: 'Begravningstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AkttypAkt: {
          AssociationName: 'AkttypAkt',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktTypResrubrik: {
          AssociationName: 'AktTypResrubrik',
          DisplayLabel: 'Resursrubrik per aktivitetstyp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktTypResrubrik',
          AssociatedComponentName: 'AktTypResrubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Resursplanering: {
          AssociationName: 'Resursplanering',
          DisplayLabel: 'Resursplanering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResursPlanering',
          AssociatedComponentName: 'ResursPlanering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOTEDBOAkttypBokngrupp: {
      CollectionName: 'BOTEDBOAkttypBokngrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktTypBoknGrupp',
        Abstract: false,
        SOLabel: 'Aktivitetstyp (bokningsgrupp)',
        SOGLabel: 'Aktivitetstyp (bokningsgrupp)',
        SBLabel: 'Aktivitetstypen (bokningsgrupp)',
        SBGLabel: 'Aktivitetstypen (bokningsgrupp)',
        POLabel: 'Aktivitetstyper (bokningsgrupp)',
        POGLabel: 'Aktivitetstyper (bokningsgrupp)',
        PBLabel: 'Aktivitetstyperna (bokningsgrupp)',
        PBGLabel: 'Aktivitetstyperna (bokningsgrupp)',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Aktivitetstypen (bokningsgrupp) primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Aktivitetstypen (bokningsgrupp) versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Aktivitetstypen (bokningsgrupp) id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Aktivitetstypen (bokningsgrupp) fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KYRKLIGHELGUTSKRIFT: {
          AttributeName: 'KYRKLIGHELGUTSKRIFT',
          DisplayLabel: 'Kyrkliga helgdagar på bokningsbekräftelsen',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        SLUTTID: {
          AttributeName: 'SLUTTID',
          DisplayLabel: 'Sluttid',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur på bokningsbekräftelse',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          InterfaceType: 'ifBoolean',
        },
        STATISTIKUPPGIFT: {
          AttributeName: 'STATISTIKUPPGIFT',
          DisplayLabel: 'Statistikuppgift',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          InterfaceType: 'ifBoolean',
        },
        AVBOKNINGSBEKRAFTELSE: {
          AttributeName: 'AVBOKNINGSBEKRAFTELSE',
          DisplayLabel: 'Avbokningsbekräftelse',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          Required: true,
        },
        AKTTYP_BOKNBAR: {
          AttributeName: 'AKTTYP_BOKNBAR',
          DisplayLabel: 'Bokningsbar på Webben',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifBoolean',
        },
        BEVAKNINGSDAGAR: {
          AttributeName: 'BEVAKNINGSDAGAR',
          DisplayLabel: 'Bevakningsdagar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VARNA_JORD_KREM: {
          AttributeName: 'VARNA_JORD_KREM',
          DisplayLabel: 'Varna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Akttyp: {
          AssociationName: 'Akttyp',
          DisplayLabel: 'Aktivitetstyp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetstyp',
          AssociatedComponentName: 'Aktivitetstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bokningsgrupp: {
          AssociationName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokngrupp',
          AssociatedComponentName: 'Bokngrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOArbetspass: {
      CollectionName: 'BOArbetspass',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'Arbetspass',
        Abstract: false,
        SOLabel: 'Arbetspass',
        SOGLabel: 'Arbetspass',
        SBLabel: 'Arbetspasset',
        SBGLabel: 'Arbetspasset',
        POLabel: 'Arbetspass',
        POGLabel: 'Arbetspass',
        PBLabel: 'Arbetspassen',
        PBGLabel: 'Arbetspassen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetspasset primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetspasset versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetspasset id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetspasset fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTAR: {
          AttributeName: 'STARTAR',
          DisplayLabel: 'Startår',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTVECKA: {
          AttributeName: 'STARTVECKA',
          DisplayLabel: 'Startvecka',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTALVECKOR: {
          AttributeName: 'ANTALVECKOR',
          DisplayLabel: 'Antal veckor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSPASS1: {
          AttributeName: 'ARBETSPASS1',
          DisplayLabel: 'ARBETSPASS1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSPASS2: {
          AttributeName: 'ARBETSPASS2',
          DisplayLabel: 'ARBETSPASS2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSPASS3: {
          AttributeName: 'ARBETSPASS3',
          DisplayLabel: 'ARBETSPASS3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSPASS4: {
          AttributeName: 'ARBETSPASS4',
          DisplayLabel: 'ARBETSPASS4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        ArbetspassRes: {
          AssociationName: 'ArbetspassRes',
          DisplayLabel: 'ArbetspassRes',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOArbetstid: {
      CollectionName: 'BOArbetstid',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'Arbetstid',
        Abstract: false,
        SOLabel: 'Arbetstid',
        SOGLabel: 'Arbetstid',
        SBLabel: 'Arbetstiden',
        SBGLabel: 'Arbetstiden',
        POLabel: 'Arbetstider',
        POGLabel: 'Arbetstider',
        PBLabel: 'Arbetstiderna',
        PBGLabel: 'Arbetstiderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Arbetstiden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Arbetstiden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Arbetstiden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Arbetstiden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTAR: {
          AttributeName: 'STARTAR',
          DisplayLabel: 'Startår',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STARTVECKA: {
          AttributeName: 'STARTVECKA',
          DisplayLabel: 'Startvecka',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTALVECKOR: {
          AttributeName: 'ANTALVECKOR',
          DisplayLabel: 'Antal veckor',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTID1: {
          AttributeName: 'ARBETSTID1',
          DisplayLabel: 'ARBETSTID1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTID2: {
          AttributeName: 'ARBETSTID2',
          DisplayLabel: 'ARBETSTID2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTID3: {
          AttributeName: 'ARBETSTID3',
          DisplayLabel: 'ARBETSTID3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTID4: {
          AttributeName: 'ARBETSTID4',
          DisplayLabel: 'ARBETSTID4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        ArbetstidRes: {
          AssociationName: 'ArbetstidRes',
          DisplayLabel: 'ArbetstidRes',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBegravningstyp: {
      CollectionName: 'BOBegravningstyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Begravningstyp',
        Abstract: false,
        SOLabel: 'Begravningsordning',
        SOGLabel: 'Begravningsordning',
        SBLabel: 'Begravningsordningen',
        SBGLabel: 'Begravningsordningen',
        POLabel: 'Begravningsordningar',
        POGLabel: 'Begravningsordningar',
        PBLabel: 'Begravningsordningarna',
        PBGLabel: 'Begravningsordningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Begravningsordningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Begravningsordningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Begravningsordningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Begravningsordningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        CLEARINGSTYP: {
          AttributeName: 'CLEARINGSTYP',
          DisplayLabel: 'Typ av clearing',
          Hint: 'Begravningsclearing/Ej clearing',
          DataType: 'Enum',
          EnumValues: new Map([['BEGRAVNINGSCLEARING', 'Begravningsclearing'], ['EJ_CLEARING', 'Ej clearing']]),
          EnumSortValues: new Map([['BEGRAVNINGSCLEARING', 'B'], ['EJ_CLEARING', 'S']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEGRAVNINGSCLEARING=Begravningsclearing;EJ_CLEARING=Ej clearing"',
          GUIEditable: true,
          Required: true,
        },
        Kod_Benamning: {
          AttributeName: 'Kod_Benamning',
          DisplayLabel: 'Begravningsordning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOBoknBestDok: {
      CollectionName: 'BOBoknBestDok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BoknBestDok',
        Abstract: false,
        SOLabel: 'BestDok',
        SOGLabel: 'BestDok',
        SBLabel: 'BestDok',
        SBGLabel: 'BestDok',
        POLabel: 'BestDok',
        POGLabel: 'BestDok',
        PBLabel: 'BestDok',
        PBGLabel: 'BestDok',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BestDok primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BestDok versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BestDok fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ApplicationIdentifier: {
          AttributeName: 'ApplicationIdentifier',
          DisplayLabel: 'Applikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FileIdentifier: {
          AttributeName: 'FileIdentifier',
          DisplayLabel: 'Filidentifikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOBoknBestallning: {
      CollectionName: 'BOBoknBestallning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BoknBestallning',
        Abstract: false,
        SOLabel: 'Beställning',
        SOGLabel: 'Beställning',
        SBLabel: 'Beställningen',
        SBGLabel: 'Beställningen',
        POLabel: 'Beställningar',
        POGLabel: 'Beställningar',
        PBLabel: 'Beställningarna',
        PBGLabel: 'Beställningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Beställningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Beställningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Beställningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användar id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_LOPNR: {
          AttributeName: 'KONTAKT_LOPNR',
          DisplayLabel: 'Kontakt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVPLATS: {
          AttributeName: 'GRAVPLATS',
          DisplayLabel: 'Gravplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        KGARD_ID: {
          AttributeName: 'KGARD_ID',
          DisplayLabel: 'Kyrkogård id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter löpnr.',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVDELNING_ID: {
          AttributeName: 'AVDELNING_ID',
          DisplayLabel: 'Avdelning id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVNUMMER: {
          AttributeName: 'GRAVNUMMER',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
        },
        AVLIDEN_ID: {
          AttributeName: 'AVLIDEN_ID',
          DisplayLabel: 'Avliden id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANHORIG_ID: {
          AttributeName: 'ANHORIG_ID',
          DisplayLabel: 'Anhörig id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'Format="y-m|-d/y|mm|dd"',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BEGRAVNINGSTYP_ID: {
          AttributeName: 'BEGRAVNINGSTYP_ID',
          DisplayLabel: 'Begravningstyp id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVSATTNINGS_TYP: {
          AttributeName: 'GRAVSATTNINGS_TYP',
          DisplayLabel: 'Gravsättningstyp',
          Hint: 'Jordbegravning/Kremering/Urnsättning/Minneslund/Askgravlund/Askgravplats/Ej bestämd/Ej gravplats',
          DataType: 'Enum',
          EnumValues: new Map([['JORDBEGRAVNING', 'Jordbegravning'], ['KREMERING', 'Kremering'], ['URNSATTNING', 'Urnsättning'], ['MINNESLUND', 'Minneslund'], ['ASKGRAVLUND', 'Askgravlund'], ['ASKGRAVPLATS', 'Askgravplats'], ['EJ_BESTAMD', 'Ej bestämd'], ['EJ_GRAVPLATS', 'Ej gravplats']]),
          EnumSortValues: new Map([['JORDBEGRAVNING', 'J'], ['KREMERING', 'K'], ['URNSATTNING', 'U'], ['MINNESLUND', 'M'], ['ASKGRAVLUND', 'L'], ['ASKGRAVPLATS', 'P'], ['EJ_BESTAMD', 'E'], ['EJ_GRAVPLATS', 'G']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JORDBEGRAVNING=Jordbegravning;KREMERING=Kremering;URNSATTNING=Urnsättning;MINNESLUND=Minneslund;ASKGRAVLUND=Askgravlund;ASKGRAVPLATS=Askgravplats;EJ_BESTAMD=Ej bestämd;EJ_GRAVPLATS=Ej gravplats"',
          GUIEditable: true,
        },
        BEGRBYRA_ID: {
          AttributeName: 'BEGRBYRA_ID',
          DisplayLabel: 'Begravningsbyrå id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLARE_ID: {
          AttributeName: 'BESTALLARE_ID',
          DisplayLabel: 'Bestallare id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RELATION: {
          AttributeName: 'RELATION',
          DisplayLabel: 'Relation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
        },
        AKT_NR: {
          AttributeName: 'AKT_NR',
          DisplayLabel: 'Aktnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains],
          DefaultCondOperator: T.contains,
        },
        BEST_DATUM: {
          AttributeName: 'BEST_DATUM',
          DisplayLabel: 'Beställningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        BEST_TID: {
          AttributeName: 'BEST_TID',
          DisplayLabel: 'Beställningstid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        MOTTAGARE_ID: {
          AttributeName: 'MOTTAGARE_ID',
          DisplayLabel: 'MottagareID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        calcKyrkogard: {
          AttributeName: 'calcKyrkogard',
          DisplayLabel: 'Kyrkogård',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        calcKvarter: {
          AttributeName: 'calcKvarter',
          DisplayLabel: 'Kvarter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        calcAvdelning: {
          AttributeName: 'calcAvdelning',
          DisplayLabel: 'Avdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sqlKontaktNamn: {
          AttributeName: 'sqlKontaktNamn',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BegrByraNamn: {
          AttributeName: 'BegrByraNamn',
          DisplayLabel: 'Begravningsbyrå',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Mottagare: {
          AttributeName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        sqlKontaktEpost: {
          AttributeName: 'sqlKontaktEpost',
          DisplayLabel: 'sqlKontaktEpost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_MED_URNA: {
          AttributeName: 'AKT_MED_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        INTYG_GRAVS: {
          AttributeName: 'INTYG_GRAVS',
          DisplayLabel: 'Intyg gravsättning',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        INTYG_ML: {
          AttributeName: 'INTYG_ML',
          DisplayLabel: 'Medgivande ML/AL',
          Hint: 'Medgivande Minneslund/Askgravlund',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BEGRBYRA_NARVARAR: {
          AttributeName: 'BEGRBYRA_NARVARAR',
          DisplayLabel: 'Begravningsbyrån närvarar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KREM_ID: {
          AttributeName: 'KREM_ID',
          DisplayLabel: 'Krematorium',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KREM_ANNAT: {
          AttributeName: 'KREM_ANNAT',
          DisplayLabel: 'Annat krematorium',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREM_URNMATERIAL: {
          AttributeName: 'KREM_URNMATERIAL',
          DisplayLabel: 'Urnmaterial',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KREM_ANH_DELTAR: {
          AttributeName: 'KREM_ANH_DELTAR',
          DisplayLabel: 'Anhörig deltar vid kremering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        TVIST: {
          AttributeName: 'TVIST',
          DisplayLabel: 'Tvist föreligger',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KremBenamning: {
          AttributeName: 'KremBenamning',
          DisplayLabel: 'Krematorium',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        KontaktBegrByraTel1: {
          AttributeName: 'KontaktBegrByraTel1',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTelNr',
        },
        sqlKontaktTelefon: {
          AttributeName: 'sqlKontaktTelefon',
          DisplayLabel: 'sqlKontaktTelefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTelNr',
        },
        KontaktBegrByraEpost: {
          AttributeName: 'KontaktBegrByraEpost',
          DisplayLabel: 'Epost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        INTYG_GRAVOPPNING: {
          AttributeName: 'INTYG_GRAVOPPNING',
          DisplayLabel: 'Medgivande gravöppning',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BestOrgNr: {
          AttributeName: 'BestOrgNr',
          DisplayLabel: 'Orgnr.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        BestOrgNamn: {
          AttributeName: 'BestOrgNamn',
          DisplayLabel: 'Beställare',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        sqlBestKontaktEpost: {
          AttributeName: 'sqlBestKontaktEpost',
          DisplayLabel: 'Beställare epost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        sqlBestKontaktNamn: {
          AttributeName: 'sqlBestKontaktNamn',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Avliden: {
          AssociationName: 'Avliden',
          DisplayLabel: 'Avliden',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Anhorig: {
          AssociationName: 'Anhorig',
          DisplayLabel: 'Anhörig',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Begravningstyp: {
          AssociationName: 'Begravningstyp',
          DisplayLabel: 'Begravningstyp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBegravningstyp',
          AssociatedComponentName: 'Begravningstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kyrkogard: {
          AssociationName: 'Kyrkogard',
          DisplayLabel: 'Kyrkogård',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kvarter: {
          AssociationName: 'Kvarter',
          DisplayLabel: 'Kvarter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKvarter',
          AssociatedComponentName: 'Kvarter',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Avdelning: {
          AssociationName: 'Avdelning',
          DisplayLabel: 'Avdelning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAAvdelning',
          AssociatedComponentName: 'Avdelning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravningsbyra: {
          AssociationName: 'Begravningsbyra',
          DisplayLabel: 'Begravningsbyrå',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Bestallare: {
          AssociationName: 'Bestallare',
          DisplayLabel: 'Beställare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Mottagare: {
          AssociationName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Krematorium: {
          AssociationName: 'Krematorium',
          DisplayLabel: 'Krematorium',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KJKrematorium',
          AssociatedComponentName: 'Krematorium',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOBoknBestallning2: {
      CollectionName: 'BOBoknBestallning2',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Best',
        Abstract: true,
        SOLabel: 'Beställning',
        SOGLabel: 'Beställning',
        SBLabel: 'Beställningen',
        SBGLabel: 'Beställningen',
        POLabel: 'Beställningar',
        POGLabel: 'Beställningar',
        PBLabel: 'Beställningarna',
        PBGLabel: 'Beställningarna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'BestBegrGravs',
            Abstract: true,
            SOLabel: 'Begravning/Gravsättning',
            SOGLabel: 'Begravnings/Gravsättnings',
            SBLabel: 'Begravningen/Gravsättningen',
            SBGLabel: 'Begravningens/Gravsättningens',
            POLabel: 'Begravningar/Gravsättningar',
            POGLabel: 'Begravningars/Gravsättningars',
            PBLabel: 'Begravningarna/Gravsättningarna',
            PBGLabel: 'Begravningarnas/Gravsättningarnas',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'BestBegr',
                Abstract: false,
                SOLabel: 'Begravning',
                SOGLabel: 'Begravningsbeställnings',
                SBLabel: 'Begravningsbeställningen',
                SBGLabel: 'Begravningsbeställningens',
                POLabel: 'Begravningsbeställningar',
                POGLabel: 'Begravningsbeställningars',
                PBLabel: 'Begravningsbeställningarna',
                PBGLabel: 'Begravningsbeställningarnas',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BestGravs',
                Abstract: false,
                SOLabel: 'Gravsättning',
                SOGLabel: 'Gravsättningsbeställnings',
                SBLabel: 'Gravsättningsbeställningen',
                SBGLabel: 'Gravsättningsbeställningens',
                POLabel: 'Gravsättningsbeställningar',
                POGLabel: 'Gravsättningsbeställningars',
                PBLabel: 'Gravsättningsbeställningarna',
                PBGLabel: 'Gravsättningsbeställningarnas',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'BestDop',
            Abstract: false,
            SOLabel: 'Dop',
            SOGLabel: 'Dopbeställnings',
            SBLabel: 'Dopbeställningen',
            SBGLabel: 'Dopbeställningens',
            POLabel: 'Dopbeställningar',
            POGLabel: 'Dopbeställning',
            PBLabel: 'Dopbeställningars',
            PBGLabel: 'Dopbeställningarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BestVigsel',
            Abstract: false,
            SOLabel: 'Vigsel',
            SOGLabel: 'Vigselbeställnings',
            SBLabel: 'Vigselbeställningen',
            SBGLabel: 'Vigselbeställningens',
            POLabel: 'Vigselbeställningar',
            POGLabel: 'Vigselbeställningars',
            PBLabel: 'Vigselbeställningarna',
            PBGLabel: 'Vigselbeställningarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Beställningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Beställningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Aktivitetstyp',
          DataType: 'Enum',
          EnumValues: new Map([['BESTBEGR', 'Begravning'], ['BESTGRAVS', 'Gravsättning'], ['BESTDOP', 'Dop'], ['BESTVIGSEL', 'Vigsel']]),
          EnumSortValues: new Map([['BESTBEGR', 'B'], ['BESTGRAVS', 'G'], ['BESTDOP', 'D'], ['BESTVIGSEL', 'V']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Beställningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Beställd/Mottagen/Refuserad/Komplettera',
          DataType: 'Enum',
          EnumValues: new Map([['BESTALLD', 'Beställd'], ['MOTTAGEN', 'Mottagen'], ['REFUSERAD', 'Refuserad'], ['KOMPLETTERA', 'Komplettera']]),
          EnumSortValues: new Map([['BESTALLD', 'B'], ['MOTTAGEN', 'M'], ['REFUSERAD', 'R'], ['KOMPLETTERA', 'K']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BESTALLD=Beställd;MOTTAGEN=Mottagen;REFUSERAD=Refuserad;KOMPLETTERA=Komplettera"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        BEST_DATUM: {
          AttributeName: 'BEST_DATUM',
          DisplayLabel: 'Beställningsdatum',
          Hint: 'Beställningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Required: true,
        },
        BEST_TID: {
          AttributeName: 'BEST_TID',
          DisplayLabel: 'Beställningstid',
          Hint: 'Beställningstid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          Required: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.contains, T.notcontains],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användar id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        KONTAKT_LOPNR: {
          AttributeName: 'KONTAKT_LOPNR',
          DisplayLabel: 'Kontakt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        GRAVPLATS: {
          AttributeName: 'GRAVPLATS',
          DisplayLabel: 'Gravplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KGARD_ID: {
          AttributeName: 'KGARD_ID',
          DisplayLabel: 'Kyrkogård id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter löpnr.',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        AVDELNING_ID: {
          AttributeName: 'AVDELNING_ID',
          DisplayLabel: 'Avdelning id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        GRAVNUMMER: {
          AttributeName: 'GRAVNUMMER',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVLIDEN_ID: {
          AttributeName: 'AVLIDEN_ID',
          DisplayLabel: 'Avliden id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        ANHORIG_ID: {
          AttributeName: 'ANHORIG_ID',
          DisplayLabel: 'Anhörig id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'Format="y-m|-d/y|mm|dd"',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRAVNINGSTYP_ID: {
          AttributeName: 'BEGRAVNINGSTYP_ID',
          DisplayLabel: 'Begravningstyp id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        GRAVSATTNINGS_TYP: {
          AttributeName: 'GRAVSATTNINGS_TYP',
          DisplayLabel: 'Gravsättningstyp',
          Hint: 'Jordbegravning/Kremering/Minneslund/Askgravlund/Askgravplats/Ej bestämd/Ej gravplats',
          DataType: 'Enum',
          EnumValues: new Map([['JORDBEGRAVNING', 'Jordbegravning'], ['KREMERING', 'Kremering'], ['MINNESLUND', 'Minneslund'], ['ASKGRAVLUND', 'Askgravlund'], ['ASKGRAVPLATS', 'Askgravplats'], ['EJ_BESTAMD', 'Ej bestämd'], ['EJ_GRAVPLATS', 'Ej gravplats']]),
          EnumSortValues: new Map([['JORDBEGRAVNING', 'J'], ['KREMERING', 'K'], ['MINNESLUND', 'M'], ['ASKGRAVLUND', 'L'], ['ASKGRAVPLATS', 'P'], ['EJ_BESTAMD', 'E'], ['EJ_GRAVPLATS', 'G']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JORDBEGRAVNING=Jordbegravning;KREMERING=Kremering;MINNESLUND=Minneslund;ASKGRAVLUND=Askgravlund;ASKGRAVPLATS=Askgravplats;EJ_BESTAMD=Ej bestämd;EJ_GRAVPLATS=Ej gravplats"',
          GUIEditable: true,
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRBYRA_ID: {
          AttributeName: 'BEGRBYRA_ID',
          DisplayLabel: 'Begravningsbyrå id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BESTALLARE_ID: {
          AttributeName: 'BESTALLARE_ID',
          DisplayLabel: 'Bestallare id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        RELATION: {
          AttributeName: 'RELATION',
          DisplayLabel: 'Relation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 30,
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AKT_NR: {
          AttributeName: 'AKT_NR',
          DisplayLabel: 'Aktnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 20,
          ValidInComps: ['BestBegrGravs'],
        },
        MOTTAGARE_ID: {
          AttributeName: 'MOTTAGARE_ID',
          DisplayLabel: 'MottagareID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_MED_URNA: {
          AttributeName: 'AKT_MED_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BestBegrGravs'],
        },
        INTYG_GRAVS: {
          AttributeName: 'INTYG_GRAVS',
          DisplayLabel: 'Intyg gravsättning',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['BestGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        INTYG_ML: {
          AttributeName: 'INTYG_ML',
          DisplayLabel: 'Medgivande ML/AL',
          Hint: 'Medgivande Minneslund/Askgravlund',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['BestBegr'],
        },
        BEGRBYRA_NARVARAR: {
          AttributeName: 'BEGRBYRA_NARVARAR',
          DisplayLabel: 'Begravningsbyrån närvarar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BestBegrGravs'],
        },
        KREM_ID: {
          AttributeName: 'KREM_ID',
          DisplayLabel: 'Krematorium',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegr'],
        },
        KREM_ANNAT: {
          AttributeName: 'KREM_ANNAT',
          DisplayLabel: 'Annat krematorium',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegr'],
        },
        KREM_URNMATERIAL: {
          AttributeName: 'KREM_URNMATERIAL',
          DisplayLabel: 'Urnmaterial',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BestBegr'],
        },
        KREM_ANH_DELTAR: {
          AttributeName: 'KREM_ANH_DELTAR',
          DisplayLabel: 'Anhörig deltar vid kremering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BestBegr'],
        },
        INTYG_GRAVOPPNING: {
          AttributeName: 'INTYG_GRAVOPPNING',
          DisplayLabel: 'Medgivande gravöppning',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['BestGravs'],
        },
        DOPBARN_ID: {
          AttributeName: 'DOPBARN_ID',
          DisplayLabel: 'Dopbarn ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestDop'],
        },
        V1_ID: {
          AttributeName: 'V1_ID',
          DisplayLabel: 'Vårdnadshavare1 ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestDop'],
        },
        V2_ID: {
          AttributeName: 'V2_ID',
          DisplayLabel: 'Vårdnadshavare2 ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestDop'],
        },
        PLATS_ID: {
          AttributeName: 'PLATS_ID',
          DisplayLabel: 'PlatsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DOPDRAKT: {
          AttributeName: 'DOPDRAKT',
          DisplayLabel: 'Önskar dopdräkt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BestDop'],
        },
        KNUT_AKT_ID: {
          AttributeName: 'KNUT_AKT_ID',
          DisplayLabel: 'Knuten AktID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestDop', 'BestVigsel'],
        },
        KNUT_PLATS_ID: {
          AttributeName: 'KNUT_PLATS_ID',
          DisplayLabel: 'Knuten PlatsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestDop', 'BestVigsel'],
        },
        P1_ID: {
          AttributeName: 'P1_ID',
          DisplayLabel: 'Person 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestVigsel'],
        },
        P2_ID: {
          AttributeName: 'P2_ID',
          DisplayLabel: 'Person 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestVigsel'],
        },
        BRUDKRONA: {
          AttributeName: 'BRUDKRONA',
          DisplayLabel: 'Brudkrona',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BestVigsel'],
        },
        calcKyrkogard: {
          AttributeName: 'calcKyrkogard',
          DisplayLabel: 'Kyrkogård',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        calcKvarter: {
          AttributeName: 'calcKvarter',
          DisplayLabel: 'Kvarter',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        calcAvdelning: {
          AttributeName: 'calcAvdelning',
          DisplayLabel: 'Avdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Mottagare: {
          AttributeName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KremBenamning: {
          AttributeName: 'KremBenamning',
          DisplayLabel: 'Krematorium',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['BestBegr'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KontaktBegrByraTel1: {
          AttributeName: 'KontaktBegrByraTel1',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTelNr',
          ValidInComps: ['BestBegrGravs'],
        },
        KontaktBegrByraEpost: {
          AttributeName: 'KontaktBegrByraEpost',
          DisplayLabel: 'Epost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
        },
        BestallareNamn: {
          AttributeName: 'BestallareNamn',
          DisplayLabel: 'Beställarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        sqlKontaktNamn: {
          AttributeName: 'sqlKontaktNamn',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegrByraNamn: {
          AttributeName: 'BegrByraNamn',
          DisplayLabel: 'Begravningsbyrå',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        sqlKontaktEpost: {
          AttributeName: 'sqlKontaktEpost',
          DisplayLabel: 'sqlKontaktEpost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        sqlKontaktTelefon: {
          AttributeName: 'sqlKontaktTelefon',
          DisplayLabel: 'sqlKontaktTelefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTelNr',
          ValidInComps: ['BestBegrGravs'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BestTid: {
          AttributeName: 'BestTid',
          DisplayLabel: 'Beställningsdatum + tid',
          Hint: 'Beställningsdatum + Beställningstid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BestOrgNr: {
          AttributeName: 'BestOrgNr',
          DisplayLabel: 'Orgnr.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        sqlBestKontaktEpost: {
          AttributeName: 'sqlBestKontaktEpost',
          DisplayLabel: 'Beställare epost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        sqlBestKontaktNamn: {
          AttributeName: 'sqlBestKontaktNamn',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NOTERING_NEKAD_BEST: {
          AttributeName: 'NOTERING_NEKAD_BEST',
          DisplayLabel: 'Notering nekad best',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 600,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVLIDEN_REF_ID: {
          AttributeName: 'AVLIDEN_REF_ID',
          DisplayLabel: 'Avliden GUID',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Avliden: {
          AssociationName: 'Avliden',
          DisplayLabel: 'Avliden',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anhorig: {
          AssociationName: 'Anhorig',
          DisplayLabel: 'Anhörig',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Avdelning: {
          AssociationName: 'Avdelning',
          DisplayLabel: 'Avdelning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAAvdelning',
          AssociatedComponentName: 'Avdelning',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravningsbyra: {
          AssociationName: 'Begravningsbyra',
          DisplayLabel: 'Begravningsbyrå',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Begravningstyp: {
          AssociationName: 'Begravningstyp',
          DisplayLabel: 'Begravningstyp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBegravningstyp',
          AssociatedComponentName: 'Begravningstyp',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bestallare: {
          AssociationName: 'Bestallare',
          DisplayLabel: 'Beställare',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Dopkandidat: {
          AssociationName: 'Dopkandidat',
          DisplayLabel: 'Dopkandidat',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BestDop'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Krematorium: {
          AssociationName: 'Krematorium',
          DisplayLabel: 'Krematorium',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KJKrematorium',
          AssociatedComponentName: 'Krematorium',
          JoinAssociation: true,
          ValidInComps: ['BestBegr'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kvarter: {
          AssociationName: 'Kvarter',
          DisplayLabel: 'Kvarter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKvarter',
          AssociatedComponentName: 'Kvarter',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kyrkogard: {
          AssociationName: 'Kyrkogard',
          DisplayLabel: 'Kyrkogård',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: true,
          ValidInComps: ['BestBegrGravs'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Mottagare: {
          AssociationName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Plats: {
          AssociationName: 'Plats',
          DisplayLabel: 'Plats',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Vardnadshavare1: {
          AssociationName: 'Vardnadshavare1',
          DisplayLabel: 'Vårdnadshavare 1',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BestDop'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Vardnadshavare2: {
          AssociationName: 'Vardnadshavare2',
          DisplayLabel: 'Vårdnadshavare 2',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BestDop'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        KnutAkt: {
          AssociationName: 'KnutAkt',
          DisplayLabel: 'Knuten aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: ['BestDop', 'BestVigsel'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KnutPlats: {
          AssociationName: 'KnutPlats',
          DisplayLabel: 'Knuten plats',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Person1: {
          AssociationName: 'Person1',
          DisplayLabel: 'Person 1',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BestVigsel'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Person2: {
          AssociationName: 'Person2',
          DisplayLabel: 'Person 2',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['BestVigsel'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        AktAkttyp: {
          AssociationName: 'AktAkttyp',
          DisplayLabel: 'Aktivitetstyp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetstyp',
          AssociatedComponentName: 'Aktivitetstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Avlidna: {
          AssociationName: 'Avlidna',
          DisplayLabel: 'Avlidna',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAvliden',
          AssociatedComponentName: 'AVLIDEN',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['IntegratedFilter', 'OP_NR;'], ['OverrideDisplayLabels', 'Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.OP_Namn="Efternamn",Avlidna.Person.NamnME="Efternamn",G:Person="";']]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBoknBestDok',
          AssociatedComponentName: 'BoknBestDok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBevakning: {
      CollectionName: 'BOBevakning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bevakningsgrupp',
        Abstract: true,
        SOLabel: 'Bevakning',
        SOGLabel: 'Bevakning',
        SBLabel: 'Bevakningen',
        SBGLabel: 'Bevakningen',
        POLabel: 'Bevakningar',
        POGLabel: 'Bevakningar',
        PBLabel: 'Bevakningarna',
        PBGLabel: 'Bevakningarna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'Anvandare',
            Abstract: false,
            SOLabel: 'Användare',
            SOGLabel: 'Användare',
            SBLabel: 'Användaren',
            SBGLabel: 'Användaren',
            POLabel: 'Användare',
            POGLabel: 'Användare',
            PBLabel: 'Användarna',
            PBGLabel: 'Användarna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BoknGrupp',
            Abstract: false,
            SOLabel: 'Bokningsgrupp',
            SOGLabel: 'Bokningsgrupp',
            SBLabel: 'Bokningsgruppen',
            SBGLabel: 'Bokningsgruppen',
            POLabel: 'Bokningsgrupper',
            POGLabel: 'Bokningsgrupper',
            PBLabel: 'Bokningsgrupperna',
            PBGLabel: 'Bokningsgrupperna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bevakningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bevakningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['ANVANDARE', 'Användare'], ['BOKNGRUPP', 'Bokningsgrupp']]),
          EnumSortValues: new Map([['ANVANDARE', 'A'], ['BOKNGRUPP', 'G']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bevakningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bevakningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'AnvändarID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['Anvandare'],
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'BokningsgruppID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BoknGrupp'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: ['Anvandare'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'SIGNATURE;']]),
        },
        Bokningsgrupp: {
          AssociationName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokngrupp',
          AssociatedComponentName: 'BoknGrupp',
          JoinAssociation: true,
          ValidInComps: ['BoknGrupp'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBisattningsrumdel: {
      CollectionName: 'BOBisattningsrumdel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '20001']]),
      RootType: {
        TypeValue: 'Bisattningsrumdel',
        Abstract: false,
        SOLabel: 'Bisättningsdel',
        SOGLabel: 'Bisättningsdels',
        SBLabel: 'Bisättningsdelen',
        SBGLabel: 'Bisättningsdelens',
        POLabel: 'Bisättningsdelar',
        POGLabel: 'Bisättningsdelars',
        PBLabel: 'Bisättningsdelarna',
        PBGLabel: 'Bisättningsdelarnas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'BisattningsrumdelUrna',
            Abstract: false,
            SOLabel: 'Urndel',
            SOGLabel: 'Urndel',
            SBLabel: 'Urndelen',
            SBGLabel: 'Urndelens',
            POLabel: 'Urndelar',
            POGLabel: 'Urndelars',
            PBLabel: 'Urndelarna',
            PBGLabel: 'Urndelarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BisattningsrumdelKista',
            Abstract: false,
            SOLabel: 'Kistdel',
            SOGLabel: 'Kistdels',
            SBLabel: 'Kistdelen',
            SBGLabel: 'Kistdelens',
            POLabel: 'Kistdelar',
            POGLabel: 'Kistdelars',
            PBLabel: 'Kistdelarna',
            PBGLabel: 'Kistdelarnas',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningsdelens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningsdelens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningsdelens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUM_ID: {
          AttributeName: 'RUM_ID',
          DisplayLabel: 'Rum',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
          ValidInComps: ['Bisattningsrumdel', 'BisattningsrumdelUrna', 'BisattningsrumdelKista'],
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        RADER: {
          AttributeName: 'RADER',
          DisplayLabel: 'Rader',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
        },
        KOLUMNER: {
          AttributeName: 'KOLUMNER',
          DisplayLabel: 'Kolumner',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
        },
        MAX_KISTOR: {
          AttributeName: 'MAX_KISTOR',
          DisplayLabel: 'Max kistor',
          Hint: 'Max antal kistor per position',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        MAX_URNOR: {
          AttributeName: 'MAX_URNOR',
          DisplayLabel: 'Max urnor',
          Hint: 'Max antal urnor per position',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Kista/Urna',
          DataType: 'Enum',
          EnumValues: new Map([['KISTA', 'Kista'], ['URNA', 'Urna']]),
          EnumSortValues: new Map([['KISTA', 'K'], ['URNA', 'U']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KISTA=Kista;URNA=Urna"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FULL_BENAMNING: {
          AttributeName: 'FULL_BENAMNING',
          DisplayLabel: 'Visa hela benämningen i placeringen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rum: {
          AssociationName: 'Rum',
          DisplayLabel: 'Rum',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningsrum',
          AssociatedComponentName: 'Bisattningsrum',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Pos: {
          AssociationName: 'Pos',
          DisplayLabel: 'Positioner',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningspos',
          AssociatedComponentName: 'Bisattningspos',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBisattningshandelse: {
      CollectionName: 'BOBisattningshandelse',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bisattningshandelse',
        Abstract: true,
        SOLabel: 'Bisättningshändelse',
        SOGLabel: 'Bisättningshändelses',
        SBLabel: 'Bisättningshändelsen',
        SBGLabel: 'Bisättningshändelsens',
        POLabel: 'Bisättningshändelser',
        POGLabel: 'Bisättningshändelsers',
        PBLabel: 'Bisättningshändelserna',
        PBGLabel: 'Bisättningshändelsernas',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'BisattningshandelseIn',
            Abstract: false,
            SOLabel: 'In',
            SOGLabel: 'In',
            SBLabel: 'In',
            SBGLabel: 'In',
            POLabel: 'In',
            POGLabel: 'In',
            PBLabel: 'In',
            PBGLabel: 'In',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BisattningshandelseUt',
            Abstract: false,
            SOLabel: 'Ut',
            SOGLabel: 'Ut',
            SBLabel: 'Ut',
            SBGLabel: 'Ut',
            POLabel: 'Ut',
            POGLabel: 'Ut',
            PBLabel: 'Ut',
            PBGLabel: 'Ut',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BisattningshandelseReg',
            Abstract: false,
            SOLabel: 'Registrerad',
            SOGLabel: 'Registrerad',
            SBLabel: 'Registrerad',
            SBGLabel: 'Registrerad',
            POLabel: 'Registrerad',
            POGLabel: 'Registrerad',
            PBLabel: 'Registrerad',
            PBGLabel: 'Registrerad',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BisattningshandelseTom',
            Abstract: false,
            SOLabel: 'Tom Urna',
            SOGLabel: 'Tom Urna',
            SBLabel: 'Tom Urna',
            SBGLabel: 'Tom Urna',
            POLabel: 'Tom Urna',
            POGLabel: 'Tom Urna',
            PBLabel: 'Tom Urna',
            PBGLabel: 'Tom Urna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BisattningshandelseBest',
            Abstract: false,
            SOLabel: 'Beställning',
            SOGLabel: 'Beställning',
            SBLabel: 'Beställning',
            SBGLabel: 'Beställning',
            POLabel: 'Beställning',
            POGLabel: 'Beställning',
            PBLabel: 'Beställning',
            PBGLabel: 'Beställning',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'BisattningshandelseAvs',
            Abstract: false,
            SOLabel: 'Avslutad',
            SOGLabel: 'Avslutad',
            SBLabel: 'Avslutade',
            SBGLabel: 'Avslutade',
            POLabel: 'Avslutade',
            POGLabel: 'Avslutade',
            PBLabel: 'Avslutade',
            PBGLabel: 'Avslutade',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningshändelsens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningshändelsens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ av händelse',
          DataType: 'Enum',
          EnumValues: new Map([['BISATTNINGSHANDELSEIN', 'In'], ['BISATTNINGSHANDELSEUT', 'Ut'], ['BISATTNINGSHANDELSEREG', 'Registrerad'], ['BISATTNINGSHANDELSETOM', 'Tom Urna'], ['BISATTNINGSHANDELSEBEST', 'Beställning'], ['BISATTNINGSHANDELSEAVS', 'Avslutad']]),
          EnumSortValues: new Map([['BISATTNINGSHANDELSEIN', 'I'], ['BISATTNINGSHANDELSEUT', 'U'], ['BISATTNINGSHANDELSEREG', 'R'], ['BISATTNINGSHANDELSETOM', 'T'], ['BISATTNINGSHANDELSEBEST', 'B'], ['BISATTNINGSHANDELSEAVS', 'X']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BISATTNINGSHANDELSEIN=In;BISATTNINGSHANDELSEUT=Ut;BISATTNINGSHANDELSEREG=Registrerad;BISATTNINGSHANDELSETOM=Tom Urna;BISATTNINGSHANDELSEBEST=Beställning;BISATTNINGSHANDELSEAVS=Avslutad"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningshändelsens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BISATTNINGSTYP_ID: {
          AttributeName: 'BISATTNINGSTYP_ID',
          DisplayLabel: 'Bisättningstyp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          Hint: 'Händelsedatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användare / Transportör',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKTPERSON: {
          AttributeName: 'KONTAKTPERSON',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BERAKNAT_AVHAMTNINGS_DATUM: {
          AttributeName: 'BERAKNAT_AVHAMTNINGS_DATUM',
          DisplayLabel: 'Beräknat avhämtningsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          ValidInComps: ['BisattningshandelseIn'],
        },
        PLACERING_ID: {
          AttributeName: 'PLACERING_ID',
          DisplayLabel: 'Placering',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BisattningshandelseIn'],
        },
        PLACERING_EJ_MALL: {
          AttributeName: 'PLACERING_EJ_MALL',
          DisplayLabel: 'Placering utanför mall',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['BisattningshandelseIn'],
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        LOKAL_ID: {
          AttributeName: 'LOKAL_ID',
          DisplayLabel: 'Lokal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        UTCHECKNINGSSTATUS_ID: {
          AttributeName: 'UTCHECKNINGSSTATUS_ID',
          DisplayLabel: 'Utcheckningsstatus',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BisattningshandelseUt', 'BisattningshandelseAvs'],
        },
        TILLBAKA: {
          AttributeName: 'TILLBAKA',
          DisplayLabel: 'Tillbaka',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          ValidInComps: ['BisattningshandelseUt'],
        },
        TILLBAKADATUM: {
          AttributeName: 'TILLBAKADATUM',
          DisplayLabel: 'Tillbaka datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          ValidInComps: ['BisattningshandelseUt'],
        },
        TILLBAKALOKAL_ID: {
          AttributeName: 'TILLBAKALOKAL_ID',
          DisplayLabel: 'Tillbaka till lokal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BisattningshandelseUt'],
        },
        Plats: {
          AttributeName: 'Plats',
          DisplayLabel: 'Plats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TILLBAKATID: {
          AttributeName: 'TILLBAKATID',
          DisplayLabel: 'Tillbaka tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          ValidInComps: ['BisattningshandelseUt'],
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        TYP_KISTA_URNA: {
          AttributeName: 'TYP_KISTA_URNA',
          DisplayLabel: 'Typ av kista/urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TRANSPORTOR: {
          AttributeName: 'TRANSPORTOR',
          DisplayLabel: 'Transportör',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 60,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BisattnTypBen: {
          AttributeName: 'BisattnTypBen',
          DisplayLabel: 'Bisättningstyp från senaste händelse',
          Hint: 'Bisättningstyp från senaste händelse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        UTCHECKNINGSSTATUS_ID_COPY: {
          AttributeName: 'UTCHECKNINGSSTATUS_ID_COPY',
          DisplayLabel: 'Kopia av utcheckningsstatus',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BisattningshandelseUt'],
        },
        UTCHECKNINGSSTATUS_ID_URNA: {
          AttributeName: 'UTCHECKNINGSSTATUS_ID_URNA',
          DisplayLabel: 'Utcheckningsstatus Urna',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BisattningshandelseUt', 'BisattningshandelseAvs'],
        },
        UTCHECKNINGSSTATUS_ID_STOFT: {
          AttributeName: 'UTCHECKNINGSSTATUS_ID_STOFT',
          DisplayLabel: 'Utcheckningsstatus Stoft',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['BisattningshandelseUt', 'BisattningshandelseAvs'],
        },
        AVHAMTARE: {
          AttributeName: 'AVHAMTARE',
          DisplayLabel: 'Avhämtare från bisättning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.equals, T.interval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AvhamtareSen: {
          AttributeName: 'AvhamtareSen',
          DisplayLabel: 'Avhämtare',
          Hint: 'Senaste avhämtare från kremation/bisättning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FinnsUtcheckadKremation: {
          AttributeName: 'FinnsUtcheckadKremation',
          DisplayLabel: 'Finns utcheckad för kremation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        UtcheckadKremationID: {
          AttributeName: 'UtcheckadKremationID',
          DisplayLabel: 'Slå upp kremation',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bisattningstyp: {
          AssociationName: 'Bisattningstyp',
          DisplayLabel: 'Bisättningstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningstyp',
          AssociatedComponentName: 'Bisattningstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare / Transportör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Lokal: {
          AssociationName: 'Lokal',
          DisplayLabel: 'Lokal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningslokal',
          AssociatedComponentName: 'Bisattningslokal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Utcheckingsstatus: {
          AssociationName: 'Utcheckingsstatus',
          DisplayLabel: 'Utcheckningsstatus kista',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOUtcheckningsstatus',
          AssociatedComponentName: 'Utcheckningsstatus',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Tillbakalokal: {
          AssociationName: 'Tillbakalokal',
          DisplayLabel: 'Tillbakalokal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningslokal',
          AssociatedComponentName: 'Bisattningslokal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Placering: {
          AssociationName: 'Placering',
          DisplayLabel: 'Placering',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningspos',
          AssociatedComponentName: 'Bisattningspos',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Journal: {
          AssociationName: 'Journal',
          DisplayLabel: 'Journal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattning',
          AssociatedComponentName: 'Bisattningsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        UtcheckningsstatusUrna: {
          AssociationName: 'UtcheckningsstatusUrna',
          DisplayLabel: 'Utcheckningsstatus urna',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOUtcheckningsstatusUrna',
          AssociatedComponentName: 'UtcheckningsstatusUrna',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UtcheckningsstatusStoft: {
          AssociationName: 'UtcheckningsstatusStoft',
          DisplayLabel: 'Utcheckningsstatus stoft',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOUtcheckningsstatusStoft',
          AssociatedComponentName: 'UtcheckningsstatusStoft',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        UtcheckadKremation: {
          AssociationName: 'UtcheckadKremation',
          DisplayLabel: 'Utcheckad kremation',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKremation',
          AssociatedComponentName: 'Kremationsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBisattningBestallning: {
      CollectionName: 'BOBisattningBestallning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BisattningBestallning',
        Abstract: false,
        SOLabel: 'Bisättningsjournal Beställning',
        SOGLabel: 'Bisättningsjournal Beställnings',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOBisattningBestallnings primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOBisattningBestallnings versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOBisattningBestallnings fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JOURNALNR: {
          AttributeName: 'JOURNALNR',
          DisplayLabel: 'Journalnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVLIDEN_ID: {
          AttributeName: 'AVLIDEN_ID',
          DisplayLabel: 'Avliden',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BEGRBYRA_ID: {
          AttributeName: 'BEGRBYRA_ID',
          DisplayLabel: 'Begravningsbyrå',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DIREKTARE: {
          AttributeName: 'DIREKTARE',
          DisplayLabel: 'Direktare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGR_AKT_ID: {
          AttributeName: 'BEGR_AKT_ID',
          DisplayLabel: 'Begravning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GRAVS_AKT_ID: {
          AttributeName: 'GRAVS_AKT_ID',
          DisplayLabel: 'Gravsättning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KREM_ID: {
          AttributeName: 'KREM_ID',
          DisplayLabel: 'Kremation',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BEGR_ANNAN_ORT: {
          AttributeName: 'BEGR_ANNAN_ORT',
          DisplayLabel: 'Begravningsort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGR_ANNAN_ORT_DATUM: {
          AttributeName: 'BEGR_ANNAN_ORT_DATUM',
          DisplayLabel: 'Begravningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVS_ANNAN_ORT: {
          AttributeName: 'GRAVS_ANNAN_ORT',
          DisplayLabel: 'Gravsättningsort',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KREMERING: {
          AttributeName: 'KREMERING',
          DisplayLabel: 'Kremering',
          Hint: 'Kremering/Jordbegravning',
          DataType: 'Enum',
          EnumValues: new Map([['KREMERING', 'Kremering'], ['JORDBEGRAVNING', 'Jordbegravning']]),
          EnumSortValues: new Map([['KREMERING', 'Y'], ['JORDBEGRAVNING', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KREMERING=Kremering;JORDBEGRAVNING=Jordbegravning"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRBYRA_KONTAKT: {
          AttributeName: 'BEGRBYRA_KONTAKT',
          DisplayLabel: 'Begravningsbyrå kontakt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEGRBYRA_KONTAKT_INFO: {
          AttributeName: 'BEGRBYRA_KONTAKT_INFO',
          DisplayLabel: 'Begravningsbyrå kontakt info.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SPARRAD: {
          AttributeName: 'SPARRAD',
          DisplayLabel: 'Spärrad journal',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FOSTERNUMMER: {
          AttributeName: 'FOSTERNUMMER',
          DisplayLabel: 'Fosternummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FOSTER: {
          AttributeName: 'FOSTER',
          DisplayLabel: 'Foster',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TOMURNA: {
          AttributeName: 'TOMURNA',
          DisplayLabel: 'Tom urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PLASTURNA: {
          AttributeName: 'PLASTURNA',
          DisplayLabel: 'Plast urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AKT_URNA: {
          AttributeName: 'AKT_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TYP_KISTA: {
          AttributeName: 'TYP_KISTA',
          DisplayLabel: 'Typ av kista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TYP_URNA: {
          AttributeName: 'TYP_URNA',
          DisplayLabel: 'Typ av urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AKTNUMMER: {
          AttributeName: 'AKTNUMMER',
          DisplayLabel: 'Aktnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTRA_STOR_KISTA: {
          AttributeName: 'EXTRA_STOR_KISTA',
          DisplayLabel: 'Extra stor kista',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KISTMATT: {
          AttributeName: 'KISTMATT',
          DisplayLabel: 'Kistmått',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NOTERINGAR: {
          AttributeName: 'NOTERINGAR',
          DisplayLabel: 'noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGR_ANNAN_ORT_TID: {
          AttributeName: 'BEGR_ANNAN_ORT_TID',
          DisplayLabel: 'Begravningstid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVS_ANNAN_ORT_DATUM: {
          AttributeName: 'GRAVS_ANNAN_ORT_DATUM',
          DisplayLabel: 'Gravsättningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GRAVS_ANNAN_ORT_TID: {
          AttributeName: 'GRAVS_ANNAN_ORT_TID',
          DisplayLabel: 'Gravsättningstid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BEST_DIREKTKREMATION: {
          AttributeName: 'BEST_DIREKTKREMATION',
          DisplayLabel: 'Direktkremation beställd',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEST_KREM_DATUM: {
          AttributeName: 'BEST_KREM_DATUM',
          DisplayLabel: 'Beställd kremationsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEST_KREMATORIUM: {
          AttributeName: 'BEST_KREMATORIUM',
          DisplayLabel: 'Krematorium',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESTALLNING_KREM: {
          AttributeName: 'BESTALLNING_KREM',
          DisplayLabel: 'Beställd kremation',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GRAVSATTNINGSORT_ID: {
          AttributeName: 'GRAVSATTNINGSORT_ID',
          DisplayLabel: 'Gravsättningsort ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INTYG_GRAVS: {
          AttributeName: 'INTYG_GRAVS',
          DisplayLabel: 'Intyg, gravsättning',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        INTYG_KREM: {
          AttributeName: 'INTYG_KREM',
          DisplayLabel: 'Intyg, Kremation',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        MARKERAD_FAKTURERAD: {
          AttributeName: 'MARKERAD_FAKTURERAD',
          DisplayLabel: 'Markerad som fakturerad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NOTERING2: {
          AttributeName: 'NOTERING2',
          DisplayLabel: 'Noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OWNER_ID: {
          AttributeName: 'OWNER_ID',
          DisplayLabel: 'Id, Owner',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PACEMAKER: {
          AttributeName: 'PACEMAKER',
          DisplayLabel: 'Implantat med batteri',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TOMURNA_PLACERING: {
          AttributeName: 'TOMURNA_PLACERING',
          DisplayLabel: 'Placering, tom urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VIKT: {
          AttributeName: 'VIKT',
          DisplayLabel: 'Vikt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOBisattningSettings: {
      CollectionName: 'BOBisattningSettings',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '20001']]),
      RootType: {
        TypeValue: 'BisattningSettings',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Bisättningsjournal inställningar',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOBisattningSettingss primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOBisattningSettingss versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOBisattningSettingss fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VALID_VALUES: {
          AttributeName: 'VALID_VALUES',
          DisplayLabel: 'Tillåtna värden',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 250,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OptionData: {
          AttributeName: 'OptionData',
          DisplayLabel: 'Option data',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BJ_GDPR_FAKT: {
          AttributeName: 'BJ_GDPR_FAKT',
          DisplayLabel: 'Månader att spara underlag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="å=12;m=1";DefaultGroup="m";GroupTexts="å=å;år=å;m=m;mån=m;månad=m;månader=m"',
          FormatterDisplayParams: 'Groups="år=12;månader/månad=1";GroupNameSep=" "',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOBisattningKontakt: {
      CollectionName: 'BOBisattningKontakt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '19012'], ['Utskick', 'Y']]),
      RootType: {
        TypeValue: 'BisattningsKontakt',
        Abstract: true,
        SOLabel: 'Bisättningsjournal kontakt',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Bisättningsjournal kontakter',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'BisattningsKontaktOrgPers',
            Abstract: true,
            SOLabel: 'Kontakt',
            SOGLabel: 'Kontakts',
            SBLabel: 'Kontakten',
            SBGLabel: 'Kontaktens',
            POLabel: 'Kontakter',
            POGLabel: 'Kontakters',
            PBLabel: 'Kontakternas',
            PBGLabel: 'Kontakters',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'BisattningsKontaktAnhorig',
                Abstract: false,
                SOLabel: 'Anhörig',
                SOGLabel: '',
                SBLabel: 'Kontakten',
                SBGLabel: '',
                POLabel: 'Anhöriga',
                POGLabel: '',
                PBLabel: '',
                PBGLabel: '',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BisattningsKontaktByra',
                Abstract: false,
                SOLabel: 'Begravningsbyrå',
                SOGLabel: '',
                SBLabel: 'Kontakten',
                SBGLabel: '',
                POLabel: 'Begravningsbyråer',
                POGLabel: '',
                PBLabel: '',
                PBGLabel: '',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BisattningsKontaktTransportor',
                Abstract: false,
                SOLabel: 'Transportör',
                SOGLabel: '',
                SBLabel: 'Kontakten',
                SBGLabel: '',
                POLabel: 'Transportörer',
                POGLabel: '',
                PBLabel: '',
                PBGLabel: '',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BisattningsKontaktOrg',
                Abstract: false,
                SOLabel: 'Övrig organisation',
                SOGLabel: '',
                SBLabel: 'Kontakten',
                SBGLabel: '',
                POLabel: 'Övriga organisationer',
                POGLabel: '',
                PBLabel: '',
                PBGLabel: '',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BisattningsKontaktPerson',
                Abstract: false,
                SOLabel: 'Övrig person',
                SOGLabel: '',
                SBLabel: 'Kontakten',
                SBGLabel: '',
                POLabel: 'Övriga personer',
                POGLabel: '',
                PBLabel: '',
                PBGLabel: '',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BisattningsKontaktAnnan',
                Abstract: false,
                SOLabel: 'Annan kund',
                SOGLabel: '',
                SBLabel: 'Kontakten',
                SBGLabel: '',
                POLabel: 'Andra kunder',
                POGLabel: '',
                PBLabel: '',
                PBGLabel: '',
                Visible: false,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'BisattningsKontaktTransportorPerson',
                Abstract: false,
                SOLabel: 'Transportör person',
                SOGLabel: '',
                SBLabel: 'Kontakten',
                SBGLabel: '',
                POLabel: 'Transportör personer',
                POGLabel: '',
                PBLabel: '',
                PBGLabel: '',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOBisattningKontakts primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOBisattningKontakts versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['BISATTNINGSKONTAKTANHORIG', 'Anhörig'], ['BISATTNINGSKONTAKTBYRA', 'Begravningsbyrå'], ['BISATTNINGSKONTAKTTRANSPORTOR', 'Transportör'], ['BISATTNINGSKONTAKTORG', 'Övrig organisation'], ['BISATTNINGSKONTAKTPERSON', 'Övrig person'], ['BISATTNINGSKONTAKTANNAN', 'Annan kund'], ['BISATTNINGSKONTAKTTRANSPORTORPERSON', 'Transportör person']]),
          EnumSortValues: new Map([['BISATTNINGSKONTAKTANHORIG', 'A'], ['BISATTNINGSKONTAKTBYRA', 'B'], ['BISATTNINGSKONTAKTTRANSPORTOR', 'T'], ['BISATTNINGSKONTAKTORG', 'Ö'], ['BISATTNINGSKONTAKTPERSON', 'P'], ['BISATTNINGSKONTAKTANNAN', 'F'], ['BISATTNINGSKONTAKTTRANSPORTORPERSON', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BISATTNINGSKONTAKTANHORIG=Anhörig;BISATTNINGSKONTAKTBYRA=Begravningsbyrå;BISATTNINGSKONTAKTTRANSPORTOR=Transportör;BISATTNINGSKONTAKTORG=Övrig organisation;BISATTNINGSKONTAKTPERSON=Övrig person;BISATTNINGSKONTAKTANNAN=Annan kund;BISATTNINGSKONTAKTTRANSPORTORPERSON=Transportör person"',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOBisattningKontakts fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'OPid',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Fråndatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KONTAKTPERSON: {
          AttributeName: 'KONTAKTPERSON',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RELATION: {
          AttributeName: 'RELATION',
          DisplayLabel: 'Relation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BESTALLARE: {
          AttributeName: 'BESTALLARE',
          DisplayLabel: 'Beställare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bisattning: {
          AssociationName: 'Bisattning',
          DisplayLabel: 'Bisättning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattning',
          AssociatedComponentName: 'Bisattningsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        OrgPers: {
          AssociationName: 'OrgPers',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: ['BisattningsKontaktOrgPers'],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,LKFStatus,Forsamlingsbo,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.CO,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON_ARB,Adress.TELEFON_MOBIL,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Anhörig",PREFIX:*="Anhörig ";'], ['NOT_ATAGANDE', 'Y']]),
        },
        OrgPers2: {
          AssociationName: 'OrgPers2',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['NOT_ATAGANDE', 'Y;'], ['OPL_NOCOMBINE', 'Y;'], ['OverrideDisplayLabels', 'G:Borttagen="Adress borttagen",BORTTAGEN="Adress borttagen",BORTTAGEN_DATUM="Adress borttagen datum",BORTTAGEN_SIGNATUR="Adress borttagen signatur"']]),
        },
      },
    },
    BOBisattning: {
      CollectionName: 'BOBisattning',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '19001'], ['AllowEdit', '19001,20001'], ['Utskick', 'Y']]),
      RootType: {
        TypeValue: 'Bisattningsjournal',
        Abstract: false,
        SOLabel: 'Bisättningsjournal',
        SOGLabel: 'Bisättningsjournals',
        SBLabel: 'Bisättningsjournalen',
        SBGLabel: 'Bisättningsjournalens',
        POLabel: 'Bisättningsjournaler',
        POGLabel: 'Bisättningsjournalers',
        PBLabel: 'Bisättningsjournalerna',
        PBGLabel: 'Bisättningsjournalernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningsjournalens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningsjournalens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bisättningsjournalens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningsjournalens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        JOURNALNR: {
          AttributeName: 'JOURNALNR',
          DisplayLabel: 'Journalnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.starts,
        },
        BEGRBYRA_ID: {
          AttributeName: 'BEGRBYRA_ID',
          DisplayLabel: 'Begravningsbyrå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DIREKTARE: {
          AttributeName: 'DIREKTARE',
          DisplayLabel: 'Direktkremation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KREM_ID: {
          AttributeName: 'KREM_ID',
          DisplayLabel: 'Kremation ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGR_ANNAN_ORT: {
          AttributeName: 'BEGR_ANNAN_ORT',
          DisplayLabel: 'Begravningsceremoni Plats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Begravningsceremoni',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVS_ANNAN_ORT: {
          AttributeName: 'GRAVS_ANNAN_ORT',
          DisplayLabel: 'Gravsättning Plats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravsättning',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        KREMERING: {
          AttributeName: 'KREMERING',
          DisplayLabel: 'Kremering',
          Hint: 'Kremering/Jordbegravning/Obestämd',
          DataType: 'Enum',
          EnumValues: new Map([['KREMERING', 'Kremering'], ['JORDBEGRAVNING', 'Jordbegravning'], ['OBESTAMD', 'Obestämd']]),
          EnumSortValues: new Map([['KREMERING', 'Y'], ['JORDBEGRAVNING', 'N'], ['OBESTAMD', '[BLANK]']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KREMERING=Kremering;JORDBEGRAVNING=Jordbegravning;OBESTAMD=Obestämd"',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'CenturyLimit="0";AllowIncomplete="Y";AllowZero="Y"',
          FormatterValidateParams: 'MaxDate="+0m";MaxRecommendedDate="+0m"',
        },
        BEGRBYRA_KONTAKT: {
          AttributeName: 'BEGRBYRA_KONTAKT',
          DisplayLabel: 'Begravningsbyrå kontakt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Begravningsbyrå',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGRBYRA_KONTAKT_INFO: {
          AttributeName: 'BEGRBYRA_KONTAKT_INFO',
          DisplayLabel: 'Begravningsbyrå kontakt info.',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Begravningsbyrå',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SPARRAD: {
          AttributeName: 'SPARRAD',
          DisplayLabel: 'Spärrad journal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FOSTERNUMMER: {
          AttributeName: 'FOSTERNUMMER',
          DisplayLabel: 'Nummer (persnr. saknas)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Avliden',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FOSTER: {
          AttributeName: 'FOSTER',
          DisplayLabel: 'Persnr. saknas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SerieID: {
          AttributeName: 'SerieID',
          DisplayLabel: 'SerieID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HandelseStatus: {
          AttributeName: 'HandelseStatus',
          DisplayLabel: 'Status',
          Hint: 'In/Ut/Registrerad/Avslutad',
          DataType: 'Enum',
          EnumValues: new Map([['IN', 'In'], ['UT', 'Ut'], ['REGISTRERAD', 'Registrerad'], ['AVSLUTAD', 'Avslutad']]),
          EnumSortValues: new Map([['IN', 'I'], ['UT', 'U'], ['REGISTRERAD', 'R'], ['AVSLUTAD', 'X']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="IN=In;UT=Ut;REGISTRERAD=Registrerad;AVSLUTAD=Avslutad"',
          InterfaceType: 'ifChecklist',
        },
        TOMURNA: {
          AttributeName: 'TOMURNA',
          DisplayLabel: 'Tom urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        PLASTURNA: {
          AttributeName: 'PLASTURNA',
          DisplayLabel: 'Urna saknas',
          Hint: 'Urna saknas - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BEGR_ANNAN_ORT_DATUM: {
          AttributeName: 'BEGR_ANNAN_ORT_DATUM',
          DisplayLabel: 'Begravningsceremoni Datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          AttributeGroup: 'Begravningsceremoni',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AKT_URNA: {
          AttributeName: 'AKT_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        TYP_KISTA: {
          AttributeName: 'TYP_KISTA',
          DisplayLabel: 'Typ av kista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TYP_URNA: {
          AttributeName: 'TYP_URNA',
          DisplayLabel: 'Typ av urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AKTNUMMER: {
          AttributeName: 'AKTNUMMER',
          DisplayLabel: 'Aktnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        EXTRA_STOR_KISTA: {
          AttributeName: 'EXTRA_STOR_KISTA',
          DisplayLabel: 'Extra stor kista',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KISTMATT: {
          AttributeName: 'KISTMATT',
          DisplayLabel: 'Kistmått',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NOTERINGAR: {
          AttributeName: 'NOTERINGAR',
          DisplayLabel: 'Anteckningar i Webaveny',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          Hint: 'Efternamn, förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BEGR_ANNAN_ORT_TID: {
          AttributeName: 'BEGR_ANNAN_ORT_TID',
          DisplayLabel: 'Begravningsceremoni Tid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          AttributeGroup: 'Begravningsceremoni',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVSATTNINGSORT_ID: {
          AttributeName: 'GRAVSATTNINGSORT_ID',
          DisplayLabel: 'Gravsättningsort ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BisattnTypBen: {
          AttributeName: 'BisattnTypBen',
          DisplayLabel: 'Bisättningstyp från senaste händelse',
          Hint: 'Bisättningstyp från senaste händelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        GRAVS_ANNAN_ORT_TID: {
          AttributeName: 'GRAVS_ANNAN_ORT_TID',
          DisplayLabel: 'Gravsättning Tid',
          DataType: 'Time',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        GRAVS_ANNAN_ORT_DATUM: {
          AttributeName: 'GRAVS_ANNAN_ORT_DATUM',
          DisplayLabel: 'Gravsättning Datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        HandelseDatum: {
          AttributeName: 'HandelseDatum',
          DisplayLabel: 'Händelsedatum',
          Hint: 'Händelsedatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTALDAGAR: {
          AttributeName: 'ANTALDAGAR',
          DisplayLabel: 'Antal dagar',
          Hint: 'Antal dagar från första inlämning av kista tills första utlämningen',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OWNER_ID: {
          AttributeName: 'OWNER_ID',
          DisplayLabel: 'Id, owner',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BegrByraNamn: {
          AttributeName: 'BegrByraNamn',
          DisplayLabel: 'Begravningsbyrå benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PACEMAKER: {
          AttributeName: 'PACEMAKER',
          DisplayLabel: 'Implantat med batteri',
          Hint: 'Finns/Finns ej',
          DataType: 'Enum',
          EnumValues: new Map([['FINNS', 'Finns'], ['FINNS_EJ', 'Finns ej']]),
          EnumSortValues: new Map([['FINNS', 'Y'], ['FINNS_EJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FINNS=Finns;FINNS_EJ=Finns ej"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        VIKT: {
          AttributeName: 'VIKT',
          DisplayLabel: 'Vikt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TransportorNamn: {
          AttributeName: 'TransportorNamn',
          DisplayLabel: 'Transportör benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        HandelsePlacering: {
          AttributeName: 'HandelsePlacering',
          DisplayLabel: 'Placering',
          Hint: 'Placering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        HandelseLokal: {
          AttributeName: 'HandelseLokal',
          DisplayLabel: 'Lokal från händelse',
          Hint: 'Lokal från händelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        MARKERAD_FAKTURERAD: {
          AttributeName: 'MARKERAD_FAKTURERAD',
          DisplayLabel: 'Markerad som fakturerad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BegrAktID: {
          AttributeName: 'BegrAktID',
          DisplayLabel: 'Begravningsaktivitet',
          Hint: 'Begravningsaktivitet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravsAktID: {
          AttributeName: 'GravsAktID',
          DisplayLabel: 'Gravsättningsaktivitet',
          Hint: 'Gravsättningsaktivitet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktDodsdatum: {
          AttributeName: 'AktDodsdatum',
          DisplayLabel: 'Dödsdatum från aktivitet',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        TOMURNA_PLACERING: {
          AttributeName: 'TOMURNA_PLACERING',
          DisplayLabel: 'Placering, tom urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        KremNR: {
          AttributeName: 'KremNR',
          DisplayLabel: 'Kremationsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Kremation',
        },
        INTYG_KREM: {
          AttributeName: 'INTYG_KREM',
          DisplayLabel: 'Intyg kremation',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        INTYG_GRAVS: {
          AttributeName: 'INTYG_GRAVS',
          DisplayLabel: 'Intyg gravsättning',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        NOTERING2: {
          AttributeName: 'NOTERING2',
          DisplayLabel: 'Noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OvrAktTitel: {
          AttributeName: 'OvrAktTitel',
          DisplayLabel: 'Övrig bokning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        TvistKrem: {
          AttributeName: 'TvistKrem',
          DisplayLabel: 'Tvist kremering',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        TvistGravs: {
          AttributeName: 'TvistGravs',
          DisplayLabel: 'Tvist gravsättning',
          Hint: 'Ja/Nej',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        Medgivande: {
          AttributeName: 'Medgivande',
          DisplayLabel: 'Medgivande ML/AL',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NarvararKremation: {
          AttributeName: 'NarvararKremation',
          DisplayLabel: 'Anhörig närvarar',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        BEST_DIREKTKREMATION: {
          AttributeName: 'BEST_DIREKTKREMATION',
          DisplayLabel: 'Direktkremation beställd',
          Hint: 'Akt med urna/Kremering efter ceremoni/Ingen ceremoni',
          DataType: 'Enum',
          EnumValues: new Map([['AKT_MED_URNA', 'Akt med urna'], ['KREMERING_EFTER_CEREMONI', 'Kremering efter ceremoni'], ['INGEN_CEREMONI', 'Ingen ceremoni']]),
          EnumSortValues: new Map([['AKT_MED_URNA', 'A'], ['KREMERING_EFTER_CEREMONI', 'E'], ['INGEN_CEREMONI', 'I']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AKT_MED_URNA=Akt med urna;KREMERING_EFTER_CEREMONI=Kremering efter ceremoni;INGEN_CEREMONI=Ingen ceremoni"',
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEST_KREMATORIUM: {
          AttributeName: 'BEST_KREMATORIUM',
          DisplayLabel: 'Krematorium',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEST_KREM_DATUM: {
          AttributeName: 'BEST_KREM_DATUM',
          DisplayLabel: 'Beställd kremationsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Visning: {
          AttributeName: 'Visning',
          DisplayLabel: 'Visning',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        GIM: {
          AttributeName: 'GIM',
          DisplayLabel: 'GIM Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TomUrnaFinns: {
          AttributeName: 'TomUrnaFinns',
          DisplayLabel: 'Tom urna finns',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        GDPRGravsDatum: {
          AttributeName: 'GDPRGravsDatum',
          DisplayLabel: 'Gravsättningsdatum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GriTransport: {
          AttributeName: 'GriTransport',
          DisplayLabel: 'Gravsättningsdatum transport',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        StatusTomUrna: {
          AttributeName: 'StatusTomUrna',
          DisplayLabel: 'Endast tom urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        INTYG_ML: {
          AttributeName: 'INTYG_ML',
          DisplayLabel: 'Medgivande ML/AL',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        INTYG_DIREKT: {
          AttributeName: 'INTYG_DIREKT',
          DisplayLabel: 'Intyg direktkremation',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        INTYG_GRAVOPPNING: {
          AttributeName: 'INTYG_GRAVOPPNING',
          DisplayLabel: 'Medgivande gravöppning',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        KREMERING_ANNAN_ORT: {
          AttributeName: 'KREMERING_ANNAN_ORT',
          DisplayLabel: 'Kremering annan ort',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        AktUrna: {
          AttributeName: 'AktUrna',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BegrByra: {
          AttributeName: 'BegrByra',
          DisplayLabel: 'Begravningsbyrå',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AnhorigID: {
          AttributeName: 'AnhorigID',
          DisplayLabel: 'Anhörig',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Krematorium_ID: {
          AttributeName: 'Krematorium_ID',
          DisplayLabel: 'Krematorium ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Krematorium: {
          AttributeName: 'Krematorium',
          DisplayLabel: 'Krematorium',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Kremation',
        },
        TransportorID: {
          AttributeName: 'TransportorID',
          DisplayLabel: 'Transpotör ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KGARD_ID: {
          AttributeName: 'KGARD_ID',
          DisplayLabel: 'Kyrkogård',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KVARTER_LOPNR: {
          AttributeName: 'KVARTER_LOPNR',
          DisplayLabel: 'Kvarter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVDELNING_ID: {
          AttributeName: 'AVDELNING_ID',
          DisplayLabel: 'Avdelning',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRAVPLATSNR: {
          AttributeName: 'GRAVPLATSNR',
          DisplayLabel: 'Gravnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        Kvarter: {
          AttributeName: 'Kvarter',
          DisplayLabel: 'Benämning kyrkogård/kvarter/avdelning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktIDB: {
          AttributeName: 'AktIDB',
          DisplayLabel: 'AktIDB',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktIDG: {
          AttributeName: 'AktIDG',
          DisplayLabel: 'AktIDG',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TransportAkt: {
          AttributeName: 'TransportAkt',
          DisplayLabel: 'TransportAkt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        TransportAska: {
          AttributeName: 'TransportAska',
          DisplayLabel: 'TransportAska',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        TransportKista: {
          AttributeName: 'TransportKista',
          DisplayLabel: 'TransportKista',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifNone',
        },
        TUTSKRIVEN_DATUM: {
          AttributeName: 'TUTSKRIVEN_DATUM',
          DisplayLabel: 'Transportlista utskriven',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TransportGravsPlats: {
          AttributeName: 'TransportGravsPlats',
          DisplayLabel: 'Transport Gravsättningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TransportBegrPlats: {
          AttributeName: 'TransportBegrPlats',
          DisplayLabel: 'Transport Begravningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TransportPlats: {
          AttributeName: 'TransportPlats',
          DisplayLabel: 'Transportplats',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVLIDEN_REF_ID: {
          AttributeName: 'AVLIDEN_REF_ID',
          DisplayLabel: 'Avliden',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GravsUtanForvaltning: {
          AttributeName: 'GravsUtanForvaltning',
          DisplayLabel: 'Gravsättningsort utanför förvaltning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        TransportMinneslund: {
          AttributeName: 'TransportMinneslund',
          DisplayLabel: 'Gravplats minneslund',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        LopNrHandelse: {
          AttributeName: 'LopNrHandelse',
          DisplayLabel: 'Löpnummer senaste händelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LopNrHandelse2: {
          AttributeName: 'LopNrHandelse2',
          DisplayLabel: 'Löpnummer senaste händelse',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BegrByraKontakt: {
          AttributeName: 'BegrByraKontakt',
          DisplayLabel: 'Begravningsbyrå kontakt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTALDAGAR_START: {
          AttributeName: 'ANTALDAGAR_START',
          DisplayLabel: 'Första incheckning',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        ANTALDAGAR_SLUT: {
          AttributeName: 'ANTALDAGAR_SLUT',
          DisplayLabel: 'Första utcheckning',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SEKRETESSMARKERAD: {
          AttributeName: 'SEKRETESSMARKERAD',
          DisplayLabel: 'Sekretessmarkerad av förvaltningen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="L=Tillfälligt spärrad"',
          GUIEditable: true,
          MaxInputLength: 1,
          Properties: new Map([['UsesMask', 'Y']]),
        },
        MaskValuesExtern: {
          AttributeName: 'MaskValuesExtern',
          DisplayLabel: 'Dolda uppgifter (person)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifFilter',
          Properties: new Map([['UsesMask', 'Y']]),
        },
        MaskTypeExtern: {
          AttributeName: 'MaskTypeExtern',
          DisplayLabel: 'Sekretessmarkerad av Skatteverket',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="S=Sekretess;P=Skyddad"',
          InterfaceType: 'ifChecklist',
          Properties: new Map([['UsesMask', 'Y']]),
        },
      },
      Associations: {
        Begravningsbyra: {
          AssociationName: 'Begravningsbyra',
          DisplayLabel: 'Begravningsbyrå',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON2,Adress.TELEFAX,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Organisationsnummer",OrgNrPersNr="Organisationsnummer",OP_Namn="Namn",G:*="Begravningsbyrå",PREFIX:*="Begravningsbyrå ";'], ['NOT_ATAGANDE', 'Y']]),
        },
        Kremation: {
          AssociationName: 'Kremation',
          DisplayLabel: 'Kremation',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KJKremation',
          AssociatedComponentName: 'Kremationsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravning2: {
          AssociationName: 'Begravning2',
          DisplayLabel: 'Begravning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Begravning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Gravsattning2: {
          AssociationName: 'Gravsattning2',
          DisplayLabel: 'Gravsattning',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Gravsattning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bisattning: {
          AssociationName: 'Bisattning',
          DisplayLabel: 'Bisättning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattning',
          AssociatedComponentName: 'Bisattningsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Begravning: {
          AssociationName: 'Begravning',
          DisplayLabel: 'Begravning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Begravning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['IntegratedFilter', 'Begravningsdatum,Begravningstid,Begravningsplats;'], ['OverrideDisplayLabels', 'Begravningsdatum="Datum",Begravningstid="Tid",Begravningsplats="Plats", G:*="Begravning";'], ['NOT_ATAGANDE', 'Y']]),
        },
        Gravsattning: {
          AssociationName: 'Gravsattning',
          DisplayLabel: 'Gravsättning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Gravsattning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anhorig: {
          AssociationName: 'Anhorig',
          DisplayLabel: 'Anhörig',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnFE,NamnME,FORNAMN,FULLST_FORNAMN,FullstFornamn,Fodelsedatum,Fodelsear,PersNrKon,LKF,LKF_BENAMNING,KYRKOLKF,KYRKOLKF_BENAMNING,LKFStatus,Forsamlingsbo,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,MEDLEMSKOD,Tvist.TVIST_GRAVS,Tvist.TVIST_KREM,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Personnummer",OrgNrPersNr="Personnummer",OP_Namn="Efternamn",NamnME="Efternamn",G:*="Anhörig",PREFIX:*="Anhörig ";'], ['NOT_ATAGANDE', 'Y']]),
        },
        Transportor: {
          AssociationName: 'Transportor',
          DisplayLabel: 'Transportör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'OP_NR,OrgNrPersNr,OP_Namn,Namn,NamnAdress,NamnAdressRad,NamnAdressTelefon,NamnAdressTelefonRad,Adress.ADRESS,Adress.POSTNR,Adress.ORT,Adress.Postadress,Adress.KompaktAdress,Adress.KompaktAdressRad,Adress.TELEFON1,Adress.TELEFON2,Adress.TELEFAX,Adress.SMTP1;'], ['OverrideDisplayLabels', 'OP_NR="Organisationsnummer",OrgNrPersNr="Organisationsnummer",OP_Namn="Namn",G:*="Transportör",PREFIX:*="Transportör ";'], ['NOT_ATAGANDE', 'Y']]),
        },
        Avlidna: {
          AssociationName: 'Avlidna',
          DisplayLabel: 'Avlidna',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPAvliden',
          AssociatedComponentName: 'Avliden',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['IntegratedFilter', 'OP_NR;'], ['OverrideDisplayLabels', 'Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.PERS_NR="Personnummer",Avlidna.Person.OP_Namn="Efternamn",Avlidna.Person.NamnME="Efternamn",G:Person="";']]),
        },
        SenasteHandelse: {
          AssociationName: 'SenasteHandelse',
          DisplayLabel: 'Senaste händelse (som inte är tomurna)',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningshandelse',
          AssociatedComponentName: 'Bisattningshandelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        SenasteHandelse2: {
          AssociationName: 'SenasteHandelse2',
          DisplayLabel: 'Senaste händelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningshandelse',
          AssociatedComponentName: 'Bisattningshandelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BegravningsbyraKontakt: {
          AssociationName: 'BegravningsbyraKontakt',
          DisplayLabel: 'Begravningsbyrå kontakt',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattningKontakt',
          AssociatedComponentName: 'BisattningsKontaktOrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Bestallning: {
          AssociationName: 'Bestallning',
          DisplayLabel: 'Beställning',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattningBestallning',
          AssociatedComponentName: 'BisattningBestallning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelse',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningshandelse',
          AssociatedComponentName: 'Bisattningshandelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Kontakter: {
          AssociationName: 'Kontakter',
          DisplayLabel: 'Kontakter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattningKontakt',
          AssociatedComponentName: 'BisattningsKontaktOrgPers',
          JoinAssociation: false,
          ValidInComps: ['BisattningsKontakt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattningActiveX',
          AssociatedComponentName: 'BisattningActiveX',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        BisattningOrder: {
          AssociationName: 'BisattningOrder',
          DisplayLabel: 'Order',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOTEDBOBisattningOrder',
          AssociatedComponentName: 'BisattningOrder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Utskick: {
          AssociationName: 'Utskick',
          DisplayLabel: 'Utskick',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBisattningslokaluser: {
      CollectionName: 'BOBisattningslokaluser',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BisättningslokalUser',
        Abstract: false,
        SOLabel: 'Bisättningslokalanvändare',
        SOGLabel: 'Bisättningslokalanvändares',
        SBLabel: 'Bisättningslokalanvändaren',
        SBGLabel: 'Bisättningslokalanvändarens',
        POLabel: 'Bisättningslokalanvändare',
        POGLabel: 'Bisättningslokalanvändares',
        PBLabel: 'Bisättningslokalanvändarna',
        PBGLabel: 'Bisättningslokalanvändarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningslokalanvändarens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningslokalanvändarens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningslokalanvändarens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lokal: {
          AssociationName: 'Lokal',
          DisplayLabel: 'Lokal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningslokal',
          AssociatedComponentName: 'Bisattningslokal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Transportor: {
          AssociationName: 'Transportor',
          DisplayLabel: 'Transportör',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOBisattningslokal: {
      CollectionName: 'BOBisattningslokal',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bisattningslokal',
        Abstract: false,
        SOLabel: 'Bisättningslokal',
        SOGLabel: 'Bisättningslokals',
        SBLabel: 'Bisättningslokalen',
        SBGLabel: 'Bisättningslokalens',
        POLabel: 'Bisättningslokaler',
        POGLabel: 'Bisättningslokalers',
        PBLabel: 'Bisättningslokalerna',
        PBGLabel: 'Bisättningslokalernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningslokalens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningslokalens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bisättningslokalens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningslokalens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True'], ['ffMaskedValue', 'Y']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MAX_ANTAL_KISTOR: {
          AttributeName: 'MAX_ANTAL_KISTOR',
          DisplayLabel: 'Max antal kistor',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Rum: {
          AssociationName: 'Rum',
          DisplayLabel: 'Rum',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningsrum',
          AssociatedComponentName: 'Bisattningsrum',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOTEDBOBisattningOrder: {
      CollectionName: 'BOTEDBOBisattningOrder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BisattningOrder',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Bisättningsordrar',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOTEDBOBisattningOrders primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOTEDBOBisattningOrders versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'BOTEDBOBisattningOrders id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOTEDBOBisattningOrders fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BISATTNINGSJOURNAL_ID: {
          AttributeName: 'BISATTNINGSJOURNAL_ID',
          DisplayLabel: 'BisattningsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDER_ID: {
          AttributeName: 'ORDER_ID',
          DisplayLabel: 'OrderID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Status: {
          AttributeName: 'Status',
          DisplayLabel: 'Status',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Fakturanr: {
          AttributeName: 'Fakturanr',
          DisplayLabel: 'Fakturanr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        NormalOrder: {
          AssociationName: 'NormalOrder',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOBisattningspos: {
      CollectionName: 'BOBisattningspos',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Bisattningspos',
        Abstract: false,
        SOLabel: 'Bisättningsposition',
        SOGLabel: 'Bisättningspositions',
        SBLabel: 'Bisättningspositionen',
        SBGLabel: 'Bisättningspositionens',
        POLabel: 'Bisättningspositioner',
        POGLabel: 'Bisättningspositioners',
        PBLabel: 'Bisättningspositionerna',
        PBGLabel: 'Bisättningspositionernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningspositionens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningspositionens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningspositionens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEL_ID: {
          AttributeName: 'DEL_ID',
          DisplayLabel: 'Del',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RAD: {
          AttributeName: 'RAD',
          DisplayLabel: 'Rad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        KOLUMN: {
          AttributeName: 'KOLUMN',
          DisplayLabel: 'Kolumn',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 15,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ORDNING: {
          AttributeName: 'ORDNING',
          DisplayLabel: 'Ordning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AntalPositionerUrna: {
          AttributeName: 'AntalPositionerUrna',
          DisplayLabel: 'Antal positioner urna',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        AntalPositionerKista: {
          AttributeName: 'AntalPositionerKista',
          DisplayLabel: 'Antal positioner kista',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        Upptagen: {
          AttributeName: 'Upptagen',
          DisplayLabel: 'Upptagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Del: {
          AssociationName: 'Del',
          DisplayLabel: 'Del',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningsrumdel',
          AssociatedComponentName: 'Bisattningsrumdel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOBisattningsrum: {
      CollectionName: 'BOBisattningsrum',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '20001']]),
      RootType: {
        TypeValue: 'Bisattningsrum',
        Abstract: false,
        SOLabel: 'Bisättningsrum',
        SOGLabel: 'Bisättningsrums',
        SBLabel: 'Bisättningsrummet',
        SBGLabel: 'Bisättningsrummets',
        POLabel: 'Bisättningsrummen',
        POGLabel: 'Bisättningsrummens',
        PBLabel: 'Bisättningsrum',
        PBGLabel: 'Bisättningsrums',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningsrummets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningsrummets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningsrummets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOKAL_ID: {
          AttributeName: 'LOKAL_ID',
          DisplayLabel: 'Lokal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        STANGS_TI: {
          AttributeName: 'STANGS_TI',
          DisplayLabel: 'Rum stängs fr.o.m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PRIORITET: {
          AttributeName: 'PRIORITET',
          DisplayLabel: 'Prioritet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AUTOPLACERING: {
          AttributeName: 'AUTOPLACERING',
          DisplayLabel: 'Autoplacering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FULL_BENAMNING: {
          AttributeName: 'FULL_BENAMNING',
          DisplayLabel: 'Visa hela benämningen i placeringen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'Id, resurs',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Kista/Urna',
          DataType: 'Enum',
          EnumValues: new Map([['KISTA', 'Kista'], ['URNA', 'Urna']]),
          EnumSortValues: new Map([['KISTA', 'K'], ['URNA', 'U']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="KISTA=Kista;URNA=Urna"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Del: {
          AssociationName: 'Del',
          DisplayLabel: 'Del',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningsrumdel',
          AssociatedComponentName: 'Bisattningsrumdel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBisattningstyp: {
      CollectionName: 'BOBisattningstyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '20001']]),
      RootType: {
        TypeValue: 'Bisattningstyp',
        Abstract: false,
        SOLabel: 'Bisättningstyp',
        SOGLabel: 'Bisättningstyps',
        SBLabel: 'Bisättningstypen',
        SBGLabel: 'Bisättningstypens',
        POLabel: 'Bisättningstyper',
        POGLabel: 'Bisättningstypers',
        PBLabel: 'Bisättningstyperna',
        PBGLabel: 'Bisättningstypernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bisättningstypens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bisättningstypens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bisättningstypens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True'], ['ffMaskedValue', 'Y']]),
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTIV: {
          AttributeName: 'AKTIV',
          DisplayLabel: 'Aktiv',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Etikett: {
          AttributeName: 'Etikett',
          DisplayLabel: 'Etikett',
          Hint: 'Kistetikett (60x90)/Urnetikett (30x90)/QRkod med Persnr/QRkod med namn/ML (30x90)/ML (60x90)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="Kistetikett (60x90)=K;Urnetikett (30x90)=U;QRkod med Persnr=LP;QRkod med namn=LN;ML (30x90)=ML;ML (60x90)=M "',
          FormatterDisplayParams: 'TranslateValues="K=Kistetikett (60x90);U=Urnetikett (30x90);LP=QRkod med Persnr;LN=QRkod med namn;ML=ML (30x90);M=ML (60x90) "',
          FormatterValidateParams: 'ValidValues="LP;LN;K;M;ML;U;[BLANK]"',
          GUIEditable: true,
          MaxInputLength: 19,
          InterfaceType: 'ifTypeTree',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOBokning: {
      CollectionName: 'BOBokning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '1029'], ['AllowEdit', '1039'], ['AllowSelection', '16001']]),
      RootType: {
        TypeValue: 'Bokning',
        Abstract: false,
        SOLabel: 'Bokning',
        SOGLabel: 'Bokning',
        SBLabel: 'Bokningen',
        SBGLabel: 'Bokningen',
        POLabel: 'Bokningar',
        POGLabel: 'Bokningar',
        PBLabel: 'Bokningarna',
        PBGLabel: 'Bokningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokningen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNRUBRIK_LOPNR: {
          AttributeName: 'BOKNRUBRIK_LOPNR',
          DisplayLabel: 'Bokningsrubriklöpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        ShortText: {
          AttributeName: 'ShortText',
          DisplayLabel: 'ShortText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LongText: {
          AttributeName: 'LongText',
          DisplayLabel: 'LongText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ResursNamn: {
          AttributeName: 'ResursNamn',
          DisplayLabel: 'ResursNamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['UsesAssociations', 'BoknRub;']]),
        },
        ResursID: {
          AttributeName: 'ResursID',
          DisplayLabel: 'ResursID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['UsesAssociations', 'BoknRub;']]),
        },
        ResursRubrik: {
          AttributeName: 'ResursRubrik',
          DisplayLabel: 'ResursRubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['UsesAssociations', 'BoknRub;']]),
        },
        TypAvBokning: {
          AttributeName: 'TypAvBokning',
          DisplayLabel: 'TypAvBokning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ShortTextNoTime: {
          AttributeName: 'ShortTextNoTime',
          DisplayLabel: 'ShortTextNoTime',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktTidFr: {
          AttributeName: 'AktTidFr',
          DisplayLabel: 'Aktivitetstid fr.o.m.',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktTidTi: {
          AttributeName: 'AktTidTi',
          DisplayLabel: 'Aktivitetstid t.o.m.',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktivitetCaption: {
          AttributeName: 'AktivitetCaption',
          DisplayLabel: 'Aktivitetsrubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ExternalText: {
          AttributeName: 'ExternalText',
          DisplayLabel: 'Extern text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FranDatumTid: {
          AttributeName: 'FranDatumTid',
          DisplayLabel: 'Från datum och tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        TillDatumTid: {
          AttributeName: 'TillDatumTid',
          DisplayLabel: 'Till datum och tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        Pos1: {
          AttributeName: 'Pos1',
          DisplayLabel: 'Pos1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EnkelExternalText: {
          AttributeName: 'EnkelExternalText',
          DisplayLabel: 'EnkelExternalText',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        BoknRub: {
          AssociationName: 'BoknRub',
          DisplayLabel: 'Bokningsrubrik',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'Resurs,Resursrubrik;']]),
        },
        BokAkt: {
          AssociationName: 'BokAkt',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Rubrik1: {
          AssociationName: 'Rubrik1',
          DisplayLabel: 'Rubrik1',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOXBridge: {
      CollectionName: 'BOXBridge',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'XBridge',
        Abstract: false,
        SOLabel: 'Bokning',
        SOGLabel: 'Boknings',
        SBLabel: 'Bokningen',
        SBGLabel: 'Bokningens',
        POLabel: 'Bokningar',
        POGLabel: 'Bokningars',
        PBLabel: 'Bokningarna',
        PBGLabel: 'Bokningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'Resurs-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XB_ID: {
          AttributeName: 'XB_ID',
          DisplayLabel: 'Externt ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XB_VER: {
          AttributeName: 'XB_VER',
          DisplayLabel: 'Externt versions-ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XB_EMAIL: {
          AttributeName: 'XB_EMAIL',
          DisplayLabel: 'Extern epost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNINGSNUMMER: {
          AttributeName: 'BOKNINGSNUMMER',
          DisplayLabel: 'Bokningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_NAMN: {
          AttributeName: 'RESURS_NAMN',
          DisplayLabel: 'Resurs',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SENAST_SKICKAD: {
          AttributeName: 'SENAST_SKICKAD',
          DisplayLabel: 'Publicerad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SENAST_SKICKAD_FEL: {
          AttributeName: 'SENAST_SKICKAD_FEL',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOBoknGruppResurs: {
      CollectionName: 'BOBoknGruppResurs',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BoknGruppResurs',
        Abstract: false,
        SOLabel: 'Bokningsgrupp av resurser',
        SOGLabel: 'Bokningsgrupp av resurser',
        SBLabel: 'Bokningsgruppen av resurserna',
        SBGLabel: 'Bokningsgruppen av resurserna',
        POLabel: 'Bokningsgrupper av resurser',
        POGLabel: 'Bokningsgrupper av resurser',
        PBLabel: 'Bokningsgrupperna av resurser',
        PBGLabel: 'Bokningsgrupperna av resurser',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokningsgruppen av resurserna primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokningsgruppen av resurserna versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokningsgruppen av resurserna id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokningsgruppen av resurserna fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ResursID: {
          AttributeName: 'ResursID',
          DisplayLabel: 'ResursID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ResursNamn: {
          AttributeName: 'ResursNamn',
          DisplayLabel: 'Resursnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ResursTyp: {
          AttributeName: 'ResursTyp',
          DisplayLabel: 'Resurstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Bokningsgrupp: {
          AttributeName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Resursnamn2: {
          AttributeName: 'Resursnamn2',
          DisplayLabel: 'Resursnamn2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Bokningsgrupp: {
          AssociationName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokngrupp',
          AssociatedComponentName: 'Bokngrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOBokningsrubrik: {
      CollectionName: 'BOBokningsrubrik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BokningsRubrik',
        Abstract: false,
        SOLabel: 'Bokningsrubrik',
        SOGLabel: 'Bokningsrubrik',
        SBLabel: 'Bokningsrubriken',
        SBGLabel: 'Bokningsrubriken',
        POLabel: 'Bokningsrubriker',
        POGLabel: 'Bokningsrubriker',
        PBLabel: 'Bokningsrubrikerna',
        PBGLabel: 'Bokningsrubrikerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Bokningsrubriken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Bokningsrubriken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Bokningsrubriken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Bokningsrubriken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'Resurs-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_NAMN: {
          AttributeName: 'RESURS_NAMN',
          DisplayLabel: 'Resursnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        AKTRESRUB_AKT_ID: {
          AttributeName: 'AKTRESRUB_AKT_ID',
          DisplayLabel: 'AktresrubriksAktID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTRESRUB_POSNR: {
          AttributeName: 'AKTRESRUB_POSNR',
          DisplayLabel: 'AktresrubriksPosNr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod (typ av bokning)',
          Hint: 'Endagsbokning/Flerdagsbokning/Upprepad bokning (datum och tidsintervall)',
          DataType: 'Enum',
          EnumValues: new Map([['ENDAGSBOKNING', 'Endagsbokning'], ['FLERDAGSBOKNING', 'Flerdagsbokning'], ['UPPREPAD_BOKNING__DATUM_OCH_TIDSINTERVALL_', 'Upprepad bokning (datum och tidsintervall)']]),
          EnumSortValues: new Map([['ENDAGSBOKNING', 'E'], ['FLERDAGSBOKNING', 'F'], ['UPPREPAD_BOKNING__DATUM_OCH_TIDSINTERVALL_', 'T']]),
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENDAGSBOKNING=Endagsbokning;FLERDAGSBOKNING=Flerdagsbokning;UPPREPAD_BOKNING__DATUM_OCH_TIDSINTERVALL_=Upprepad bokning (datum och tidsintervall)"',
          InterfaceType: 'ifChecklist',
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Fråndatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TILLDATUM: {
          AttributeName: 'TILLDATUM',
          DisplayLabel: 'Tilldatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TIDSTEXT: {
          AttributeName: 'TIDSTEXT',
          DisplayLabel: 'Tidstext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
        },
        OUTLOOK_PAMINNELSE: {
          AttributeName: 'OUTLOOK_PAMINNELSE',
          DisplayLabel: 'Påminnelsetid i Outlook',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          FormatterParseParams: 'Unsigned="Y"',
          FormatterDisplayParams: 'Unsigned="Y"',
          FormatterValidateParams: 'MinRecommendedValue="0";MaxRecommendedValue="10080"',
        },
        ResursIDNamn: {
          AttributeName: 'ResursIDNamn',
          DisplayLabel: 'Resursnamn och ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Tid: {
          AttributeName: 'Tid',
          DisplayLabel: 'Tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ResursRubrik2: {
          AttributeName: 'ResursRubrik2',
          DisplayLabel: 'Resursrubrik2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Resursrubrik: {
          AttributeName: 'Resursrubrik',
          DisplayLabel: 'Resursrubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        PosNr: {
          AttributeName: 'PosNr',
          DisplayLabel: 'PosNr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Telefon: {
          AttributeName: 'Telefon',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Telefon2: {
          AttributeName: 'Telefon2',
          DisplayLabel: 'Telefon2',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TelefonArbete: {
          AttributeName: 'TelefonArbete',
          DisplayLabel: 'Telefon arbete',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Mobiltelefon: {
          AttributeName: 'Mobiltelefon',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ResursNamnExternt: {
          AttributeName: 'ResursNamnExternt',
          DisplayLabel: 'Externt resursnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        XB_ID: {
          AttributeName: 'XB_ID',
          DisplayLabel: 'XBridge, ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        XB_VER: {
          AttributeName: 'XB_VER',
          DisplayLabel: 'XBridge, version',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        XB_EMAIL: {
          AttributeName: 'XB_EMAIL',
          DisplayLabel: 'XBridge, email',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        XB_SENT_TIME: {
          AttributeName: 'XB_SENT_TIME',
          DisplayLabel: 'XBridge, senast synkroniserad',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        VARME_STANDARD: {
          AttributeName: 'VARME_STANDARD',
          DisplayLabel: 'Värme Standard',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        VarmeInst: {
          AttributeName: 'VarmeInst',
          DisplayLabel: 'Värmeinställning',
          Hint: 'Standardvärme/Ingen uppvärmning/Stabil luftfuktighet/Städtemperatur/Valfri temperatur',
          DataType: 'Enum',
          EnumValues: new Map([['STANDARDVARME', 'Standardvärme'], ['INGEN_UPPVARMNING', 'Ingen uppvärmning'], ['STABIL_LUFTFUKTIGHET', 'Stabil luftfuktighet'], ['STADTEMPERATUR', 'Städtemperatur'], ['VALFRI_TEMPERATUR', 'Valfri temperatur']]),
          EnumSortValues: new Map([['STANDARDVARME', 'Y'], ['INGEN_UPPVARMNING', 'N'], ['STABIL_LUFTFUKTIGHET', 'F'], ['STADTEMPERATUR', 'S'], ['VALFRI_TEMPERATUR', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="STANDARDVARME=Standardvärme;INGEN_UPPVARMNING=Ingen uppvärmning;STABIL_LUFTFUKTIGHET=Stabil luftfuktighet;STADTEMPERATUR=Städtemperatur;VALFRI_TEMPERATUR=Valfri temperatur"',
          InterfaceType: 'ifChecklist',
        },
        VarmeTemp: {
          AttributeName: 'VarmeTemp',
          DisplayLabel: 'Värmeinställning, valfri temp.',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FlexLedighet: {
          AttributeName: 'FlexLedighet',
          DisplayLabel: 'Ledighet i Flex',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DatumOchTid: {
          AttributeName: 'DatumOchTid',
          DisplayLabel: 'Datum och tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SKKPubl: {
          AttributeName: 'SKKPubl',
          DisplayLabel: 'Publiceras på webb',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        Bastyp: {
          AttributeName: 'Bastyp',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
        FranDatumTid: {
          AttributeName: 'FranDatumTid',
          DisplayLabel: 'Från datum och tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        TillDatumTid: {
          AttributeName: 'TillDatumTid',
          DisplayLabel: 'Till datum och tid',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatDateTime',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktResRubrik: {
          AssociationName: 'AktResRubrik',
          DisplayLabel: 'Aktivitetens resursrubriker',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitetResrubrik',
          AssociatedComponentName: 'AktivitetResrubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokningar: {
          AssociationName: 'Bokningar',
          DisplayLabel: 'Bokningar',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBokning',
          AssociatedComponentName: 'Bokning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        FaktOmgRad: {
          AssociationName: 'FaktOmgRad',
          DisplayLabel: 'FaktOmgRad',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOFaktOmgOrdrad',
          AssociatedComponentName: 'FaktOmgOrdrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOXBBorttagen: {
      CollectionName: 'BOXBBorttagen',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'XBBorttagen',
        Abstract: false,
        SOLabel: 'Borttagen i XBridge',
        SOGLabel: 'Borttagen i XBridge',
        SBLabel: 'Borttagen i XBridge',
        SBGLabel: 'Borttagen i XBridge',
        POLabel: 'Borttagen i XBridge',
        POGLabel: 'Borttagen i XBridge',
        PBLabel: 'Borttagen i XBridge',
        PBGLabel: 'Borttagen i XBridge',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Borttagen i XBridge primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Borttagen i XBridge versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Borttagen i XBridge fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XB_ID: {
          AttributeName: 'XB_ID',
          DisplayLabel: 'XBridge, ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        XB_VER: {
          AttributeName: 'XB_VER',
          DisplayLabel: 'XBridge, version',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        XB_EMAIL: {
          AttributeName: 'XB_EMAIL',
          DisplayLabel: 'XBridge, email',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        FEL: {
          AttributeName: 'FEL',
          DisplayLabel: 'Misslyckade försök',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOAktDigitalaVisningar: {
      CollectionName: 'BOAktDigitalaVisningar',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktDigitalaVisningar',
        Abstract: false,
        SOLabel: 'Digital visning',
        SOGLabel: 'Digital visnings',
        SBLabel: 'Digitala visningen',
        SBGLabel: 'Digitala visningens',
        POLabel: 'Digitala visningar',
        POGLabel: 'Digitala visningars',
        PBLabel: 'Digitala visningarna',
        PBGLabel: 'Digitala visningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Digitala visningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Digitala visningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Digitala visningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VISNINGAR_TOTAL: {
          AttributeName: 'VISNINGAR_TOTAL',
          DisplayLabel: 'Antal totala visningar',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VISNINGAR_FACEBOOK: {
          AttributeName: 'VISNINGAR_FACEBOOK',
          DisplayLabel: 'Antal Facebook visningar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VISNINGAR_YOUTUBE: {
          AttributeName: 'VISNINGAR_YOUTUBE',
          DisplayLabel: 'Antal Youtube visningar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VISNINGAR_VIMEO: {
          AttributeName: 'VISNINGAR_VIMEO',
          DisplayLabel: 'Antal Vimeo visningar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VISNINGAR_OVRIG: {
          AttributeName: 'VISNINGAR_OVRIG',
          DisplayLabel: 'Antal övriga visningar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOBisattningActiveX: {
      CollectionName: 'BOBisattningActiveX',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BisattningActiveX',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Bisättningsjournal dokument',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOBisattningActiveXs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOBisattningActiveXs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOBisattningActiveXs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BISATTNINGSJOURNAL_ID: {
          AttributeName: 'BISATTNINGSJOURNAL_ID',
          DisplayLabel: 'Id bisättningsjournal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        DATASIZE: {
          AttributeName: 'DATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOAktivitetDok: {
      CollectionName: 'BOAktivitetDok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['UseRawFileData', 'Y']]),
      RootType: {
        TypeValue: 'AktivitetDok',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ApplicationIdentifier: {
          AttributeName: 'ApplicationIdentifier',
          DisplayLabel: 'Applikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FileIdentifier: {
          AttributeName: 'FileIdentifier',
          DisplayLabel: 'Filidentifikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOResursDok: {
      CollectionName: 'BOResursDok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['UseRawFileData', 'Y']]),
      RootType: {
        TypeValue: 'ResursDok',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        OLECLASSNAME: {
          AttributeName: 'OLECLASSNAME',
          DisplayLabel: 'OLE klassnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BINARDATA: {
          AttributeName: 'BINARDATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BINARDATASIZE: {
          AttributeName: 'BINARDATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ApplicationIdentifier: {
          AttributeName: 'ApplicationIdentifier',
          DisplayLabel: 'Applikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FileIdentifier: {
          AttributeName: 'FileIdentifier',
          DisplayLabel: 'Filidentifikation',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOKremBestDok: {
      CollectionName: 'BOKremBestDok',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'KremBestDok',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokument',
        SBGLabel: 'Dokument',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokument',
        PBGLabel: 'Dokument',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokument primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokument versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokument fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BestID: {
          AttributeName: 'BestID',
          DisplayLabel: 'Beställnings id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FILNAMN: {
          AttributeName: 'FILNAMN',
          DisplayLabel: 'Filnamn (länk)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_ANDRAD: {
          AttributeName: 'SENAST_ANDRAD',
          DisplayLabel: 'Senast ändrad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        DATASIZE: {
          AttributeName: 'DATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOSKS: {
      CollectionName: 'BOSKS',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SKS',
        Abstract: false,
        SOLabel: 'Exporterad statistik',
        SOGLabel: 'Exporterad statistiks',
        SBLabel: 'Exporterade statistiken',
        SBGLabel: 'Exporterade statistikens',
        POLabel: 'Exporterad statistik',
        POGLabel: 'Exporterad statistiks',
        PBLabel: 'Exporterade statistiken',
        PBGLabel: 'Exporterade statistikens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Exporterade statistikens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Exporterade statistikens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Exporterade statistikens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_ID: {
          AttributeName: 'AKT_ID',
          DisplayLabel: 'Aktivitets-ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTERNAL_KEY: {
          AttributeName: 'EXTERNAL_KEY',
          DisplayLabel: 'Externt ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SENAST_SKICKAD_OK: {
          AttributeName: 'SENAST_SKICKAD_OK',
          DisplayLabel: 'Skickad godkänd datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SENAST_SKICKAD_ERR: {
          AttributeName: 'SENAST_SKICKAD_ERR',
          DisplayLabel: 'Skickad ej godkänd datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SENAST_ERRMSG: {
          AttributeName: 'SENAST_ERRMSG',
          DisplayLabel: 'Felmeddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BOKNINGSNUMMER: {
          AttributeName: 'BOKNINGSNUMMER',
          DisplayLabel: 'Bokningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOFaktOmg: {
      CollectionName: 'BOFaktOmg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['GroupAssociation', 'Faktureringsgrupp']]),
      RootType: {
        TypeValue: 'FaktOmg',
        Abstract: false,
        SOLabel: 'Fakturaunderlag',
        SOGLabel: 'Fakturaunderlag',
        SBLabel: 'Fakturaunderlaget',
        SBGLabel: 'Fakturaunderlaget',
        POLabel: 'Fakturaunderlag',
        POGLabel: 'Fakturaunderlag',
        PBLabel: 'Fakturaunderlagen',
        PBGLabel: 'Fakturaunderlagen',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturaunderlaget primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturaunderlaget versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturaunderlaget id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturaunderlaget fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRISLISTA_ID: {
          AttributeName: 'PRISLISTA_ID',
          DisplayLabel: 'Prislista id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Faktureringsunderlags nummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          Required: true,
          MaskedValue: true,
        },
        TEXT: {
          AttributeName: 'TEXT',
          DisplayLabel: 'Fakturarubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'Kund',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Order skapad/Ej order skapad',
          DataType: 'Enum',
          EnumValues: new Map([['ORDER_SKAPAD', 'Order skapad'], ['EJ_ORDER_SKAPAD', 'Ej order skapad']]),
          EnumSortValues: new Map([['ORDER_SKAPAD', 'F'], ['EJ_ORDER_SKAPAD', 'E']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ORDER_SKAPAD=Order skapad;EJ_ORDER_SKAPAD=Ej order skapad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEVAKNDAT: {
          AttributeName: 'BEVAKNDAT',
          DisplayLabel: 'Bevakningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        VARREFERENS: {
          AttributeName: 'VARREFERENS',
          DisplayLabel: 'Vår referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        AKTUELLAPRISER: {
          AttributeName: 'AKTUELLAPRISER',
          DisplayLabel: 'Aktuella priser',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
        },
        KUNDREFERENS: {
          AttributeName: 'KUNDREFERENS',
          DisplayLabel: 'Kundens referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        CLEARING: {
          AttributeName: 'CLEARING',
          DisplayLabel: 'Clearing',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifBoolean',
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKAPAD_SIGNATUR: {
          AttributeName: 'SKAPAD_SIGNATUR',
          DisplayLabel: 'Skapad signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FORRATTNINGSTYP: {
          AttributeName: 'FORRATTNINGSTYP',
          DisplayLabel: 'Förrättningstyp',
          Hint: 'Begravning/Vigsel/Konfirmation/Dop/Statlig clearing/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['BEGRAVNING', 'Begravning'], ['VIGSEL', 'Vigsel'], ['KONFIRMATION', 'Konfirmation'], ['DOP', 'Dop'], ['STATLIG_CLEARING', 'Statlig clearing'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['BEGRAVNING', '1'], ['VIGSEL', '2'], ['KONFIRMATION', '3'], ['DOP', '4'], ['STATLIG_CLEARING', '5'], ['OVRIGT', '6']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEGRAVNING=Begravning;VIGSEL=Vigsel;KONFIRMATION=Konfirmation;DOP=Dop;STATLIG_CLEARING=Statlig clearing;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          Required: true,
          MaskedValue: true,
        },
        FAKTURERINGSSATT: {
          AttributeName: 'FAKTURERINGSSATT',
          DisplayLabel: 'Faktureringssätt',
          Hint: 'Faktura/KOB',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTURA', 'Faktura'], ['KOB', 'KOB']]),
          EnumSortValues: new Map([['FAKTURA', 'F'], ['KOB', 'O']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTURA=Faktura;KOB=KOB"',
          GUIEditable: true,
          Required: true,
        },
        FAKTDELT: {
          AttributeName: 'FAKTDELT',
          DisplayLabel: 'Fakturera deltagare',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
        },
        AktTitel: {
          AttributeName: 'AktTitel',
          DisplayLabel: 'Aktivitetens titel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KundNamnAdress: {
          AttributeName: 'KundNamnAdress',
          DisplayLabel: 'Kundens namn och adress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KundNamn: {
          AttributeName: 'KundNamn',
          DisplayLabel: 'Kundens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KundNr: {
          AttributeName: 'KundNr',
          DisplayLabel: 'Kundnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        TotBelopp: {
          AttributeName: 'TotBelopp',
          DisplayLabel: 'Totala beloppet',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BokNr: {
          AttributeName: 'BokNr',
          DisplayLabel: 'Bokningsnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        AktuelltTotBelopp: {
          AttributeName: 'AktuelltTotBelopp',
          DisplayLabel: 'Aktuellt total belopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeParams: {'PrislistaID': {type: 'Int', defaultValue: ''}},
        },
        BokNr2: {
          AttributeName: 'BokNr2',
          DisplayLabel: 'BokNr2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktuelltTotBelopp2: {
          AttributeName: 'AktuelltTotBelopp2',
          DisplayLabel: 'AktuelltTotBelopp2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TotBelopp2: {
          AttributeName: 'TotBelopp2',
          DisplayLabel: 'TotBelopp2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktTidstext: {
          AttributeName: 'AktTidstext',
          DisplayLabel: 'Aktivitetens tidstext',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Akttyp: {
          AttributeName: 'Akttyp',
          DisplayLabel: 'Akttyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundMoms: {
          AttributeName: 'KundMoms',
          DisplayLabel: 'Kunden momsbelagd',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Faktureringsgrupp: {
          AttributeName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundFornamn: {
          AttributeName: 'KundFornamn',
          DisplayLabel: 'Kundens förnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        FAKT_DODSBO: {
          AttributeName: 'FAKT_DODSBO',
          DisplayLabel: 'Fakturera dödsbo',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FORFALLOTYP: {
          AttributeName: 'FORFALLOTYP',
          DisplayLabel: 'Val av förfallodatum',
          Hint: 'Inkommande/Utgående - Enligt betalningsvillkor/Ange förfallodatum',
          DataType: 'Enum',
          EnumValues: new Map([['ENLIGT_BETALNINGSVILLKOR', 'Enligt betalningsvillkor'], ['ANGE_FORFALLODATUM', 'Ange förfallodatum']]),
          EnumSortValues: new Map([['ENLIGT_BETALNINGSVILLKOR', 'B'], ['ANGE_FORFALLODATUM', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="ENLIGT_BETALNINGSVILLKOR=Enligt betalningsvillkor;ANGE_FORFALLODATUM=Ange förfallodatum"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        FORFALLODATUM: {
          AttributeName: 'FORFALLODATUM',
          DisplayLabel: 'Förfallodatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterParseParams: 'CenturyLimit=""',
          FormatterValidateParams: 'MinDate="-0m";MaxDate="+36m";MinRecommendedDate="-0m";MaxRecommendedDate="+12m"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Prislista: {
          AssociationName: 'Prislista',
          DisplayLabel: 'Prislista',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAPrislista',
          AssociatedComponentName: 'Prislista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'True']]),
        },
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'Grupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FaktOmgOrdrad: {
          AssociationName: 'FaktOmgOrdrad',
          DisplayLabel: 'FaktOmgOrdrad',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOFaktOmgOrdrad',
          AssociatedComponentName: 'FaktOmgOrdrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        AktOrder: {
          AssociationName: 'AktOrder',
          DisplayLabel: 'AktOrder',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetOrder',
          AssociatedComponentName: 'AktOrder',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOFaktOmgOrdrad: {
      CollectionName: 'BOFaktOmgOrdrad',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FaktOmgOrdrad',
        Abstract: true,
        SOLabel: 'Fakturaunderlagsrad',
        SOGLabel: 'Fakturaunderlagsrad',
        SBLabel: 'Fakturaunderlagsraden',
        SBGLabel: 'Fakturaunderlagsraden',
        POLabel: 'Fakturaunderlagsrader',
        POGLabel: 'Fakturaunderlagsrader',
        PBLabel: 'Fakturaunderlagsraderna',
        PBGLabel: 'Fakturaunderlagsraderna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'FaktOmgText',
            Abstract: false,
            SOLabel: 'Fakturatext',
            SOGLabel: 'Fakturatext',
            SBLabel: 'Fakturatexten',
            SBGLabel: 'Fakturatexten',
            POLabel: 'Fakturatexter',
            POGLabel: 'Fakturatexter',
            PBLabel: 'Fakturatexterna',
            PBGLabel: 'Fakturatexterna',
            Visible: true,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'FaktOmgArtikel',
            Abstract: false,
            SOLabel: 'Artikel',
            SOGLabel: 'Artikel',
            SBLabel: 'Artikeln',
            SBGLabel: 'Artikeln',
            POLabel: 'Artiklar',
            POGLabel: 'Artiklar',
            PBLabel: 'Artiklarna',
            PBGLabel: 'Artiklarna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturaunderlagsraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturaunderlagsraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['FAKTOMGTEXT', 'Fakturatext'], ['FAKTOMGARTIKEL', 'Artikel']]),
          EnumSortValues: new Map([['FAKTOMGTEXT', 'T'], ['FAKTOMGARTIKEL', 'A']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FAKTOMGTEXT=Fakturatext;FAKTOMGARTIKEL=Artikel"',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturaunderlagsraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturaunderlagsraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNNR: {
          AttributeName: 'ORDNNR',
          DisplayLabel: 'Ordningsnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNRUB_AKT_ID: {
          AttributeName: 'BOKNRUB_AKT_ID',
          DisplayLabel: 'Bokningsrubrik',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNRUB_LOPNR: {
          AttributeName: 'BOKNRUB_LOPNR',
          DisplayLabel: 'Bokningsrubrikens löpnummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RADKOD: {
          AttributeName: 'RADKOD',
          DisplayLabel: 'Kod',
          Hint: 'Fristående/Bokningsrubrik',
          DataType: 'Enum',
          EnumValues: new Map([['FRISTAENDE', 'Fristående'], ['BOKNINGSRUBRIK', 'Bokningsrubrik']]),
          EnumSortValues: new Map([['FRISTAENDE', 'F'], ['BOKNINGSRUBRIK', 'B']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FRISTAENDE=Fristående;BOKNINGSRUBRIK=Bokningsrubrik"',
          GUIEditable: true,
        },
        Resurs: {
          AttributeName: 'Resurs',
          DisplayLabel: 'Resurs',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ArtNrFaktText: {
          AttributeName: 'ArtNrFaktText',
          DisplayLabel: 'Artikelnummer/Fakturatext',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Resursrubrik: {
          AttributeName: 'Resursrubrik',
          DisplayLabel: 'Resursrubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FAKTURATEXT_ID: {
          AttributeName: 'FAKTURATEXT_ID',
          DisplayLabel: 'FakturatextID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgText'],
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'ArtikelID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['FaktOmgArtikel'],
        },
        APRIS: {
          AttributeName: 'APRIS',
          DisplayLabel: 'Apris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['FaktOmgArtikel'],
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          GUIEditable: true,
          ValidInComps: ['FaktOmgArtikel'],
        },
        RadBelopp: {
          AttributeName: 'RadBelopp',
          DisplayLabel: 'Radbelopp',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['FaktOmgArtikel'],
        },
        AktuelltRadBelopp: {
          AttributeName: 'AktuelltRadBelopp',
          DisplayLabel: 'Aktuellt radbelopp',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          ValidInComps: ['FaktOmgArtikel'],
          AttributeParams: {'PrislistaID': {type: 'Int', defaultValue: ''}},
        },
        Enhet: {
          AttributeName: 'Enhet',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        ArtikelTyp: {
          AttributeName: 'ArtikelTyp',
          DisplayLabel: 'Artikeltyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        ArtikelNr: {
          AttributeName: 'ArtikelNr',
          DisplayLabel: 'Artikelnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        RadBelopp2: {
          AttributeName: 'RadBelopp2',
          DisplayLabel: 'Radbelopp2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        AktuelltRadBelopp2: {
          AttributeName: 'AktuelltRadBelopp2',
          DisplayLabel: 'AktuelltRadBelopp2',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        Artikelnr2: {
          AttributeName: 'Artikelnr2',
          DisplayLabel: 'Artikelnr2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        Momsbenamning: {
          AttributeName: 'Momsbenamning',
          DisplayLabel: 'Momsbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        Momssats: {
          AttributeName: 'Momssats',
          DisplayLabel: 'Momssats',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
          ValidInComps: ['FaktOmgArtikel'],
        },
        MomsID: {
          AttributeName: 'MomsID',
          DisplayLabel: 'MomsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        Kan_Andra_Antal: {
          AttributeName: 'Kan_Andra_Antal',
          DisplayLabel: 'Kan ändra antal',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        Kan_Andra_Pris: {
          AttributeName: 'Kan_Andra_Pris',
          DisplayLabel: 'Kan ändra pris',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['FaktOmgArtikel'],
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktomg: {
          AssociationName: 'Faktomg',
          DisplayLabel: 'Faktureraunderlag',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOFaktOmg',
          AssociatedComponentName: 'FaktOmg',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokningsrubrik: {
          AssociationName: 'Bokningsrubrik',
          DisplayLabel: 'Bokningsrubrik',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturatext: {
          AssociationName: 'Fakturatext',
          DisplayLabel: 'Fakturatext',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAFakturatext',
          AssociatedComponentName: 'FakturaText',
          JoinAssociation: true,
          ValidInComps: ['FaktOmgText'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: ['FaktOmgArtikel'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontering: {
          AssociationName: 'Kontering',
          DisplayLabel: 'Kontering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOFaktOmgOrdradKontering',
          AssociatedComponentName: 'FaktOmgRadKontering',
          JoinAssociation: false,
          ValidInComps: ['FaktOmgArtikel'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOFlexPersonal: {
      CollectionName: 'BOFlexPersonal',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: '',
        Abstract: true,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOFlexPersonals primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOFlexPersonals versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOFlexPersonals fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'Resurs ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FLEX_ID: {
          AttributeName: 'FLEX_ID',
          DisplayLabel: 'Anställd nummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FROMDATE: {
          AttributeName: 'FROMDATE',
          DisplayLabel: 'Från datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TODATE: {
          AttributeName: 'TODATE',
          DisplayLabel: 'Till datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FROMTIME: {
          AttributeName: 'FROMTIME',
          DisplayLabel: 'Från klockan',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TOTIME: {
          AttributeName: 'TOTIME',
          DisplayLabel: 'Till klockan',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MESSAGE: {
          AttributeName: 'MESSAGE',
          DisplayLabel: 'Meddelande',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Senaste status',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOGruppImportExport: {
      CollectionName: 'BOGruppImportExport',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GruppImportExport',
        Abstract: false,
        SOLabel: 'Format',
        SOGLabel: 'Formats',
        SBLabel: 'Formatet',
        SBGLabel: 'Formatets',
        POLabel: 'Format',
        POGLabel: 'Formats',
        PBLabel: 'Formaten',
        PBGLabel: 'Formatens',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Formatets primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Formatets versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Formatets id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Formatets fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Import/Excel/CSV',
          DataType: 'Enum',
          EnumValues: new Map([['IMPORT', 'Import'], ['EXCEL', 'Excel'], ['CSV', 'CSV']]),
          EnumSortValues: new Map([['IMPORT', 'I'], ['EXCEL', 'X'], ['CSV', 'C']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="IMPORT=Import;EXCEL=Excel;CSV=CSV"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FALT: {
          AttributeName: 'FALT',
          DisplayLabel: 'Fält',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORMAT: {
          AttributeName: 'FORMAT',
          DisplayLabel: 'Formatparametrar',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOKategori: {
      CollectionName: 'BOKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Kategori',
        Abstract: false,
        SOLabel: 'Framsidan kategori',
        SOGLabel: 'Framsidekategoris',
        SBLabel: 'Framsidekategorin',
        SBGLabel: 'Framsidekategorins',
        POLabel: 'Framsidekategorier',
        POGLabel: 'Framsidekategoriers',
        PBLabel: 'Framsidekategorierna',
        PBGLabel: 'Framsidekategoriernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Framsidekategorins primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Framsidekategorins versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Framsidekategorins id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Framsidekategorins fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOGruppOP: {
      CollectionName: 'BOGruppOP',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '1012']]),
      RootType: {
        TypeValue: 'GruppOP',
        Abstract: false,
        SOLabel: 'Grupp',
        SOGLabel: 'Grupp',
        SBLabel: 'Gruppen',
        SBGLabel: 'Gruppen',
        POLabel: 'Grupper',
        POGLabel: 'Grupper',
        PBLabel: 'Grupperna',
        PBGLabel: 'Grupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SIGNATUR: {
          AttributeName: 'SIGNATUR',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        GILTIG_FROM: {
          AttributeName: 'GILTIG_FROM',
          DisplayLabel: 'Giltig fr.o.m.',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        GILTIG_TOM: {
          AttributeName: 'GILTIG_TOM',
          DisplayLabel: 'Giltig t.o.m.',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        GRUPP_LEDARE: {
          AttributeName: 'GRUPP_LEDARE',
          DisplayLabel: 'Gruppledare',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VISA_PERSNR: {
          AttributeName: 'VISA_PERSNR',
          DisplayLabel: 'Visa fullst. personnummer',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          InterfaceType: 'ifBoolean',
        },
        Antal: {
          AttributeName: 'Antal',
          DisplayLabel: 'Antal medlemmar',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SkapadSign: {
          AttributeName: 'SkapadSign',
          DisplayLabel: 'Skapad',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalSam: {
          AttributeName: 'AntalSam',
          DisplayLabel: 'Antal sammankomster',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalNarvTotalt: {
          AttributeName: 'AntalNarvTotalt',
          DisplayLabel: 'Närvarande totalt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalNarvPerSam: {
          AttributeName: 'AntalNarvPerSam',
          DisplayLabel: 'Antal närvarande per sammankomst',
          DataType: 'Float',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatFloat',
        },
        IngarIGrupp: {
          AttributeName: 'IngarIGrupp',
          DisplayLabel: 'Ingår i grupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        GiltigPer: {
          AttributeName: 'GiltigPer',
          DisplayLabel: 'Giltig per datum',
          DataType: 'Date',
          Attribute: 'None',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        STATI_ANTAL: {
          AttributeName: 'STATI_ANTAL',
          DisplayLabel: 'Antal medlemmar som rapporteras till statistik',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        ENHETSID: {
          AttributeName: 'ENHETSID',
          DisplayLabel: 'Församling',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VERKSAMHETSTYP_ID: {
          AttributeName: 'VERKSAMHETSTYP_ID',
          DisplayLabel: 'Verksamhetstyp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Verksamhetstyp: {
          AssociationName: 'Verksamhetstyp',
          DisplayLabel: 'Verksamhetstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOVerksamhetstyper',
          AssociatedComponentName: 'Verksamhetstyper',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Forsamling: {
          AssociationName: 'Forsamling',
          DisplayLabel: 'Församling',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSStatistikinstallningar',
          AssociatedComponentName: 'Statistikinstallningar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GruppmedlemOP: {
          AssociationName: 'GruppmedlemOP',
          DisplayLabel: 'Gruppmedlem personer',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOTEDBOGruppmedlemOP',
          AssociatedComponentName: 'GruppMedlem',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Sammankomster: {
          AssociationName: 'Sammankomster',
          DisplayLabel: 'Sammankomster',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOSammankomst',
          AssociatedComponentName: 'Sammankomst',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Ansvariga: {
          AssociationName: 'Ansvariga',
          DisplayLabel: 'Ansvariga',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGruppBehorighet',
          AssociatedComponentName: 'GruppBehorighet',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Aldersindelningar: {
          AssociationName: 'Aldersindelningar',
          DisplayLabel: 'Åldersindelningar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGruppAldersindelning',
          AssociatedComponentName: 'GruppAldersindelning',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOGudstjansttypHandelsetyp: {
      CollectionName: 'BOGudstjansttypHandelsetyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GudstjansttypHandelsetyp',
        Abstract: false,
        SOLabel: 'Gudstjänst händelsetyp',
        SOGLabel: 'Gudstjänst händelsetyp',
        SBLabel: 'Gudstjänsten händelsetypen',
        SBGLabel: 'Gudstjänsten händelsetypen',
        POLabel: 'Gudstjänster händelsetyper',
        POGLabel: 'Gudstjänster händelsetyper',
        PBLabel: 'Gudstjänsterna händelsetyperna',
        PBGLabel: 'Gudstjänsterna händelsetyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gudstjänsten händelsetypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gudstjänsten händelsetypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gudstjänsten händelsetypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Handelsetyp: {
          AssociationName: 'Handelsetyp',
          DisplayLabel: 'Händelsetyp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKKHandelsetyp',
          AssociatedComponentName: 'SKKHandelsetyp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOGudstjansttypAmnesomrade: {
      CollectionName: 'BOGudstjansttypAmnesomrade',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GudstjansttypAmnesomrade',
        Abstract: false,
        SOLabel: 'Gudstjänsttypens ämnesområde',
        SOGLabel: 'Gudstjänsttypens ämnesområde',
        SBLabel: 'Gudstjänsttypens ämnesområde',
        SBGLabel: 'Gudstjänsttypens ämnesområde',
        POLabel: 'Gudstjänsttypens ämnesområde',
        POGLabel: 'Gudstjänsttypens ämnesområde',
        PBLabel: 'Gudstjänsttypens ämnesområde',
        PBGLabel: 'Gudstjänsttypens ämnesområde',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gudstjänsttypens ämnesområde primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gudstjänsttypens ämnesområde versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gudstjänsttypens ämnesområde fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Amnesomrade: {
          AttributeName: 'Amnesomrade',
          DisplayLabel: 'Ämnesområde',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bokningsgrupp: {
          AttributeName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
      },
      Associations: {
        Amnesomrade: {
          AssociationName: 'Amnesomrade',
          DisplayLabel: 'Ämnesområde',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKKAmnesomraden',
          AssociatedComponentName: 'SKKAmnesomraden',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOGudstjansttyp: {
      CollectionName: 'BOGudstjansttyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Gudstjansttyp',
        Abstract: false,
        SOLabel: 'Gudstjänsttyp',
        SOGLabel: 'Gudstjänsttyp',
        SBLabel: 'Gudstjänsttypen',
        SBGLabel: 'Gudstjänsttypen',
        POLabel: 'Gudstjänsttyper',
        POGLabel: 'Gudstjänsttyper',
        PBLabel: 'Gudstjänsttyperna',
        PBGLabel: 'Gudstjänsttyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Gudstjänsttypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Gudstjänsttypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Gudstjänsttypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Gudstjänsttypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORK: {
          AttributeName: 'FORK',
          DisplayLabel: 'Förkortning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NAMN: {
          AttributeName: 'NAMN',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        HUVUDGUDSTJANST: {
          AttributeName: 'HUVUDGUDSTJANST',
          DisplayLabel: 'Huvudgudstjänst',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        INGARPREDIKOTUR: {
          AttributeName: 'INGARPREDIKOTUR',
          DisplayLabel: 'Ingår i predikotur',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          Required: true,
        },
        BenamningFork: {
          AttributeName: 'BenamningFork',
          DisplayLabel: 'Benäming (förkortning)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Fork_Benamning: {
          AttributeName: 'Fork_Benamning',
          DisplayLabel: 'Förkortning: Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        NYTT_NAMN: {
          AttributeName: 'NYTT_NAMN',
          DisplayLabel: 'Nytt namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;']]),
        },
        CATEGORY: {
          AttributeName: 'CATEGORY',
          DisplayLabel: 'Statistik kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SK_STATISTIK_GRUPP: {
          AttributeName: 'SK_STATISTIK_GRUPP',
          DisplayLabel: 'Statistikgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        PRIO_ORDNING: {
          AttributeName: 'PRIO_ORDNING',
          DisplayLabel: 'Prioriteringsordning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
        Aktivitetskategorier: {
          AssociationName: 'Aktivitetskategorier',
          DisplayLabel: 'Aktivitetskategorier',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOGudstjtypKategori',
          AssociatedComponentName: 'GudstjtypKategori',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Amnesomraden: {
          AssociationName: 'Amnesomraden',
          DisplayLabel: 'Ämnesområden',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGudstjansttypAmnesomrade',
          AssociatedComponentName: 'GudstjansttypAmnesomrade',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelsetyper: {
          AssociationName: 'Handelsetyper',
          DisplayLabel: 'Händelsetyper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGudstjansttypHandelsetyp',
          AssociatedComponentName: 'GudstjansttypHandelsetyp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOVerkstypHandelsetyp: {
      CollectionName: 'BOVerkstypHandelsetyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'VerkstypHandelsetyp',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOVerkstypHandelsetyps primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOVerkstypHandelsetyps versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOVerkstypHandelsetyps fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Handelsetyp: {
          AssociationName: 'Handelsetyp',
          DisplayLabel: 'Händelsetyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKKHandelsetyp',
          AssociatedComponentName: 'SKKHandelsetyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOSKKHandelsetyp: {
      CollectionName: 'BOSKKHandelsetyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SKKHandelsetyp',
        Abstract: false,
        SOLabel: 'Händelsetyp',
        SOGLabel: 'Händelsetyp',
        SBLabel: 'Händelsetypen',
        SBGLabel: 'Händelsetypen',
        POLabel: 'Händelsetyp',
        POGLabel: '',
        PBLabel: 'Händelsetyperna',
        PBGLabel: 'Händelsetyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Händelsetypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Händelsetypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Händelsetypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KATEGORI_ID: {
          AttributeName: 'KATEGORI_ID',
          DisplayLabel: 'Kategori id',
          Hint: '1/2',
          DataType: 'Enum',
          EnumValues: new Map([['K1', '1'], ['K2', '2']]),
          EnumSortValues: new Map([['K1', '\'Gudstjänst\''], ['K2', '\'Kalender\'']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="K1=1;K2=2"',
          GUIEditable: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        FORKORT: {
          AttributeName: 'FORKORT',
          DisplayLabel: 'Förkortning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOAktivitetHandelsetyp: {
      CollectionName: 'BOAktivitetHandelsetyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktivitetHandelsetyp',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOAktivitetHandelsetyps primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOAktivitetHandelsetyps versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOAktivitetHandelsetyps fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Handelsetyp: {
          AssociationName: 'Handelsetyp',
          DisplayLabel: 'Händelsetyp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKKHandelsetyp',
          AssociatedComponentName: 'SKKHandelsetyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOInkluderadRestyp: {
      CollectionName: 'BOInkluderadRestyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'InkluderadRestyp',
        Abstract: false,
        SOLabel: 'Inkluderad resurstyp',
        SOGLabel: 'Inkluderad resurstyps',
        SBLabel: 'Inkluderad resurstyp',
        SBGLabel: 'Inkluderad resurstyps',
        POLabel: 'Inkluderade resurstyper',
        POGLabel: 'Inkluderade resurstypers',
        PBLabel: 'Inkluderade resurstyper',
        PBGLabel: 'Inkluderade resurstypers',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Inkluderad resurstyps primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Inkluderad resurstyps versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Inkluderad resurstyps fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PARENTID: {
          AttributeName: 'PARENTID',
          DisplayLabel: 'Parent ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurstyp: {
          AssociationName: 'Resurstyp',
          DisplayLabel: 'Resurstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurstyp',
          AssociatedComponentName: 'Resurstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOJourtid: {
      CollectionName: 'BOJourtid',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Jourtid',
        Abstract: false,
        SOLabel: 'Jourtid',
        SOGLabel: 'Jourtid',
        SBLabel: 'Jourtiden',
        SBGLabel: 'Jourtiden',
        POLabel: 'Jourtider',
        POGLabel: 'Jourtider',
        PBLabel: 'Jourtiderna',
        PBGLabel: 'Jourtiderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Jourtiden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Jourtiden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Jourtiden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'ResursID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOAktivitetkalenderinfo: {
      CollectionName: 'BOAktivitetkalenderinfo',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Aktivitetkalenderinfo',
        Abstract: false,
        SOLabel: 'Kalenderinfo',
        SOGLabel: 'Kalenderinfo',
        SBLabel: 'Kalenderinfo',
        SBGLabel: 'Kalenderinfo',
        POLabel: 'Kalenderinfo',
        POGLabel: 'Kalenderinfo',
        PBLabel: 'Kalenderinfo',
        PBGLabel: 'Kalenderinfo',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kalenderinfo primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kalenderinfo versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kalenderinfo fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESINFO: {
          AttributeName: 'RESINFO',
          DisplayLabel: 'Resinfo',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KNUTAKTINFO: {
          AttributeName: 'KNUTAKTINFO',
          DisplayLabel: 'Knutaktinfo',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOAktKategori: {
      CollectionName: 'BOAktKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktKategori',
        Abstract: false,
        SOLabel: 'Kategori för en aktivitet',
        SOGLabel: 'Kategori för en aktivitet',
        SBLabel: 'Kategorin för en aktivitet',
        SBGLabel: 'Kategorin för en aktivitet',
        POLabel: 'Kategorier för en aktivitet',
        POGLabel: 'Kategorier för en aktivitet',
        PBLabel: 'Kategorierna för en aktivitet',
        PBGLabel: 'Kategorierna för en aktivitet',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kategorin för en aktivitet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kategorin för en aktivitet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kategorin för en aktivitet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KategoriKod: {
          AttributeName: 'KategoriKod',
          DisplayLabel: 'Kategori, kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KategoriBen: {
          AttributeName: 'KategoriBen',
          DisplayLabel: 'Kategori, benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitetskategori: {
          AssociationName: 'Aktivitetskategori',
          DisplayLabel: 'Framsidan kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOKategori',
          AssociatedComponentName: 'Kategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOGudstjtypKategori: {
      CollectionName: 'BOGudstjtypKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GudstjtypKategori',
        Abstract: false,
        SOLabel: 'Kategori för en gudstjänsttyp',
        SOGLabel: 'Kategori för en gudstjänsttyp',
        SBLabel: 'Kategorin för en gudstjänsttyp',
        SBGLabel: 'Kategorin för en gudstjänsttyp',
        POLabel: 'Kategorier för en gudstjänsttyp',
        POGLabel: 'Kategorier för en gudstjänsttyp',
        PBLabel: 'Kategorierna för en gudstjänsttyp',
        PBGLabel: 'Kategorierna för en gudstjänsttyp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kategorin för en gudstjänsttyp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kategorin för en gudstjänsttyp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kategorin för en gudstjänsttyp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KategoriKod: {
          AttributeName: 'KategoriKod',
          DisplayLabel: 'Kategori, kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KategoriBen: {
          AttributeName: 'KategoriBen',
          DisplayLabel: 'Kategori, benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitetskategori: {
          AssociationName: 'Aktivitetskategori',
          DisplayLabel: 'Aktivitetskategori',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOKategori',
          AssociatedComponentName: 'Kategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOVerkstypKategori: {
      CollectionName: 'BOVerkstypKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'VerkstypKategori',
        Abstract: false,
        SOLabel: 'Kategori för en verksamhetstyp',
        SOGLabel: 'Kategori för en verksamhetstyp',
        SBLabel: 'Kategorin för en verksamhetstyp',
        SBGLabel: 'Kategorin för en verksamhetstyp',
        POLabel: 'Kategorier för en verksamhetstyp',
        POGLabel: 'Kategorier för en verksamhetstyp',
        PBLabel: 'Kategorierna för en verksamhetstyp',
        PBGLabel: 'Kategorierna för en verksamhetstyp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kategorin för en verksamhetstyp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kategorin för en verksamhetstyp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kategorin för en verksamhetstyp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KategoriKod: {
          AttributeName: 'KategoriKod',
          DisplayLabel: 'Kategori, kod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KategoriBen: {
          AttributeName: 'KategoriBen',
          DisplayLabel: 'Kategori, benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitetskategori: {
          AssociationName: 'Aktivitetskategori',
          DisplayLabel: 'Framsidan kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOKategori',
          AssociatedComponentName: 'Kategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOFaktOmgOrdradKontering: {
      CollectionName: 'BOFaktOmgOrdradKontering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'FaktOmgRadKontering',
        Abstract: false,
        SOLabel: 'Konteringsrad',
        SOGLabel: 'Konteringsrad',
        SBLabel: 'Konteringsraden',
        SBGLabel: 'Konteringsraden',
        POLabel: 'Konteringsrader',
        POGLabel: 'Konteringsrader',
        PBLabel: 'Konteringsraderna',
        PBGLabel: 'Konteringsraderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Konteringsraden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Konteringsraden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Konteringsraden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Konteringsraden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KPLAN_ID: {
          AttributeName: 'KPLAN_ID',
          DisplayLabel: 'Kontoplan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_1: {
          AttributeName: 'ORDNINGS_NR_1',
          DisplayLabel: 'Ordningsnr 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_1: {
          AttributeName: 'KONTOID_1',
          DisplayLabel: 'Kontoid 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_2: {
          AttributeName: 'ORDNINGS_NR_2',
          DisplayLabel: 'Ordningsnr 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_2: {
          AttributeName: 'KONTOID_2',
          DisplayLabel: 'Kontoid 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_3: {
          AttributeName: 'ORDNINGS_NR_3',
          DisplayLabel: 'Ordningsnr 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_3: {
          AttributeName: 'KONTOID_3',
          DisplayLabel: 'Kontoid 3',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_4: {
          AttributeName: 'ORDNINGS_NR_4',
          DisplayLabel: 'Ordningsnr 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_4: {
          AttributeName: 'KONTOID_4',
          DisplayLabel: 'Kontoid 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_5: {
          AttributeName: 'ORDNINGS_NR_5',
          DisplayLabel: 'Ordningsnr 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_5: {
          AttributeName: 'KONTOID_5',
          DisplayLabel: 'Kontoid 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_6: {
          AttributeName: 'ORDNINGS_NR_6',
          DisplayLabel: 'Ordningsnr 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_6: {
          AttributeName: 'KONTOID_6',
          DisplayLabel: 'Kontoid 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_7: {
          AttributeName: 'ORDNINGS_NR_7',
          DisplayLabel: 'Ordningsnr 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_7: {
          AttributeName: 'KONTOID_7',
          DisplayLabel: 'Kontoid 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_8: {
          AttributeName: 'ORDNINGS_NR_8',
          DisplayLabel: 'Ordningsnr 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_8: {
          AttributeName: 'KONTOID_8',
          DisplayLabel: 'Kontoid 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_9: {
          AttributeName: 'ORDNINGS_NR_9',
          DisplayLabel: 'Ordningsnr 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_9: {
          AttributeName: 'KONTOID_9',
          DisplayLabel: 'Kontoid 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORDNINGS_NR_10: {
          AttributeName: 'ORDNINGS_NR_10',
          DisplayLabel: 'Ordningsnr 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTOID_10: {
          AttributeName: 'KONTOID_10',
          DisplayLabel: 'Kontoid 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PROCENT: {
          AttributeName: 'PROCENT',
          DisplayLabel: 'Procent',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        KontoBen: {
          AttributeName: 'KontoBen',
          DisplayLabel: 'Kontobenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KontoStrang: {
          AttributeName: 'KontoStrang',
          DisplayLabel: 'Kontosträng',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Faktomgang: {
          AttributeName: 'Faktomgang',
          DisplayLabel: 'Faktureringsomgång',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Faktomg2: {
          AttributeName: 'Faktomg2',
          DisplayLabel: 'Faktomg2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        FaktOmgRad: {
          AssociationName: 'FaktOmgRad',
          DisplayLabel: 'Faktureringsunderlagsrad',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOFaktOmgOrdrad',
          AssociatedComponentName: 'FaktOmgOrdrad',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBisattningKremBest: {
      CollectionName: 'BOBisattningKremBest',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '19008']]),
      RootType: {
        TypeValue: 'BisattningKremBest',
        Abstract: false,
        SOLabel: 'Kremationsbeställning',
        SOGLabel: 'Kremationsbeställning',
        SBLabel: 'Kremationsbeställningen',
        SBGLabel: 'Kremationsbeställningen',
        POLabel: 'Kremationsbeställningar',
        POGLabel: 'Kremationsbeställningar',
        PBLabel: 'Kremationsbeställningarna',
        PBGLabel: 'Kremationsbeställningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kremationsbeställningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kremationsbeställningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kremationsbeställningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AVLIDEN_ID: {
          AttributeName: 'AVLIDEN_ID',
          DisplayLabel: 'Avliden id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Beställd/Mottagen/Refuserad',
          DataType: 'Enum',
          EnumValues: new Map([['BESTALLD', 'Beställd'], ['MOTTAGEN', 'Mottagen'], ['REFUSERAD', 'Refuserad']]),
          EnumSortValues: new Map([['BESTALLD', 'B'], ['MOTTAGEN', 'M'], ['REFUSERAD', 'R']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BESTALLD=Beställd;MOTTAGEN=Mottagen;REFUSERAD=Refuserad"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEST_DATUMTID: {
          AttributeName: 'BEST_DATUMTID',
          DisplayLabel: 'Beställningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KONTAKT_LOPNR: {
          AttributeName: 'KONTAKT_LOPNR',
          DisplayLabel: 'Kontakt löpnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DODSDATUM: {
          AttributeName: 'DODSDATUM',
          DisplayLabel: 'Dödsdatum',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateStr',
          FormatterParseParams: 'Format="y-m|-d/y|mm|dd"',
          FormatterValidateParams: 'MaxDate="+0d"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        MOTTAGARE_ID: {
          AttributeName: 'MOTTAGARE_ID',
          DisplayLabel: 'Mottagare id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_MED_URNA: {
          AttributeName: 'AKT_MED_URNA',
          DisplayLabel: 'Akt med urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KREM_ID: {
          AttributeName: 'KREM_ID',
          DisplayLabel: 'Krematorium',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KREM_ANNAT: {
          AttributeName: 'KREM_ANNAT',
          DisplayLabel: 'Annat Krematorium',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEGBYRA_ID: {
          AttributeName: 'BEGBYRA_ID',
          DisplayLabel: 'Begravningsbyrå id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESTALLARE_ID: {
          AttributeName: 'BESTALLARE_ID',
          DisplayLabel: 'Beställare id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MOTTAG_DATUMTID: {
          AttributeName: 'MOTTAG_DATUMTID',
          DisplayLabel: 'Mottagningsdatum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        BISATTNING_ID: {
          AttributeName: 'BISATTNING_ID',
          DisplayLabel: 'Bisättningsjournal id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TYP_URNA: {
          AttributeName: 'TYP_URNA',
          DisplayLabel: 'Typ av urna',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        DIREKTARE: {
          AttributeName: 'DIREKTARE',
          DisplayLabel: 'Direktkremation',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        BegrByraNamn: {
          AttributeName: 'BegrByraNamn',
          DisplayLabel: 'Begravningsbyrå benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KONTAKT_NAMN: {
          AttributeName: 'KONTAKT_NAMN',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TYP_KISTA: {
          AttributeName: 'TYP_KISTA',
          DisplayLabel: 'Typ av kista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NARVARA: {
          AttributeName: 'NARVARA',
          DisplayLabel: 'Anhörig närvarar',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        AVVIKANDE_STR: {
          AttributeName: 'AVVIKANDE_STR',
          DisplayLabel: 'Avvikande storlek kista',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KontaktNamn: {
          AttributeName: 'KontaktNamn',
          DisplayLabel: 'Kontaktperson',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        KONTAKT_ANHORIG_ID: {
          AttributeName: 'KONTAKT_ANHORIG_ID',
          DisplayLabel: 'Kontakt anhörig id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_BEGRBYRA_ID: {
          AttributeName: 'KONTAKT_BEGRBYRA_ID',
          DisplayLabel: 'Kontakt begravningsbyrå id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_OVRIG_PERS: {
          AttributeName: 'KONTAKT_OVRIG_PERS',
          DisplayLabel: 'Kontakt övrig person id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_OVRIG_ORG: {
          AttributeName: 'KONTAKT_OVRIG_ORG',
          DisplayLabel: 'Kontakt övrig org id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANHORIG_HAMTAR: {
          AttributeName: 'ANHORIG_HAMTAR',
          DisplayLabel: 'Anhörig hämtar urna',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffMaskedValue', 'Y']]),
          MaskedValue: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Noteringar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        RELATION: {
          AttributeName: 'RELATION',
          DisplayLabel: 'Relation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEGR_DATUM_TID: {
          AttributeName: 'BEGR_DATUM_TID',
          DisplayLabel: 'Begravningsdatum och tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifNone',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEGR_PLATS: {
          AttributeName: 'BEGR_PLATS',
          DisplayLabel: 'Begravningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GRAVS_DATUM_TID: {
          AttributeName: 'GRAVS_DATUM_TID',
          DisplayLabel: 'Gravsättningsdatum och tid',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifNone',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GRAVS_PLATS: {
          AttributeName: 'GRAVS_PLATS',
          DisplayLabel: 'Gravsättningsplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ARENDE_NR: {
          AttributeName: 'ARENDE_NR',
          DisplayLabel: 'Ärendenr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatArendeNr',
          GUIEditable: true,
          MaxInputLength: 11,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Avliden: {
          AssociationName: 'Avliden',
          DisplayLabel: 'Avliden',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y']]),
        },
        Begravningsbyra: {
          AssociationName: 'Begravningsbyra',
          DisplayLabel: 'Begravningsbyrå',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bestallare: {
          AssociationName: 'Bestallare',
          DisplayLabel: 'Beställare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Krematorium: {
          AssociationName: 'Krematorium',
          DisplayLabel: 'Krematorium',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KJKrematorium',
          AssociatedComponentName: 'Krematorium',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Mottagare: {
          AssociationName: 'Mottagare',
          DisplayLabel: 'Mottagare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bisattning: {
          AssociationName: 'Bisattning',
          DisplayLabel: 'Bisättningsjournal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattning',
          AssociatedComponentName: 'Bisattningsjournal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOKremBestDok',
          AssociatedComponentName: 'KremBestDok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kontakter: {
          AssociationName: 'Kontakter',
          DisplayLabel: 'Kontakter',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBisattningKontakt',
          AssociatedComponentName: 'BisattningsKontaktOrgPers',
          JoinAssociation: false,
          ValidInComps: ['BisattningsKontakt'],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktKontakt: {
      CollectionName: 'BOAktKontakt',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '1031']]),
      RootType: {
        TypeValue: 'AktKontakt',
        Abstract: false,
        SOLabel: 'Kursdeltagare',
        SOGLabel: 'Kursdeltagare',
        SBLabel: 'Kursdeltagaren',
        SBGLabel: 'Kursdeltagaren',
        POLabel: 'Kursdeltagare',
        POGLabel: 'Kursdeltagare',
        PBLabel: 'Kursdeltagarna',
        PBGLabel: 'Kursdeltagarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Kursdeltagaren primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Kursdeltagaren versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Kursdeltagaren fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'OrganisationsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KONTAKT_ID: {
          AttributeName: 'KONTAKT_ID',
          DisplayLabel: 'KontaktID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KUND_ID: {
          AttributeName: 'KUND_ID',
          DisplayLabel: 'KundID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PRIS: {
          AttributeName: 'PRIS',
          DisplayLabel: 'Pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.notless,
        },
        ANMARKNING: {
          AttributeName: 'ANMARKNING',
          DisplayLabel: 'Anmärkning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KontaktTele: {
          AttributeName: 'KontaktTele',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        OrgAdress: {
          AttributeName: 'OrgAdress',
          DisplayLabel: 'Organisationsadress',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KontaktNamn: {
          AttributeName: 'KontaktNamn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KontaktEPost: {
          AttributeName: 'KontaktEPost',
          DisplayLabel: 'E-post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KontaktMobil: {
          AttributeName: 'KontaktMobil',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        KundNr: {
          AttributeName: 'KundNr',
          DisplayLabel: 'KundNr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KundNr1: {
          AttributeName: 'KundNr1',
          DisplayLabel: 'Kundnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Organisationsnamn1: {
          AttributeName: 'Organisationsnamn1',
          DisplayLabel: 'Organisationsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Organisationsnamn: {
          AttributeName: 'Organisationsnamn',
          DisplayLabel: 'Organisationsnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ALLERGI: {
          AttributeName: 'ALLERGI',
          DisplayLabel: 'Allergi',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 200,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        LookUpOrg: {
          AssociationName: 'LookUpOrg',
          DisplayLabel: 'Organisation',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Organisation',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([['NOT_ATAGANDE', 'Y;'], ['NO_FOREIGN_KEY', 'Y;']]),
        },
        Kontakt: {
          AssociationName: 'Kontakt',
          DisplayLabel: 'Kontakt',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPKontakt',
          AssociatedComponentName: 'Kontakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'FakturaKund',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOXBridgeLogg: {
      CollectionName: 'BOXBridgeLogg',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'XBridgeLogg',
        Abstract: false,
        SOLabel: 'Loggpost',
        SOGLabel: 'Loggposts',
        SBLabel: 'Loggposten',
        SBGLabel: 'Loggpostens',
        POLabel: 'Loggposter',
        POGLabel: 'Loggposters',
        PBLabel: 'Loggposterna',
        PBGLabel: 'Loggposternas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Loggpostens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Loggpostens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Loggpostens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TID: {
          AttributeName: 'TID',
          DisplayLabel: 'Tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        OK: {
          AttributeName: 'OK',
          DisplayLabel: 'OK',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterDisplayParams: 'TrueText="OK";FalseText="FEL"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ACTIVITY: {
          AttributeName: 'ACTIVITY',
          DisplayLabel: 'Händelse',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="A=A - Ny Avenybokning;U=U - Ändrad i Aveny;D=D - Avbokad i Aveny;R=R - Borttagen i Outlook;C=C - Ändrad i Outlook;G=G - Läs Outlookbokning"',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        XB_ID: {
          AttributeName: 'XB_ID',
          DisplayLabel: 'Externt ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        XB_VER: {
          AttributeName: 'XB_VER',
          DisplayLabel: 'Externt versions-ID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        XB_EMAIL: {
          AttributeName: 'XB_EMAIL',
          DisplayLabel: 'Extern epost',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKT_ID: {
          AttributeName: 'AKT_ID',
          DisplayLabel: 'Aktivitets-ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'Resurs-ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        REQUEST: {
          AttributeName: 'REQUEST',
          DisplayLabel: 'Anrop',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        RESPONSE: {
          AttributeName: 'RESPONSE',
          DisplayLabel: 'Svar',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        THREAD_ID: {
          AttributeName: 'THREAD_ID',
          DisplayLabel: 'Tråd-ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
      },
      Associations: {
      },
    },
    BOTEDBOGruppmedlemOP: {
      CollectionName: 'BOTEDBOGruppmedlemOP',
      UDAEnabled: true,
      UDNEnabled: false,
      Properties: new Map([['UDATableName', 'BO_GRUPPMEDLEM_UDA'], ['USER_DEF_REPORT_ROUTINE', '1021']]),
      RootType: {
        TypeValue: 'GruppMedlem',
        Abstract: true,
        SOLabel: 'Medlem',
        SOGLabel: 'Medlem',
        SBLabel: 'Medlemmen',
        SBGLabel: 'Medlemmen',
        POLabel: 'Medlemmar',
        POGLabel: 'Medlemmar',
        PBLabel: 'Medlemmarna',
        PBGLabel: 'Medlemmarna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'GruppmedlemOP',
            Abstract: false,
            SOLabel: 'Gruppmedlem',
            SOGLabel: 'Gruppmedlem',
            SBLabel: 'Gruppmedlemmen',
            SBGLabel: 'Gruppmedlemmen',
            POLabel: 'Gruppmedlemmar',
            POGLabel: 'Gruppmedlemmar',
            PBLabel: 'Gruppmedlemmarna',
            PBGLabel: 'Gruppmedlemmarna',
            Visible: false,
            ChildTypes: [
            ],
          },
          {
            TypeValue: 'GruppMedlemGrupp',
            Abstract: false,
            SOLabel: 'Ingående grupp',
            SOGLabel: 'Ingående grupp',
            SBLabel: 'Ingående gruppen',
            SBGLabel: 'Ingående gruppen',
            POLabel: 'Ingående grupper',
            POGLabel: 'Ingående grupper',
            PBLabel: 'Ingående grupperna',
            PBGLabel: 'Ingående grupperna',
            Visible: false,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Medlemmen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Medlemmen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ av medlem',
          DataType: 'Enum',
          EnumValues: new Map([['GRUPPMEDLEMOP', 'Gruppmedlem'], ['GRUPPMEDLEMGRUPP', 'Ingående grupp']]),
          EnumSortValues: new Map([['GRUPPMEDLEMOP', 'M'], ['GRUPPMEDLEMGRUPP', 'G']]),
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifTypeTree',
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Medlemmen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Medlemmen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Medlemsbeskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANMALNINGSDATUM: {
          AttributeName: 'ANMALNINGSDATUM',
          DisplayLabel: 'Anmälningsdatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Gruppbenamning: {
          AttributeName: 'Gruppbenamning',
          DisplayLabel: 'Gruppbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        sqlNamn: {
          AttributeName: 'sqlNamn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
          ValidInComps: ['GruppmedlemOP'],
        },
        calcNamn: {
          AttributeName: 'calcNamn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Person',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        PersNr: {
          AttributeName: 'PersNr',
          DisplayLabel: 'PersNr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatPersNr',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['GruppmedlemOP'],
        },
        Namn: {
          AttributeName: 'Namn',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Tele: {
          AttributeName: 'Tele',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Efternamn: {
          AttributeName: 'Efternamn',
          DisplayLabel: 'Efternamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['GruppmedlemOP'],
        },
        Fornamn: {
          AttributeName: 'Fornamn',
          DisplayLabel: 'Förnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          ValidInComps: ['GruppmedlemOP'],
        },
        PersNr2: {
          AttributeName: 'PersNr2',
          DisplayLabel: 'Personnummer2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Efternamn2: {
          AttributeName: 'Efternamn2',
          DisplayLabel: 'Efternamn2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Mellannamn2: {
          AttributeName: 'Mellannamn2',
          DisplayLabel: 'Mellannamn2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Fornamn2: {
          AttributeName: 'Fornamn2',
          DisplayLabel: 'Fornamn2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Kompaktadress: {
          AttributeName: 'Kompaktadress',
          DisplayLabel: 'Kompaktadress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Telefon: {
          AttributeName: 'Telefon',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Mobiltelefon: {
          AttributeName: 'Mobiltelefon',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Arbetstelefon: {
          AttributeName: 'Arbetstelefon',
          DisplayLabel: 'Arbetstelefon',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        SMTP: {
          AttributeName: 'SMTP',
          DisplayLabel: 'E-post',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Mellannamn: {
          AttributeName: 'Mellannamn',
          DisplayLabel: 'Mellannamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['GruppmedlemOP'],
        },
        OPLBorttagen: {
          AttributeName: 'OPLBorttagen',
          DisplayLabel: 'OPLBorttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        AvenySign: {
          AttributeName: 'AvenySign',
          DisplayLabel: 'Signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlTelefon: {
          AttributeName: 'sqlTelefon',
          DisplayLabel: 'Telefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTelNr',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlTelefon2: {
          AttributeName: 'sqlTelefon2',
          DisplayLabel: 'Telefon 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlAdress: {
          AttributeName: 'sqlAdress',
          DisplayLabel: 'Adress',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlSMTP: {
          AttributeName: 'sqlSMTP',
          DisplayLabel: 'E-post',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlSMTP2: {
          AttributeName: 'sqlSMTP2',
          DisplayLabel: 'E-post (2)',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlMobiltelefon: {
          AttributeName: 'sqlMobiltelefon',
          DisplayLabel: 'Mobiltelefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTelNr',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlArbetsTelefon: {
          AttributeName: 'sqlArbetsTelefon',
          DisplayLabel: 'Arbetstelefon',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatTelNr',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlAdrId: {
          AttributeName: 'sqlAdrId',
          DisplayLabel: 'Adress id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlRefAdrId: {
          AttributeName: 'sqlRefAdrId',
          DisplayLabel: 'Ref. adress id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        sqlInternAdr: {
          AttributeName: 'sqlInternAdr',
          DisplayLabel: 'Lokal adress',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          ValidInComps: ['GruppmedlemOP'],
        },
        GruppVisaPersNr: {
          AttributeName: 'GruppVisaPersNr',
          DisplayLabel: 'Visa fullst. personnummer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Telefon2: {
          AttributeName: 'Telefon2',
          DisplayLabel: 'Telefon2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        Telefon_Telefon2: {
          AttributeName: 'Telefon_Telefon2',
          DisplayLabel: 'Telefon/Telefon2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppmedlemOP'],
        },
        MEDL_GRUPP_ID: {
          AttributeName: 'MEDL_GRUPP_ID',
          DisplayLabel: 'Ingående grupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppMedlemGrupp'],
        },
        MedlGruppNamn: {
          AttributeName: 'MedlGruppNamn',
          DisplayLabel: 'Gruppnamn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['GruppMedlemGrupp'],
        },
        calcPersIDString: {
          AttributeName: 'calcPersIDString',
          DisplayLabel: 'Namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        GruppOP: {
          AssociationName: 'GruppOP',
          DisplayLabel: 'Grupp personer',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGruppOP',
          AssociatedComponentName: 'GruppOP',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Person: {
          AssociationName: 'Person',
          DisplayLabel: 'Adress',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'Person',
          JoinAssociation: true,
          ValidInComps: ['GruppmedlemOP'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        MedlGrupp: {
          AssociationName: 'MedlGrupp',
          DisplayLabel: 'Ingående grupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOGruppOP',
          AssociatedComponentName: 'GruppOP',
          JoinAssociation: true,
          ValidInComps: ['GruppMedlemGrupp'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Narvaro: {
          AssociationName: 'Narvaro',
          DisplayLabel: 'Närvaro',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BONarvaro',
          AssociatedComponentName: 'Narvaro',
          JoinAssociation: false,
          ValidInComps: ['GruppmedlemOP'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBisattningMottagare: {
      CollectionName: 'BOBisattningMottagare',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BisattningMottagare',
        Abstract: false,
        SOLabel: 'Mottagare utskick',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Mottagare utskick',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOBisattningMottagares primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOBisattningMottagares versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOBisattningMottagares fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'HändelseID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BISATTNINGSJOURNAL_ID: {
          AttributeName: 'BISATTNINGSJOURNAL_ID',
          DisplayLabel: 'Bisattningsjournal_ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Lopnr',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelse',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Kontakt: {
          AssociationName: 'Kontakt',
          DisplayLabel: 'Kontakt',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningKontakt',
          AssociatedComponentName: 'BisattningsKontaktOrgPers',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOAktivitetMottagare: {
      CollectionName: 'BOAktivitetMottagare',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktivitetMottagare',
        Abstract: false,
        SOLabel: 'Mottagare utskick',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Mottagare utskick',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOAktivitetMottagares primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOAktivitetMottagares versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOAktivitetMottagares fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HANDELSE_ID: {
          AttributeName: 'HANDELSE_ID',
          DisplayLabel: 'HändelseID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_ID: {
          AttributeName: 'AKT_ID',
          DisplayLabel: 'AktivitetID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OPID: {
          AttributeName: 'OPID',
          DisplayLabel: 'KontaktID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Handelse: {
          AssociationName: 'Handelse',
          DisplayLabel: 'Händelse',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'GAHandelse',
          AssociatedComponentName: 'Handelse',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Kontakt: {
          AssociationName: 'Kontakt',
          DisplayLabel: 'Kontakt',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningKontakt',
          AssociatedComponentName: 'BisattningsKontaktOrg',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOAktivitetOrder: {
      CollectionName: 'BOAktivitetOrder',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'AktOrder',
        Abstract: false,
        SOLabel: 'Order per aktivitet',
        SOGLabel: 'Order per aktivitet',
        SBLabel: 'Ordern per aktivitet',
        SBGLabel: 'Ordern per aktivitet',
        POLabel: 'Order per aktivitet',
        POGLabel: 'Order per aktivitet',
        PBLabel: 'Ordrarna per aktivitet',
        PBGLabel: 'Ordrarna per aktivitet',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ordern per aktivitet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ordern per aktivitet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Ordern per aktivitet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ordern per aktivitet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        OP_ID: {
          AttributeName: 'OP_ID',
          DisplayLabel: 'Organisation/Person id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Ej fakturerad/Fakturerad',
          DataType: 'Enum',
          EnumValues: new Map([['EJ_FAKTURERAD', 'Ej fakturerad'], ['FAKTURERAD', 'Fakturerad']]),
          EnumSortValues: new Map([['EJ_FAKTURERAD', 'E'], ['FAKTURERAD', 'F']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="EJ_FAKTURERAD=Ej fakturerad;FAKTURERAD=Fakturerad"',
          GUIEditable: true,
        },
        VARREFERENS: {
          AttributeName: 'VARREFERENS',
          DisplayLabel: 'Vår referens',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 40,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Faktomg: {
          AssociationName: 'Faktomg',
          DisplayLabel: 'Faktureringsomgång',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOFaktOmg',
          AssociatedComponentName: 'FaktOmg',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Order: {
          AssociationName: 'Order',
          DisplayLabel: 'Order',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'OFOrder',
          AssociatedComponentName: 'Order',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Deltagare: {
          AssociationName: 'Deltagare',
          DisplayLabel: 'Deltagare',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktDeltagar',
          AssociatedComponentName: 'AktDeltagare',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktPlanRes: {
      CollectionName: 'BOAktPlanRes',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '16009']]),
      RootType: {
        TypeValue: 'AktPlanRes',
        Abstract: false,
        SOLabel: 'Planerad resurs',
        SOGLabel: 'Planerad resurs',
        SBLabel: 'Planerade resursen',
        SBGLabel: 'Planerade resursens',
        POLabel: 'Planerade resurser',
        POGLabel: 'Planerade resursers',
        PBLabel: 'Planerade resurserna',
        PBGLabel: 'Planerade resursernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Planerade resursens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Planerade resursens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Planerade resursens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'Resurs ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOAktPlan: {
      CollectionName: 'BOAktPlan',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '16009']]),
      RootType: {
        TypeValue: 'AktPlan',
        Abstract: false,
        SOLabel: 'Planering',
        SOGLabel: 'Planerings',
        SBLabel: 'Planeringen',
        SBGLabel: 'Planeringens',
        POLabel: 'Planeringar',
        POGLabel: 'Planeringars',
        PBLabel: 'Planeringarna',
        PBGLabel: 'Planeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Planeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Planeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Planeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Fråndatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILLDATUM: {
          AttributeName: 'TILLDATUM',
          DisplayLabel: 'Tilldatum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AKTIVITETSTYP: {
          AttributeName: 'AKTIVITETSTYP',
          DisplayLabel: 'Aktivitetstyp',
          Hint: 'Dop/Begravning/Vigsel/Konfimation/Gravsättning/Lokaluthyrning/Gudstjänst',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="Dop=D;Begravning=B;Vigsel=V;Konfimation=K;Gravsättning=G;Lokaluthyrning=L;Gudstjänst=U;"',
          FormatterDisplayParams: 'TranslateValues="D=Dop;B=Begravning;V=Vigsel;K=Konfimation;G=Gravsättning;L=Lokaluthyrning;U=Gudstjänst;Ö=Övrigt;"',
          FormatterValidateParams: 'ValidValues="D;V;G;B;K;L;O;S;U;Ö;"',
          GUIEditable: true,
          MaxInputLength: 14,
          InterfaceType: 'ifTypeTree',
        },
        GUDSTJANSTTYP_ID: {
          AttributeName: 'GUDSTJANSTTYP_ID',
          DisplayLabel: 'GudstjänsttypID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VERKSAMHETSTYP_ID: {
          AttributeName: 'VERKSAMHETSTYP_ID',
          DisplayLabel: 'Verksamhetstyp ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTECKNING: {
          AttributeName: 'ANTECKNING',
          DisplayLabel: 'Anteckning för planering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'SKAPAD_DATUM',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKAPAD_AV: {
          AttributeName: 'SKAPAD_AV',
          DisplayLabel: 'Skapad av',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Planerad/Verifierad/Arkiverad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="Planerad=P;Verifierad=V;Arkiverad=A"',
          FormatterDisplayParams: 'TranslateValues="P=Planerad;V=Verifierad;A=Arkiverad"',
          FormatterValidateParams: 'ValidValues="P;V;A"',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifTypeTree',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKAPAD_AKTID: {
          AttributeName: 'SKAPAD_AKTID',
          DisplayLabel: 'Skapad aktivitet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Verksamhetstyp: {
          AssociationName: 'Verksamhetstyp',
          DisplayLabel: 'Verksamhetstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOVerksamhetstyper',
          AssociatedComponentName: 'Verksamhetstyper',
          JoinAssociation: true,
          ValidInComps: ['AktOvrLok'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        GudstjanstTyp: {
          AssociationName: 'GudstjanstTyp',
          DisplayLabel: 'Gudstjänsttyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGudstjansttyp',
          AssociatedComponentName: 'Gudstjansttyp',
          JoinAssociation: true,
          ValidInComps: ['Gudstjanst'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurser: {
          AssociationName: 'Resurser',
          DisplayLabel: 'Resurser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktPlanRes',
          AssociatedComponentName: 'AktPlanRes',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOPlanering: {
      CollectionName: 'BOPlanering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowEdit', '16009']]),
      RootType: {
        TypeValue: 'Planering',
        Abstract: false,
        SOLabel: 'Planering',
        SOGLabel: 'Planerings',
        SBLabel: 'Planeringen',
        SBGLabel: 'Planeringens',
        POLabel: 'Planeringar',
        POGLabel: 'Planeringars',
        PBLabel: 'Planeringarna',
        PBGLabel: 'Planeringarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Planeringens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Planeringens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Planeringens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURS_ID: {
          AttributeName: 'RESURS_ID',
          DisplayLabel: 'ResursID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.notgreater,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.notless,
        },
        KATEGORI_ID: {
          AttributeName: 'KATEGORI_ID',
          DisplayLabel: 'KategoriID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DAGTID: {
          AttributeName: 'DAGTID',
          DisplayLabel: 'Förmiddag/Eftermiddag/Dagtid',
          Hint: 'Förmiddag/Eftermiddag/Heldag',
          DataType: 'Enum',
          EnumValues: new Map([['FORMIDDAG', 'Förmiddag'], ['EFTERMIDDAG', 'Eftermiddag'], ['HELDAG', 'Heldag']]),
          EnumSortValues: new Map([['FORMIDDAG', 'F'], ['EFTERMIDDAG', 'E'], ['HELDAG', 'H']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORMIDDAG=Förmiddag;EFTERMIDDAG=Eftermiddag;HELDAG=Heldag"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        INFO: {
          AttributeName: 'INFO',
          DisplayLabel: 'Info',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifNone',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kategori: {
          AssociationName: 'Kategori',
          DisplayLabel: 'Kategori',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOPlaneringskategori',
          AssociatedComponentName: 'PlaneringsKategori',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOPlaneringskategori: {
      CollectionName: 'BOPlaneringskategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Planeringskategori',
        Abstract: false,
        SOLabel: 'Planeringskategori',
        SOGLabel: 'Planeringskategoris',
        SBLabel: 'Planeringskategorin',
        SBGLabel: 'Planeringskategorins',
        POLabel: 'Planeringskategorier',
        POGLabel: 'Planeringskategoriers',
        PBLabel: 'Planeringskategorierna',
        PBGLabel: 'Planeringskategoriernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Planeringskategorins primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Planeringskategorins versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Planeringskategorins fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        TYP: {
          AttributeName: 'TYP',
          DisplayLabel: 'Typ',
          Hint: 'Ledig/Tjänstgörande Begravning/Kurs/Övrigt',
          DataType: 'Enum',
          EnumValues: new Map([['LEDIG', 'Ledig'], ['TJANSTGORANDE_BEGRAVNING', 'Tjänstgörande Begravning'], ['KURS', 'Kurs'], ['OVRIGT', 'Övrigt']]),
          EnumSortValues: new Map([['LEDIG', 'L'], ['TJANSTGORANDE_BEGRAVNING', 'TjB'], ['KURS', 'K'], ['OVRIGT', 'Ö']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="LEDIG=Ledig;TJANSTGORANDE_BEGRAVNING=Tjänstgörande Begravning;KURS=Kurs;OVRIGT=Övrigt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        FARG: {
          AttributeName: 'FARG',
          DisplayLabel: 'Färg',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        FargText: {
          AttributeName: 'FargText',
          DisplayLabel: 'Färg',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 5,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        FRANTID: {
          AttributeName: 'FRANTID',
          DisplayLabel: 'Fråntid',
          Hint: 'Från vilken tid på dygnet?',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        TILLTID: {
          AttributeName: 'TILLTID',
          DisplayLabel: 'Tilltid',
          Hint: 'Till vilken tid på dygnet?',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        Dagtid: {
          AttributeName: 'Dagtid',
          DisplayLabel: 'fm/em/heldag',
          Hint: 'Förmiddag/Eftermiddag/Heldag',
          DataType: 'Enum',
          EnumValues: new Map([['FORMIDDAG', 'Förmiddag'], ['EFTERMIDDAG', 'Eftermiddag'], ['HELDAG', 'Heldag']]),
          EnumSortValues: new Map([['FORMIDDAG', 'F'], ['EFTERMIDDAG', 'E'], ['HELDAG', 'H']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="FORMIDDAG=Förmiddag;EFTERMIDDAG=Eftermiddag;HELDAG=Heldag"',
          InterfaceType: 'ifChecklist',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        KategoriSort: {
          AttributeName: 'KategoriSort',
          DisplayLabel: 'Kategori sorteringsordning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Gravplatsnummer',
        },
        PRIO: {
          AttributeName: 'PRIO',
          DisplayLabel: 'Prioritet',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.equals,
        },
        MANUELL_PLANERING: {
          AttributeName: 'MANUELL_PLANERING',
          DisplayLabel: 'Manuell tjänstgöring',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Bokngrupper: {
          AssociationName: 'Bokngrupper',
          DisplayLabel: 'Bokningsgrupper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOPlankatBokngrupp',
          AssociatedComponentName: 'PlankatBokngrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOPsalm: {
      CollectionName: 'BOPsalm',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Psalm',
        Abstract: false,
        SOLabel: 'Psalm',
        SOGLabel: 'Psalms',
        SBLabel: 'Psalmen',
        SBGLabel: 'Psalmens',
        POLabel: 'Psalmer',
        POGLabel: 'Psalmers',
        PBLabel: 'Psalmerna',
        PBGLabel: 'Psalmernas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Psalmens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Psalmens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Psalmens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Psalmens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TITEL: {
          AttributeName: 'TITEL',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 80,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        NUMMER: {
          AttributeName: 'NUMMER',
          DisplayLabel: 'Nummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        EXTID: {
          AttributeName: 'EXTID',
          DisplayLabel: 'Psalm ID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NRTitel: {
          AttributeName: 'NRTitel',
          DisplayLabel: 'Nummer och titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SortNummer: {
          AttributeName: 'SortNummer',
          DisplayLabel: 'SortNummer',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOResursPlanering: {
      CollectionName: 'BOResursPlanering',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'ResursPlanering',
        Abstract: false,
        SOLabel: 'Påminnelsetid',
        SOGLabel: 'Påminnelsetid',
        SBLabel: 'Påminnelsetiden',
        SBGLabel: 'Påminnelsetiden',
        POLabel: 'Påminnelsetider',
        POGLabel: 'Påminnelsetider',
        PBLabel: 'Påminnelsetiderna',
        PBGLabel: 'Påminnelsetiderna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Påminnelsetiden primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Påminnelsetiden versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Påminnelsetiden id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Påminnelsetiden fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PAMINNELSETID: {
          AttributeName: 'PAMINNELSETID',
          DisplayLabel: 'Påminnelsetid',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatGroupedNr',
          FormatterParseParams: 'Groups="d=1440;t=60;m=1";DefaultGroup="m";GroupTexts="d=d;dygn=d;t=t;tim=t;timme=t;timmar=t;m=m;min=m;minut=m;minuter=m"',
          FormatterDisplayParams: 'Groups="dygn/dygn=1440;timmar/timme=60;minuter/minut=1";GroupNameSep=" "',
        },
        ResursID: {
          AttributeName: 'ResursID',
          DisplayLabel: 'ResursID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AktTyp: {
          AttributeName: 'AktTyp',
          DisplayLabel: 'Aktivitetstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Aktivitetstyp: {
          AssociationName: 'Aktivitetstyp',
          DisplayLabel: 'Aktivitetstyp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetstyp',
          AssociatedComponentName: 'Aktivitetstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOResurs: {
      CollectionName: 'BOResurs',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '1003'], ['AllowSelection', '1039,16001']]),
      RootType: {
        TypeValue: 'Resurs',
        Abstract: false,
        SOLabel: 'Resurs',
        SOGLabel: 'Resurs',
        SBLabel: 'Resursen',
        SBGLabel: 'Resursen',
        POLabel: 'Resurser',
        POGLabel: 'Resurser',
        PBLabel: 'Resurserna',
        PBGLabel: 'Resurserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resursen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resursen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Resursen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resursen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BO_RESURS_ID: {
          AttributeName: 'BO_RESURS_ID',
          DisplayLabel: 'ResursID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BO_RESURS_NAMN: {
          AttributeName: 'BO_RESURS_NAMN',
          DisplayLabel: 'Resursens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCase',
          FormatterParseParams: 'Words=" False"',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ARBETSPASS_ID: {
          AttributeName: 'ARBETSPASS_ID',
          DisplayLabel: 'Resursens arbetspass ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RESURSTYP_ID: {
          AttributeName: 'RESURSTYP_ID',
          DisplayLabel: 'ResurstypID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        OPL_ID: {
          AttributeName: 'OPL_ID',
          DisplayLabel: 'Organisation/Person/Lokal',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DEFAKTIVITETSTYP_ID: {
          AttributeName: 'DEFAKTIVITETSTYP_ID',
          DisplayLabel: 'Förvald aktivitetstyp',
          Hint: 'Begravning/Gravsättning/Gudstjänst/Dop/Vigsel/Övrigt/Lokaluthyrning/Konfirmation/Snabbokning',
          DataType: 'Enum',
          EnumValues: new Map([['BEGRAVNING', 'Begravning'], ['GRAVSATTNING', 'Gravsättning'], ['GUDSTJANST', 'Gudstjänst'], ['DOP', 'Dop'], ['VIGSEL', 'Vigsel'], ['OVRIGT', 'Övrigt'], ['LOKALUTHYRNING', 'Lokaluthyrning'], ['KONFIRMATION', 'Konfirmation'], ['SNABBOKNING', 'Snabbokning']]),
          EnumSortValues: new Map([['BEGRAVNING', 'B'], ['GRAVSATTNING', 'G'], ['GUDSTJANST', 'U'], ['DOP', 'D'], ['VIGSEL', 'V'], ['OVRIGT', 'Ö'], ['LOKALUTHYRNING', 'L'], ['KONFIRMATION', 'K'], ['SNABBOKNING', 'S']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="BEGRAVNING=Begravning;GRAVSATTNING=Gravsättning;GUDSTJANST=Gudstjänst;DOP=Dop;VIGSEL=Vigsel;OVRIGT=Övrigt;LOKALUTHYRNING=Lokaluthyrning;KONFIRMATION=Konfirmation;SNABBOKNING=Snabbokning"',
        },
        USER_ID: {
          AttributeName: 'USER_ID',
          DisplayLabel: 'Användar ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARBETSTID_ID: {
          AttributeName: 'ARBETSTID_ID',
          DisplayLabel: 'ArbetstidsID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BOKNINGSBAR: {
          AttributeName: 'BOKNINGSBAR',
          DisplayLabel: 'Bokningsbar',
          Hint: 'Privat/Normal/Fritt',
          DataType: 'Enum',
          EnumValues: new Map([['PRIVAT', 'Privat'], ['NORMAL', 'Normal'], ['FRITT', 'Fritt']]),
          EnumSortValues: new Map([['PRIVAT', 'P'], ['NORMAL', 'V'], ['FRITT', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="PRIVAT=Privat;NORMAL=Normal;FRITT=Fritt"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Artikel',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        STATUS: {
          AttributeName: 'STATUS',
          DisplayLabel: 'Status',
          Hint: 'Aktuell/Visas ej i kalendern/Ej aktuell',
          DataType: 'Enum',
          EnumValues: new Map([['AKTUELL', 'Aktuell'], ['VISAS_EJ_I_KALENDERN', 'Visas ej i kalendern'], ['EJ_AKTUELL', 'Ej aktuell']]),
          EnumSortValues: new Map([['AKTUELL', 'A'], ['VISAS_EJ_I_KALENDERN', 'E'], ['EJ_AKTUELL', 'B']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="AKTUELL=Aktuell;VISAS_EJ_I_KALENDERN=Visas ej i kalendern;EJ_AKTUELL=Ej aktuell"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        VARNING_DUBBELBOKNING: {
          AttributeName: 'VARNING_DUBBELBOKNING',
          DisplayLabel: 'Varning vid dubbelbokning',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        TELEFONPAUTSKRIFT: {
          AttributeName: 'TELEFONPAUTSKRIFT',
          DisplayLabel: 'Telefonnummer på bokningsbekräftelse',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        WINDOWSSIGNATUR: {
          AttributeName: 'WINDOWSSIGNATUR',
          DisplayLabel: 'Windowssignatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BEGRAVNINGSPLATS: {
          AttributeName: 'BEGRAVNINGSPLATS',
          DisplayLabel: 'Begravningslokal',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KGARD_ID: {
          AttributeName: 'KGARD_ID',
          DisplayLabel: 'KyrkogårdID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EGEN_KGARD: {
          AttributeName: 'EGEN_KGARD',
          DisplayLabel: 'Egen kyrkogård',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        VECKOR_INNAN: {
          AttributeName: 'VECKOR_INNAN',
          DisplayLabel: 'Veckor innan',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VECKOR_EFTER: {
          AttributeName: 'VECKOR_EFTER',
          DisplayLabel: 'Veckor efter',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        WEBBOKNINGSBAR: {
          AttributeName: 'WEBBOKNINGSBAR',
          DisplayLabel: 'Webbokningsbar',
          Hint: 'Visas ej/Privat/Normal/Fritt/WebFri',
          DataType: 'Enum',
          EnumValues: new Map([['VISAS_EJ', 'Visas ej'], ['PRIVAT', 'Privat'], ['NORMAL', 'Normal'], ['FRITT', 'Fritt'], ['WEBFRI', 'WebFri']]),
          EnumSortValues: new Map([['VISAS_EJ', 'E'], ['PRIVAT', 'P'], ['NORMAL', 'V'], ['FRITT', 'Ä'], ['WEBFRI', 'W']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="VISAS_EJ=Visas ej;PRIVAT=Privat;NORMAL=Normal;FRITT=Fritt;WEBFRI=WebFri"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        SYNKRIKTNING: {
          AttributeName: 'SYNKRIKTNING',
          DisplayLabel: 'Synkroniseringsval',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOKALUTHYR_INFO: {
          AttributeName: 'LOKALUTHYR_INFO',
          DisplayLabel: 'Lokaluthyrningsinformation',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MAILBOXES: {
          AttributeName: 'MAILBOXES',
          DisplayLabel: 'Brevlådor',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        EPOSTPAUTSKRIFT: {
          AttributeName: 'EPOSTPAUTSKRIFT',
          DisplayLabel: 'E-post på bokningsbekräftelsen',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BOKBAR_AKTIVITET: {
          AttributeName: 'BOKBAR_AKTIVITET',
          DisplayLabel: 'Bokbar på aktivitet (web)',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        AUTOSYNK: {
          AttributeName: 'AUTOSYNK',
          DisplayLabel: 'Synkroniseras med Outlook',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        SYNKA_DOK: {
          AttributeName: 'SYNKA_DOK',
          DisplayLabel: 'Synka dokument',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        SYNCDATE: {
          AttributeName: 'SYNCDATE',
          DisplayLabel: 'Senast synkroniserad',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SYNCTIME: {
          AttributeName: 'SYNCTIME',
          DisplayLabel: 'Senast synkroniserad tid',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        SYNKA_TEXT: {
          AttributeName: 'SYNKA_TEXT',
          DisplayLabel: 'Synka meddelandetext',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
        },
        RESURSNAMN_EXTERN: {
          AttributeName: 'RESURSNAMN_EXTERN',
          DisplayLabel: 'Externt resursnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        Resursnamn: {
          AttributeName: 'Resursnamn',
          DisplayLabel: 'Resursens namn',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Resurstyp_Inkl: {
          AttributeName: 'Resurstyp_Inkl',
          DisplayLabel: 'Resurstyp (inkl underliggande)',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesSubsystem', 'BO;'], ['ConditionShowValuesCollection', 'TEDBOResurstypSaml;'], ['ConditionShowValuesAttribute', 'BO_RESURSTYP_NAMN;']]),
        },
        SKK_PLACE_ID: {
          AttributeName: 'SKK_PLACE_ID',
          DisplayLabel: 'Publicering platsid',
          Hint: 'Ett platsid som finns i Svenska Kyrkans kalender',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        SKK_ORG_ID: {
          AttributeName: 'SKK_ORG_ID',
          DisplayLabel: 'Publicering enhetsid',
          Hint: 'Ett enhetsid som finns i Svenska Kyrkans kalender',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PRIO_ORDNING: {
          AttributeName: 'PRIO_ORDNING',
          DisplayLabel: 'Prioriteringsordning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less],
          DefaultCondOperator: T.interval,
        },
        SKK_PUBLIK_WEB: {
          AttributeName: 'SKK_PUBLIK_WEB',
          DisplayLabel: 'Publiceras på Web',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        SKK_ORG_WSSURL: {
          AttributeName: 'SKK_ORG_WSSURL',
          DisplayLabel: 'wssURL',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ADRESSPAUTSKRIFT: {
          AttributeName: 'ADRESSPAUTSKRIFT',
          DisplayLabel: 'Adress på utskrift',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KBIntaktskonto: {
          AttributeName: 'KBIntaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Intaktskonto: {
          AttributeName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ResursSok: {
          AttributeName: 'ResursSok',
          DisplayLabel: 'Resurssökning (ID, typ eller underliggande)',
          DataType: 'String',
          Attribute: 'None',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        SKK_REGION_ID: {
          AttributeName: 'SKK_REGION_ID',
          DisplayLabel: 'Publicering regionid/projektid',
          Hint: 'ID för de enheter som inte har EnhetsID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        XB_RESURS_ID: {
          AttributeName: 'XB_RESURS_ID',
          DisplayLabel: 'Skall bort',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XBResursEmail: {
          AttributeName: 'XBResursEmail',
          DisplayLabel: 'XBridge, resursens epost',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        XB_SYNK: {
          AttributeName: 'XB_SYNK',
          DisplayLabel: 'Synkroniseras med XBridge',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        IsSynchronized: {
          AttributeName: 'IsSynchronized',
          DisplayLabel: 'Automatisk synkronisering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        XB_ERROR: {
          AttributeName: 'XB_ERROR',
          DisplayLabel: 'XBridge, felmeddelande',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          Properties: new Map([['ffIgnoreChanges', 'Y']]),
        },
        HasXBError: {
          AttributeName: 'HasXBError',
          DisplayLabel: 'XBridge, fel',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        DOPLOKAL: {
          AttributeName: 'DOPLOKAL',
          DisplayLabel: 'Doplokal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        VIGSELLOKAL: {
          AttributeName: 'VIGSELLOKAL',
          DisplayLabel: 'Vigsellokal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        WEBB_LINK: {
          AttributeName: 'WEBB_LINK',
          DisplayLabel: 'Webblänk',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        WEBB_INFO: {
          AttributeName: 'WEBB_INFO',
          DisplayLabel: 'Webbinfo',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        WEBB_IMGLINK: {
          AttributeName: 'WEBB_IMGLINK',
          DisplayLabel: 'Bildlänk',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        STATUS_DATUM: {
          AttributeName: 'STATUS_DATUM',
          DisplayLabel: 'Senast ändrad status',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GALLRAD: {
          AttributeName: 'GALLRAD',
          DisplayLabel: 'Gallrad',
          Hint: 'Nej/Ja/Preliminärt',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja'], ['PRELIMINART', 'Preliminärt']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y'], ['PRELIMINART', 'P']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja;PRELIMINART=Preliminärt"',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        GALLRAD_DATUM: {
          AttributeName: 'GALLRAD_DATUM',
          DisplayLabel: 'Gallrad, datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        FORSAMLINGS_ID: {
          AttributeName: 'FORSAMLINGS_ID',
          DisplayLabel: 'FörsamlingsID',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANSTALLNINGSNUMMER: {
          AttributeName: 'ANSTALLNINGSNUMMER',
          DisplayLabel: 'FLEX anställningsnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.hasvalue,
        },
        SKK_API22_PLACE_ID: {
          AttributeName: 'SKK_API22_PLACE_ID',
          DisplayLabel: 'Nationella kalendern, plats-id',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.hasvalue,
        },
        SKK_API22_PLACE_NAME: {
          AttributeName: 'SKK_API22_PLACE_NAME',
          DisplayLabel: 'Nationella kalendern, platsnamn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        ResArbetstider: {
          AssociationName: 'ResArbetstider',
          DisplayLabel: 'Arbetstider',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOArbetstid',
          AssociatedComponentName: 'Arbetstid',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ResRestyp: {
          AssociationName: 'ResRestyp',
          DisplayLabel: 'Resurstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurstyp',
          AssociatedComponentName: 'Resurstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'BO_RESURSTYP_NAMN,Bastyp;'], ['OverrideDisplayLabels', 'BO_RESURSTYP_NAMN="Resurstyp";']]),
          Required: true,
        },
        OPL: {
          AssociationName: 'OPL',
          DisplayLabel: 'Adress/Lokal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OPOrgPersLok',
          AssociatedComponentName: 'OrgPersLok',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Anvandare: {
          AssociationName: 'Anvandare',
          DisplayLabel: 'Användare',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSUser',
          AssociatedComponentName: 'User',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktTyp: {
          AssociationName: 'AktTyp',
          DisplayLabel: 'Aktivitetstyp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitetstyp',
          AssociatedComponentName: 'Aktivitetstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([['IntegratedFilter', 'NAMN;'], ['OverrideDisplayLabels', 'NAMN="Aktivitetstyp";']]),
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ResArbetspass: {
          AssociationName: 'ResArbetspass',
          DisplayLabel: 'Arbetspass',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOArbetspass',
          AssociatedComponentName: 'Arbetspass',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Kyrkogard: {
          AssociationName: 'Kyrkogard',
          DisplayLabel: 'Kyrkogård',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GAKGard',
          AssociatedComponentName: 'KGard',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Forsamling: {
          AssociationName: 'Forsamling',
          DisplayLabel: 'Församling för statistik',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSStatistikinstallningar',
          AssociatedComponentName: 'Statistikinstallningar',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokningsrubrik: {
          AssociationName: 'Bokningsrubrik',
          DisplayLabel: 'Bokningsrubrik',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        BokGruppResurs: {
          AssociationName: 'BokGruppResurs',
          DisplayLabel: 'Bokningsgrupp av resurser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBoknGruppResurs',
          AssociatedComponentName: 'BoknGruppResurs',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Resursplanering: {
          AssociationName: 'Resursplanering',
          DisplayLabel: 'Resursplanering',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResursPlanering',
          AssociatedComponentName: 'ResursPlanering',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResursDok',
          AssociatedComponentName: 'ResursDok',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        ResArt: {
          AssociationName: 'ResArt',
          DisplayLabel: 'Resursens artiklar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResursArtikel',
          AssociatedComponentName: 'ResursArtikel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resurstyper: {
          AssociationName: 'Resurstyper',
          DisplayLabel: 'Resurstyper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOInkluderadRestyp',
          AssociatedComponentName: 'InkluderadRestyp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOResursArtikel: {
      CollectionName: 'BOResursArtikel',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ResursArtikel',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOResursArtikels primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOResursArtikels versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOResursArtikels fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOJourResurs: {
      CollectionName: 'BOJourResurs',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'JourResurs',
        Abstract: false,
        SOLabel: 'Resurserns jourresurs',
        SOGLabel: 'Resurserns jourresurs',
        SBLabel: 'Resurserns jourresurs',
        SBGLabel: 'Resurserns jourresurs',
        POLabel: 'Resurserns jourresurser',
        POGLabel: 'Resurserns jourresurser',
        PBLabel: 'Resurserns jourresurser',
        PBGLabel: 'Resurserns jourresurser',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resurserns jourresurs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resurserns jourresurs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resurserns jourresurs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Jourtid: {
          AssociationName: 'Jourtid',
          DisplayLabel: 'Jourtid',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOJourtid',
          AssociatedComponentName: 'Jourtid',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOResursgrupp: {
      CollectionName: 'BOResursgrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Resursgrupp',
        Abstract: false,
        SOLabel: 'Resursgrupp',
        SOGLabel: 'Resursgrupp',
        SBLabel: 'Resursgrupp',
        SBGLabel: 'Resursgrupp',
        POLabel: 'Resursgrupp',
        POGLabel: 'Resursgrupp',
        PBLabel: 'Resursgrupp',
        PBGLabel: 'Resursgrupp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resursgrupp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resursgrupp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resursgrupp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurser: {
          AssociationName: 'Resurser',
          DisplayLabel: 'Resurser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResursgruppResurs',
          AssociatedComponentName: 'ResursgruppResurs',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOResursgruppResurs: {
      CollectionName: 'BOResursgruppResurs',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ResursgruppResurs',
        Abstract: false,
        SOLabel: 'Resursgrupp resurs',
        SOGLabel: 'Resursgrupp resurs',
        SBLabel: 'Resursgrupp resurs',
        SBGLabel: 'Resursgrupp resurs',
        POLabel: 'Resursgrupp resurs',
        POGLabel: 'Resursgrupp resurs',
        PBLabel: 'Resursgrupp resurs',
        PBGLabel: 'Resursgrupp resurs',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resursgrupp resurs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resursgrupp resurs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resursgrupp resurs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Resurs: {
          AssociationName: 'Resurs',
          DisplayLabel: 'Resurs',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOResrubrik: {
      CollectionName: 'BOResrubrik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '1038,1039,16001']]),
      RootType: {
        TypeValue: 'Resrubrik',
        Abstract: false,
        SOLabel: 'Resursrubrik',
        SOGLabel: 'Resursrubrik',
        SBLabel: 'Resursrubriken',
        SBGLabel: 'Resursrubriken',
        POLabel: 'Resursrubriker',
        POGLabel: 'Resursrubriker',
        PBLabel: 'Resursrubrikerna',
        PBGLabel: 'Resursrubrikerna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resursrubriken primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resursrubriken versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Resursrubriken id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resursrubriken fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Resursrubrikskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RUBRIK: {
          AttributeName: 'RUBRIK',
          DisplayLabel: 'Rubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        TILLAT_RESTYP_ID: {
          AttributeName: 'TILLAT_RESTYP_ID',
          DisplayLabel: 'Tillåten resurstyp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FORESL_RESTYP_ID: {
          AttributeName: 'FORESL_RESTYP_ID',
          DisplayLabel: 'Föreslagen resurstyp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TillResTyp: {
          AttributeName: 'TillResTyp',
          DisplayLabel: 'Tillåten resurstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        ForeslResTyp: {
          AttributeName: 'ForeslResTyp',
          DisplayLabel: 'Föreslagen resurstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        TillatResTyp: {
          AssociationName: 'TillatResTyp',
          DisplayLabel: 'Tillåten resurstyp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurstyp',
          AssociatedComponentName: 'Resurstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ForeslRestyp: {
          AssociationName: 'ForeslRestyp',
          DisplayLabel: 'Föreslagen resurstyp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurstyp',
          AssociatedComponentName: 'Resurstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        AktTypResrubrik: {
          AssociationName: 'AktTypResrubrik',
          DisplayLabel: 'Resursrubrik på aktivitetstyp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktTypResrubrik',
          AssociatedComponentName: 'AktTypResrubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktivitetResrubrik: {
      CollectionName: 'BOAktivitetResrubrik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktivitetResrubrik',
        Abstract: false,
        SOLabel: 'Resursrubrik per aktivitet',
        SOGLabel: 'Resursrubrik per aktivitet',
        SBLabel: 'Resursrubriken per aktivitet',
        SBGLabel: 'Resursrubriken per aktivitet',
        POLabel: 'Resursrubriker per aktivitet',
        POGLabel: 'Resursrubriker per aktivitet',
        PBLabel: 'Resursrubrikerna per aktivitet',
        PBGLabel: 'Resursrubrikerna per aktivitet',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resursrubriken per aktivitet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resursrubriken per aktivitet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Resursrubriken per aktivitet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resursrubriken per aktivitet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        POSNR: {
          AttributeName: 'POSNR',
          DisplayLabel: 'Position',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RESRUBRIK_ID: {
          AttributeName: 'RESRUBRIK_ID',
          DisplayLabel: 'Resursrubrik',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Resursrubrik: {
          AttributeName: 'Resursrubrik',
          DisplayLabel: 'Resursrubrik',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Resrubrik: {
          AssociationName: 'Resrubrik',
          DisplayLabel: 'Resursrubrik',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResrubrik',
          AssociatedComponentName: 'Resrubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokningsrubrik: {
          AssociationName: 'Bokningsrubrik',
          DisplayLabel: 'Bokningsrubrik',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOBokningsrubrik',
          AssociatedComponentName: 'BokningsRubrik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAktTypResrubrik: {
      CollectionName: 'BOAktTypResrubrik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'AktTypResrubrik',
        Abstract: false,
        SOLabel: 'Resursrubrik på aktivitetstyp',
        SOGLabel: 'Resursrubrik på aktivitetstyp',
        SBLabel: 'Resursrubriken på aktivitetstyp',
        SBGLabel: 'Resursrubriken på aktivitetstyp',
        POLabel: 'Resursrubrikerna på aktivitetstyp',
        POGLabel: 'Resursrubrikerna på aktivitetstyp',
        PBLabel: 'Resursrubriker på aktivitetstyp',
        PBGLabel: 'Resursrubriker på aktivitetstyp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resursrubriken på aktivitetstyp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resursrubriken på aktivitetstyp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Resursrubriken på aktivitetstyp id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resursrubriken på aktivitetstyp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKTTYP_FORK: {
          AttributeName: 'AKTTYP_FORK',
          DisplayLabel: 'Aktivitetstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        POSNR: {
          AttributeName: 'POSNR',
          DisplayLabel: 'Position',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        RESRUBRIK_ID: {
          AttributeName: 'RESRUBRIK_ID',
          DisplayLabel: 'Resursrubrik',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRAN_TIDSDIFF: {
          AttributeName: 'FRAN_TIDSDIFF',
          DisplayLabel: 'Från tidsdiffererns',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        TILL_TIDSDIFF: {
          AttributeName: 'TILL_TIDSDIFF',
          DisplayLabel: 'Till tidsdifferens',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        VIEW_ID: {
          AttributeName: 'VIEW_ID',
          DisplayLabel: 'Urval',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ANTALBEKR: {
          AttributeName: 'ANTALBEKR',
          DisplayLabel: 'Antal bokningsbekräftelser',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        Rubrik: {
          AttributeName: 'Rubrik',
          DisplayLabel: 'Resursrubrik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SKK_WEB_PUBLICERAS: {
          AttributeName: 'SKK_WEB_PUBLICERAS',
          DisplayLabel: 'Publiceras på webb',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
        },
        URVAL_ID: {
          AttributeName: 'URVAL_ID',
          DisplayLabel: 'Urval från Aveny 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTRA_BOOK_TIME_BEFORE_AKTIVITY: {
          AttributeName: 'EXTRA_BOOK_TIME_BEFORE_AKTIVITY',
          DisplayLabel: 'Extra bokningstid före aktivitet',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        EXTRA_BOOK_TIME_AFTER_AKTIVITY: {
          AttributeName: 'EXTRA_BOOK_TIME_AFTER_AKTIVITY',
          DisplayLabel: 'Extra booking time after aktivitet',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        AktTyp: {
          AssociationName: 'AktTyp',
          DisplayLabel: 'Aktivitetstyp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOAktivitetstyp',
          AssociatedComponentName: 'Aktivitetstyp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Resrubrik: {
          AssociationName: 'Resrubrik',
          DisplayLabel: 'Resursrubrik',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResrubrik',
          AssociatedComponentName: 'Resrubrik',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokningsgrupp: {
          AssociationName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokngrupp',
          AssociatedComponentName: 'Bokngrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOResurstyp: {
      CollectionName: 'BOResurstyp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['AllowSelection', '1039,16001']]),
      RootType: {
        TypeValue: 'Resurstyp',
        Abstract: false,
        SOLabel: 'Resurstyp',
        SOGLabel: 'Resurstyp',
        SBLabel: 'Resurstypen',
        SBGLabel: 'Resurstypen',
        POLabel: 'Resurstyper',
        POGLabel: 'Resurstyper',
        PBLabel: 'Resurstyperna',
        PBGLabel: 'Resurstyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Resurstypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Resurstypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Resurstypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Resurstypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BO_RESURSTYP_NAMN: {
          AttributeName: 'BO_RESURSTYP_NAMN',
          DisplayLabel: 'Resurstypens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 25,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        FORALDRATYP: {
          AttributeName: 'FORALDRATYP',
          DisplayLabel: 'Föräldratyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KYRKOGARD: {
          AttributeName: 'KYRKOGARD',
          DisplayLabel: 'Kyrkogård',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterValidateParams: 'ValidValues="Y;N"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        MUSIKER: {
          AttributeName: 'MUSIKER',
          DisplayLabel: 'Musiker',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PRAST: {
          AttributeName: 'PRAST',
          DisplayLabel: 'Präst',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        PRIO_ORDNING: {
          AttributeName: 'PRIO_ORDNING',
          DisplayLabel: 'Prioordning',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        PLATS: {
          AttributeName: 'PLATS',
          DisplayLabel: 'Plats',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        KYLRUM: {
          AttributeName: 'KYLRUM',
          DisplayLabel: 'Kylrum',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        Bastyp: {
          AttributeName: 'Bastyp',
          DisplayLabel: 'Bastyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        RestypRes: {
          AssociationName: 'RestypRes',
          DisplayLabel: 'RestypRes',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOResurs',
          AssociatedComponentName: 'Resurs',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        InkluderadResTyp: {
          AssociationName: 'InkluderadResTyp',
          DisplayLabel: 'Inkluderade resurstyper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOInkluderadRestyp',
          AssociatedComponentName: 'InkluderadRestyp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOSammankomst: {
      CollectionName: 'BOSammankomst',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Sammankomst',
        Abstract: false,
        SOLabel: 'Sammankomst',
        SOGLabel: 'Sammankomst',
        SBLabel: 'Sammankomsten',
        SBGLabel: 'Sammankomsten',
        POLabel: 'Sammankomster',
        POGLabel: 'Sammankomster',
        PBLabel: 'Sammankomsterna',
        PBGLabel: 'Sammankomsterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Sammankomsten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Sammankomsten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Sammankomsten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Sammankomsten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'Grupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_ID: {
          AttributeName: 'AKT_ID',
          DisplayLabel: 'Aktivitets id',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATUM: {
          AttributeName: 'DATUM',
          DisplayLabel: 'Datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          FormatterValidateParams: 'MaxDate="+24m";MinDate="-120m";MaxRecommendedDate="+12m";MinRecommendedDate="-10m"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        FRAN_TID: {
          AttributeName: 'FRAN_TID',
          DisplayLabel: 'Från tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        TILL_TID: {
          AttributeName: 'TILL_TID',
          DisplayLabel: 'Till tid',
          DataType: 'Time',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatTimeMinute',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Titel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        NOTERING: {
          AttributeName: 'NOTERING',
          DisplayLabel: 'Notering',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AktivitetTitel: {
          AttributeName: 'AktivitetTitel',
          DisplayLabel: 'Aktivitetens titel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktivitetBokNr: {
          AttributeName: 'AktivitetBokNr',
          DisplayLabel: 'Aktivitet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AktivitetBokNrTitel: {
          AttributeName: 'AktivitetBokNrTitel',
          DisplayLabel: 'Aktivitetens boknr och titel',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalNarv: {
          AttributeName: 'AntalNarv',
          DisplayLabel: 'Antal närvarande',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AntalFranv: {
          AttributeName: 'AntalFranv',
          DisplayLabel: 'Antal frånvarande',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        TidPunkt: {
          AttributeName: 'TidPunkt',
          DisplayLabel: 'Tid',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GruppNamn: {
          AttributeName: 'GruppNamn',
          DisplayLabel: 'Grupp av personer',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Grupp: {
          AssociationName: 'Grupp',
          DisplayLabel: 'Grupp',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOGruppOP',
          AssociatedComponentName: 'GruppOP',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Narvaro: {
          AssociationName: 'Narvaro',
          DisplayLabel: 'Närvaro',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BONarvaro',
          AssociatedComponentName: 'Narvaro',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOSKKPlats: {
      CollectionName: 'BOSKKPlats',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SKKPlats',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOSKKPlatss primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOSKKPlatss versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOSKKPlatss fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        PLACE_ID: {
          AttributeName: 'PLACE_ID',
          DisplayLabel: 'Plats id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        ORG_ID: {
          AttributeName: 'ORG_ID',
          DisplayLabel: 'Organisations id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        SKK_REGION_ID: {
          AttributeName: 'SKK_REGION_ID',
          DisplayLabel: 'RegionID/ProjektID',
          Hint: 'ID för de enheter som inte har OrgID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOStatistikKategori: {
      CollectionName: 'BOStatistikKategori',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'StatistikKategori',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOStatistikKategoris primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOStatistikKategoris versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOStatistikKategoris fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CATEGORY: {
          AttributeName: 'CATEGORY',
          DisplayLabel: 'Statistik Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SenastUppdaterad: {
          AttributeName: 'SenastUppdaterad',
          DisplayLabel: 'Senast uppaterad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          AttributeParams: {'EnhetsID': {type: 'Int', defaultValue: '0'}, 'PerAr': {type: 'Date', defaultValue: 'Date'}},
        },
        CAPTION1: {
          AttributeName: 'CAPTION1',
          DisplayLabel: 'Caption 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION2: {
          AttributeName: 'CAPTION2',
          DisplayLabel: 'Caption 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT1: {
          AttributeName: 'HINT1',
          DisplayLabel: 'Hint 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT2: {
          AttributeName: 'HINT2',
          DisplayLabel: 'Hint 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LBL_HINT1: {
          AttributeName: 'LBL_HINT1',
          DisplayLabel: 'Label hint 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LBL_HINT2: {
          AttributeName: 'LBL_HINT2',
          DisplayLabel: 'Label hint 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION3: {
          AttributeName: 'CAPTION3',
          DisplayLabel: 'Caption 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT3: {
          AttributeName: 'HINT3',
          DisplayLabel: 'Hint 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LBL_HINT3: {
          AttributeName: 'LBL_HINT3',
          DisplayLabel: 'Label hint 3',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION4: {
          AttributeName: 'CAPTION4',
          DisplayLabel: 'Caption 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION5: {
          AttributeName: 'CAPTION5',
          DisplayLabel: 'Caption 5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION6: {
          AttributeName: 'CAPTION6',
          DisplayLabel: 'Caption 6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION7: {
          AttributeName: 'CAPTION7',
          DisplayLabel: 'Caption 7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION8: {
          AttributeName: 'CAPTION8',
          DisplayLabel: 'Caption 8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION9: {
          AttributeName: 'CAPTION9',
          DisplayLabel: 'Caption 9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION10: {
          AttributeName: 'CAPTION10',
          DisplayLabel: 'Caption 10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CAPTION11: {
          AttributeName: 'CAPTION11',
          DisplayLabel: 'Caption 11',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT4: {
          AttributeName: 'HINT4',
          DisplayLabel: 'Hint 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LBL_HINT4: {
          AttributeName: 'LBL_HINT4',
          DisplayLabel: 'Label hint 4',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT5: {
          AttributeName: 'HINT5',
          DisplayLabel: 'Hint 5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LBL_HINT5: {
          AttributeName: 'LBL_HINT5',
          DisplayLabel: 'Label hint 5',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT6: {
          AttributeName: 'HINT6',
          DisplayLabel: 'Hint 6',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT7: {
          AttributeName: 'HINT7',
          DisplayLabel: 'Hint 7',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT8: {
          AttributeName: 'HINT8',
          DisplayLabel: 'Hint8',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT9: {
          AttributeName: 'HINT9',
          DisplayLabel: 'Hint 9',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT10: {
          AttributeName: 'HINT10',
          DisplayLabel: 'Hint 10',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HINT11: {
          AttributeName: 'HINT11',
          DisplayLabel: 'Hint 11',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Statistik: {
          AssociationName: 'Statistik',
          DisplayLabel: 'Årsbaserad statistik',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOArsbaseradStatistik',
          AssociatedComponentName: 'ArsbaseradStatistik',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOBoknBestSettings: {
      CollectionName: 'BOBoknBestSettings',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'BoknBestSettings',
        Abstract: false,
        SOLabel: 'Styrvärden bokningsbeställningar',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: 'Styrvärden bokningsbeställningar',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOBoknBestSettingss primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOBoknBestSettingss versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOBoknBestSettingss fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BEKRTEXT: {
          AttributeName: 'BEKRTEXT',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6000,
          InterfaceType: 'ifNone',
        },
        DOPKALASIKON: {
          AttributeName: 'DOPKALASIKON',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        DOPKALASTEXT: {
          AttributeName: 'DOPKALASTEXT',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifNone',
        },
        KRAVVARD2: {
          AttributeName: 'KRAVVARD2',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        OVRIGAONSKEMALDOP: {
          AttributeName: 'OVRIGAONSKEMALDOP',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifNone',
        },
        DOPKANDINFO: {
          AttributeName: 'DOPKANDINFO',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2000,
          InterfaceType: 'ifNone',
        },
        VARDINFO: {
          AttributeName: 'VARDINFO',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2000,
          InterfaceType: 'ifNone',
        },
        BROLLOPSFESTIKON: {
          AttributeName: 'BROLLOPSFESTIKON',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifNone',
        },
        BROLLOPSFESTTEXT: {
          AttributeName: 'BROLLOPSFESTTEXT',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifNone',
        },
        OVRIGAONSKEMALVIGSEL: {
          AttributeName: 'OVRIGAONSKEMALVIGSEL',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifNone',
        },
        BRUDPARINFO: {
          AttributeName: 'BRUDPARINFO',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 2000,
          InterfaceType: 'ifNone',
        },
        BEKRMAILAMNE: {
          AttributeName: 'BEKRMAILAMNE',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifNone',
        },
        BEKRMAILAVS: {
          AttributeName: 'BEKRMAILAVS',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifNone',
        },
        BEKRMAILMSG: {
          AttributeName: 'BEKRMAILMSG',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6000,
          InterfaceType: 'ifNone',
        },
        NEKAMAILAMNE: {
          AttributeName: 'NEKAMAILAMNE',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifNone',
        },
        NEKAMAILAVS: {
          AttributeName: 'NEKAMAILAVS',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifNone',
        },
        NEKAMAILMSG: {
          AttributeName: 'NEKAMAILMSG',
          DisplayLabel: 'Länk till information om personuppgiftslagring',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6000,
          InterfaceType: 'ifNone',
        },
        GDPRDOP: {
          AttributeName: 'GDPRDOP',
          DisplayLabel: 'Personuppgiftslagring dop',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6000,
          InterfaceType: 'ifNone',
        },
        GDPRVIGSEL: {
          AttributeName: 'GDPRVIGSEL',
          DisplayLabel: 'Personuppgiftslagring vigsel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6000,
          InterfaceType: 'ifNone',
        },
        FRAMSIDAN: {
          AttributeName: 'FRAMSIDAN',
          DisplayLabel: 'Webbadress Aveny Framsidan',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifNone',
        },
        ORGNAMN: {
          AttributeName: 'ORGNAMN',
          DisplayLabel: 'Pastoratets namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifNone',
        },
        WEBB_LINK_DOPDRAKT: {
          AttributeName: 'WEBB_LINK_DOPDRAKT',
          DisplayLabel: 'Webblänk dopdräkt',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        WEBB_LINK_BRUDKRONA: {
          AttributeName: 'WEBB_LINK_BRUDKRONA',
          DisplayLabel: 'Webblänk brudkrona',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        GDPR_LINK_DOP: {
          AttributeName: 'GDPR_LINK_DOP',
          DisplayLabel: 'Weblänk GDPR dop',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1000,
        },
        GDPR_LINK_VIGSEL: {
          AttributeName: 'GDPR_LINK_VIGSEL',
          DisplayLabel: 'Weblänk GDPR vigsel',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1000,
        },
        GDPR_LINK_INFO: {
          AttributeName: 'GDPR_LINK_INFO',
          DisplayLabel: 'Weblänk GDPR information',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1000,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BEKRMAILNAMN: {
          AttributeName: 'BEKRMAILNAMN',
          DisplayLabel: 'Avsändarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
        },
        NEKAMAILNAMN: {
          AttributeName: 'NEKAMAILNAMN',
          DisplayLabel: 'Avsändarens namn',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
        },
        AVPUBL_DOPKALAS: {
          AttributeName: 'AVPUBL_DOPKALAS',
          DisplayLabel: 'Aktivera automatisk avpublicering av dopkalas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVPUBL_BROLLOPSFEST: {
          AttributeName: 'AVPUBL_BROLLOPSFEST',
          DisplayLabel: 'Aktivera automatisk avpublicering av bröllopsfest',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ERBJUD_DOP_KLANNING: {
          AttributeName: 'ERBJUD_DOP_KLANNING',
          DisplayLabel: 'Erbjud dopklänning i webbformuläret',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ERBJUD_BRUDKRONA: {
          AttributeName: 'ERBJUD_BRUDKRONA',
          DisplayLabel: 'Erbjud brudkrona i webbformuläret',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOUtcheckningsstatusStoft: {
      CollectionName: 'BOUtcheckningsstatusStoft',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UtcheckningsStatusStoft',
        Abstract: false,
        SOLabel: 'Utcheckningsstatus',
        SOGLabel: 'Utcheckningsstatus',
        SBLabel: 'Utcheckningsstatusen',
        SBGLabel: 'Utcheckningsstatusens',
        POLabel: 'Utcheckningsstatusar',
        POGLabel: 'Utcheckningsstatusars',
        PBLabel: 'Utcheckningsstatusarna',
        PBGLabel: 'Utcheckningsstatusarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utcheckningsstatusens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utcheckningsstatusens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utcheckningsstatusens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utcheckningsstatusens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        TILLBAKA: {
          AttributeName: 'TILLBAKA',
          DisplayLabel: 'Tillbaka',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BLOCKERA_VID_TVIST: {
          AttributeName: 'BLOCKERA_VID_TVIST',
          DisplayLabel: 'Blockera vid tvist',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOKAL_ID: {
          AttributeName: 'LOKAL_ID',
          DisplayLabel: 'Id, lokal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BLOCKERA_TVIST_GRAVS: {
          AttributeName: 'BLOCKERA_TVIST_GRAVS',
          DisplayLabel: 'Blockera vid tvist om gravsättning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        STATUSTYP: {
          AttributeName: 'STATUSTYP',
          DisplayLabel: 'Statustyp',
          Hint: 'Ceremoni/Ceremoni & Gravsättning, avslutad/Transport/Gravsättning, avslutad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="Ceremoni=C;Ceremoni & Gravsättning, avslutad=G;Transport=T;Gravsättning, avslutad=X"',
          FormatterDisplayParams: 'TranslateValues="C=Ceremoni;G=Ceremoni & Gravsättning, avslutad;T=Transport;X=Gravsättning, avslutad"',
          FormatterValidateParams: 'ValidValues="C;G;T;X"',
          GUIEditable: true,
          MaxInputLength: 33,
          InterfaceType: 'ifTypeTree',
        },
        PERSONAL: {
          AttributeName: 'PERSONAL',
          DisplayLabel: 'Endast Personal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVHAMTAD_KREMJOURNAL: {
          AttributeName: 'AVHAMTAD_KREMJOURNAL',
          DisplayLabel: 'Avhämtad i kremationsjournalen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lokal: {
          AssociationName: 'Lokal',
          DisplayLabel: 'Lokal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningslokal',
          AssociatedComponentName: 'Bisattningslokal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOUtcheckningsstatus: {
      CollectionName: 'BOUtcheckningsstatus',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Utcheckningsstatus',
        Abstract: false,
        SOLabel: 'Utcheckningsstatus',
        SOGLabel: 'Utcheckningsstatus',
        SBLabel: 'Utcheckningsstatusen',
        SBGLabel: 'Utcheckningsstatusens',
        POLabel: 'Utcheckningsstatusar',
        POGLabel: 'Utcheckningsstatusars',
        PBLabel: 'Utcheckningsstatusarna',
        PBGLabel: 'Utcheckningsstatusarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Utcheckningsstatusens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Utcheckningsstatusens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Utcheckningsstatusens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Utcheckningsstatusens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        TILLBAKA: {
          AttributeName: 'TILLBAKA',
          DisplayLabel: 'Tillbaka',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        BLOCKERA_VID_TVIST: {
          AttributeName: 'BLOCKERA_VID_TVIST',
          DisplayLabel: 'Blockera vid tvist',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOKAL_ID: {
          AttributeName: 'LOKAL_ID',
          DisplayLabel: 'Id, lokal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BLOCKERA_TVIST_GRAVS: {
          AttributeName: 'BLOCKERA_TVIST_GRAVS',
          DisplayLabel: 'Blockera vid tvist om gravsättning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        STATUSTYP: {
          AttributeName: 'STATUSTYP',
          DisplayLabel: 'Statustyp',
          Hint: 'Ceremoni/Ceremoni & Kremering/Ceremoni & Gravsättning, avslutad/Visning/Transport/Kremering/Gravsättning, avslutad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="Ceremoni=C;Ceremoni & Kremering=K;Ceremoni & Gravsättning, avslutad=G;Visning=V;Transport=T;Kremering=R;Gravsättning, avslutad=X"',
          FormatterDisplayParams: 'TranslateValues="C=Ceremoni;K=Ceremoni & Kremering;G=Ceremoni & Gravsättning, avslutad;V=Visning;T=Transport;R=Kremering;X=Gravsättning, avslutad"',
          FormatterValidateParams: 'ValidValues="C;K;G;V;T;R;X"',
          GUIEditable: true,
          MaxInputLength: 33,
          InterfaceType: 'ifTypeTree',
        },
        PERSONAL: {
          AttributeName: 'PERSONAL',
          DisplayLabel: 'Endast Personal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVHAMTAD_KREMJOURNAL: {
          AttributeName: 'AVHAMTAD_KREMJOURNAL',
          DisplayLabel: 'Avhämtad i kremationsjournalen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lokal: {
          AssociationName: 'Lokal',
          DisplayLabel: 'Lokal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningslokal',
          AssociatedComponentName: 'Bisattningslokal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOUtcheckningsstatusUrna: {
      CollectionName: 'BOUtcheckningsstatusUrna',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'UtcheckningsstatusUrna',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOUtcheckningsstatusUrnas primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOUtcheckningsstatusUrnas versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'BOUtcheckningsstatusUrnas id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOUtcheckningsstatusUrnas fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 100,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        TILLBAKA: {
          AttributeName: 'TILLBAKA',
          DisplayLabel: 'Tillbaka',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BLOCKERA_VID_TVIST: {
          AttributeName: 'BLOCKERA_VID_TVIST',
          DisplayLabel: 'Blockera vid tvist',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        LOKAL_ID: {
          AttributeName: 'LOKAL_ID',
          DisplayLabel: 'Id, lokal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BLOCKERA_TVIST_GRAVS: {
          AttributeName: 'BLOCKERA_TVIST_GRAVS',
          DisplayLabel: 'Blockera vid tvist om gravsättning',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 50,
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Borttagen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 1,
        },
        STATUSTYP: {
          AttributeName: 'STATUSTYP',
          DisplayLabel: 'Statustyp',
          Hint: 'Ceremoni/Ceremoni & Gravsättning, avslutad/Transport/Gravsättning, avslutad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterParseParams: 'TranslateValues="Ceremoni=C;Ceremoni & Gravsättning, avslutad=G;Transport=T;Gravsättning, avslutad=X"',
          FormatterDisplayParams: 'TranslateValues="C=Ceremoni;G=Ceremoni & Gravsättning, avslutad;T=Transport;X=Gravsättning, avslutad"',
          FormatterValidateParams: 'ValidValues="C;G;T;X"',
          GUIEditable: true,
          MaxInputLength: 33,
          InterfaceType: 'ifTypeTree',
        },
        PERSONAL: {
          AttributeName: 'PERSONAL',
          DisplayLabel: 'Endast Personal',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        AVHAMTAD_KREMJOURNAL: {
          AttributeName: 'AVHAMTAD_KREMJOURNAL',
          DisplayLabel: 'Avhämtad i kremationsjournalen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 1,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Lokal: {
          AssociationName: 'Lokal',
          DisplayLabel: 'Lokal',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOBisattningslokal',
          AssociatedComponentName: 'Bisattningslokal',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOVerktypBoknGrupp: {
      CollectionName: 'BOVerktypBoknGrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'VerktypBoknGrupp',
        Abstract: false,
        SOLabel: 'Verksamhetens bokningsgrupp',
        SOGLabel: 'Verksamhetens bokningsgrupp',
        SBLabel: 'Verksamhetens bokningsgrupp',
        SBGLabel: 'Verksamhetens bokningsgrupp',
        POLabel: 'Verksamheternas bokningsgrupp',
        POGLabel: 'Verksamheternas bokningsgrupp',
        PBLabel: 'Verksamheternas bokningsgrupp',
        PBGLabel: 'Verksamheternas bokningsgrupp',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verksamhetens bokningsgrupp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verksamhetens bokningsgrupp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verksamhetens bokningsgrupp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Verksamhetstyp: {
          AssociationName: 'Verksamhetstyp',
          DisplayLabel: 'Verksamhetstyp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOVerksamhetstyper',
          AssociatedComponentName: 'Verksamhetstyper',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Bokningsgrupp: {
          AssociationName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'SYSBokngrupp',
          AssociatedComponentName: 'Bokngrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOVerkstypAmnesomrade: {
      CollectionName: 'BOVerkstypAmnesomrade',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'VerkstypAmnesomrade',
        Abstract: false,
        SOLabel: 'Verksamhetstypens ämnesområde',
        SOGLabel: 'Verksamhetstypens ämnesområde',
        SBLabel: 'Verksamhetstypens ämnesområde',
        SBGLabel: 'Verksamhetstypens ämnesområde',
        POLabel: 'Verksamhetstypens ämnesområde',
        POGLabel: 'Verksamhetstypens ämnesområde',
        PBLabel: 'Verksamhetstypens ämnesområde',
        PBGLabel: 'Verksamhetstypens ämnesområde',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verksamhetstypens ämnesområde primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verksamhetstypens ämnesområde versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verksamhetstypens ämnesområde fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Amnesomrade: {
          AttributeName: 'Amnesomrade',
          DisplayLabel: 'Ämnesområde',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Bokningsgrupp: {
          AttributeName: 'Bokningsgrupp',
          DisplayLabel: 'Bokningsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
      },
      Associations: {
        Amnesomrade: {
          AssociationName: 'Amnesomrade',
          DisplayLabel: 'Ämnesområde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKKAmnesomraden',
          AssociatedComponentName: 'SKKAmnesomraden',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOVerksamhetstyper: {
      CollectionName: 'BOVerksamhetstyper',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '1016']]),
      RootType: {
        TypeValue: 'Verksamhetstyper',
        Abstract: false,
        SOLabel: 'Verksamhetstyp',
        SOGLabel: 'Verksamhetstyp',
        SBLabel: 'Verksamhetstypen',
        SBGLabel: 'Verksamhetstypen',
        POLabel: 'Verksamhetstyper',
        POGLabel: 'Verksamhetstyper',
        PBLabel: 'Verksamhetstyperna',
        PBGLabel: 'Verksamhetstyperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Verksamhetstypen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Verksamhetstypen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Verksamhetstypen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Verksamhetstypen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'BENAMNING;']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True']]),
          Required: true,
        },
        STATISTIKUPPGIFT: {
          AttributeName: 'STATISTIKUPPGIFT',
          DisplayLabel: 'Statistikuppgift',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ANNONSERAS: {
          AttributeName: 'ANNONSERAS',
          DisplayLabel: 'Annonseras',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'Date',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
        },
        ALDERINDELAS: {
          AttributeName: 'ALDERINDELAS',
          DisplayLabel: 'Åldersindelas',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
        },
        Kod_Benamning: {
          AttributeName: 'Kod_Benamning',
          DisplayLabel: 'Kod (benämning)',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        CATEGORY: {
          AttributeName: 'CATEGORY',
          DisplayLabel: 'Statistik kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenCat: {
          AttributeName: 'BenCat',
          DisplayLabel: 'Benämning och kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AnvandsPaGrupp: {
          AttributeName: 'AnvandsPaGrupp',
          DisplayLabel: 'Valbar på grupper',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'Internal',
          Formatter: 'TEDFormatBool',
          InterfaceType: 'ifBoolean',
        },
        SK_STATISTIK_GRUPP: {
          AttributeName: 'SK_STATISTIK_GRUPP',
          DisplayLabel: 'Statistikgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatValues',
          GUIEditable: true,
          InterfaceType: 'ifChecklist',
        },
        AVENYSTANDARD: {
          AttributeName: 'AVENYSTANDARD',
          DisplayLabel: 'Standardtyp',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        ARSBASERAD: {
          AttributeName: 'ARSBASERAD',
          DisplayLabel: 'Årsbaserad',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
      },
      Associations: {
        Aktivitetskategorier: {
          AssociationName: 'Aktivitetskategorier',
          DisplayLabel: 'Framsidan kategorier',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOVerkstypKategori',
          AssociatedComponentName: 'VerkstypKategori',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        VerktypBoknGrupp: {
          AssociationName: 'VerktypBoknGrupp',
          DisplayLabel: 'Verksamhetstypens bokningsgrupp',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'BOVerktypBoknGrupp',
          AssociatedComponentName: 'VerktypBoknGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Handelsetyper: {
          AssociationName: 'Handelsetyper',
          DisplayLabel: 'Händelsetyper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOVerkstypHandelsetyp',
          AssociatedComponentName: 'VerkstypHandelsetyp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Amnesomraden: {
          AssociationName: 'Amnesomraden',
          DisplayLabel: 'Ämnesområden',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOVerkstypAmnesomrade',
          AssociatedComponentName: 'VerkstypAmnesomrade',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    BOAldersindelning: {
      CollectionName: 'BOAldersindelning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Aldersindelning',
        Abstract: false,
        SOLabel: 'Åldersindelning',
        SOGLabel: 'Åldersindelning',
        SBLabel: 'Åldersindelningen',
        SBGLabel: 'Åldersindelningen',
        POLabel: 'Åldersindelningar',
        POGLabel: 'Åldersindelningar',
        PBLabel: 'Åldersindelningarna',
        PBGLabel: 'Åldersindelningarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Åldersindelningen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Åldersindelningen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Åldersindelningen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KOD: {
          AttributeName: 'KOD',
          DisplayLabel: 'Kod',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Giltig fr o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        TILLDATUM: {
          AttributeName: 'TILLDATUM',
          DisplayLabel: 'Giltig t o m',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOGruppAldersindelning: {
      CollectionName: 'BOGruppAldersindelning',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'GruppAldersindelning',
        Abstract: false,
        SOLabel: 'Åldersindelning',
        SOGLabel: 'Åldersindelnings',
        SBLabel: 'Åldersindelningen',
        SBGLabel: 'Åldersindelningens',
        POLabel: 'Åldersindelningar',
        POGLabel: 'Åldersindelningars',
        PBLabel: 'Åldersindelningarna',
        PBGLabel: 'Åldersindelningarnas',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Åldersindelningens primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Åldersindelningens versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Åldersindelningens id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Åldersindelningens fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'Grupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ALDER_ID: {
          AttributeName: 'ALDER_ID',
          DisplayLabel: 'ÅlderintervallID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Alder: {
          AssociationName: 'Alder',
          DisplayLabel: 'Åldersintervall',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAldersindelning',
          AssociatedComponentName: 'Aldersindelning',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    BOArsbaseradStatistik: {
      CollectionName: 'BOArsbaseradStatistik',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArsbaseradStatistik',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOArsbaseradStatistiks primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOArsbaseradStatistiks versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'BOArsbaseradStatistiks id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOArsbaseradStatistiks fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        CATEGORY: {
          AttributeName: 'CATEGORY',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ENHETSID: {
          AttributeName: 'ENHETSID',
          DisplayLabel: 'FörsamlingsID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        StatistikSenastUppdaterad: {
          AttributeName: 'StatistikSenastUppdaterad',
          DisplayLabel: 'Statistik, senast uppdaterad',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
        },
        AR: {
          AttributeName: 'AR',
          DisplayLabel: 'År',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL1: {
          AttributeName: 'ANTAL1',
          DisplayLabel: 'Antal 1',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL2: {
          AttributeName: 'ANTAL2',
          DisplayLabel: 'Antal 2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL3: {
          AttributeName: 'ANTAL3',
          DisplayLabel: 'Antal 3',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL4: {
          AttributeName: 'ANTAL4',
          DisplayLabel: 'Antal 4',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        ANTAL5: {
          AttributeName: 'ANTAL5',
          DisplayLabel: 'Antal 5',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        ANTAL6: {
          AttributeName: 'ANTAL6',
          DisplayLabel: 'Antal 6',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        ANTAL7: {
          AttributeName: 'ANTAL7',
          DisplayLabel: 'Antal 7',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
        },
        ANTAL8: {
          AttributeName: 'ANTAL8',
          DisplayLabel: 'Antal 8',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL9: {
          AttributeName: 'ANTAL9',
          DisplayLabel: 'Antal 9',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL10: {
          AttributeName: 'ANTAL10',
          DisplayLabel: 'Antal 10',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ANTAL11: {
          AttributeName: 'ANTAL11',
          DisplayLabel: 'Antal 11',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        MAN_ANTAL1: {
          AttributeName: 'MAN_ANTAL1',
          DisplayLabel: 'Manuellt antal 1',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL2: {
          AttributeName: 'MAN_ANTAL2',
          DisplayLabel: 'Manuellt antal 2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL3: {
          AttributeName: 'MAN_ANTAL3',
          DisplayLabel: 'Manuellt antal 3',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL4: {
          AttributeName: 'MAN_ANTAL4',
          DisplayLabel: 'Manuellt antal 4',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL5: {
          AttributeName: 'MAN_ANTAL5',
          DisplayLabel: 'Manuellt antal 5',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL6: {
          AttributeName: 'MAN_ANTAL6',
          DisplayLabel: 'Manuellt antal 6',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL7: {
          AttributeName: 'MAN_ANTAL7',
          DisplayLabel: 'Manuellt antal 7',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL8: {
          AttributeName: 'MAN_ANTAL8',
          DisplayLabel: 'Manuellt antal 8',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL9: {
          AttributeName: 'MAN_ANTAL9',
          DisplayLabel: 'Manuellt antal 9',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL10: {
          AttributeName: 'MAN_ANTAL10',
          DisplayLabel: 'Manuellt antal 10',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        MAN_ANTAL11: {
          AttributeName: 'MAN_ANTAL11',
          DisplayLabel: 'Manuellt antal 11',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SUMMA1: {
          AttributeName: 'SUMMA1',
          DisplayLabel: 'Summerat antal 1',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA2: {
          AttributeName: 'SUMMA2',
          DisplayLabel: 'Summerat antal 2',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA3: {
          AttributeName: 'SUMMA3',
          DisplayLabel: 'Summerat antal 3',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA4: {
          AttributeName: 'SUMMA4',
          DisplayLabel: 'Summerat antal 4',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA5: {
          AttributeName: 'SUMMA5',
          DisplayLabel: 'Summerat antal 5',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA6: {
          AttributeName: 'SUMMA6',
          DisplayLabel: 'Summerat antal 6',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA7: {
          AttributeName: 'SUMMA7',
          DisplayLabel: 'Summerat antal 7',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA8: {
          AttributeName: 'SUMMA8',
          DisplayLabel: 'Summerat antal 8',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA9: {
          AttributeName: 'SUMMA9',
          DisplayLabel: 'Summerat antal 9',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA10: {
          AttributeName: 'SUMMA10',
          DisplayLabel: 'Summerat antal 10',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SUMMA11: {
          AttributeName: 'SUMMA11',
          DisplayLabel: 'Summerat antal 11',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOArsbaseradStatistik2: {
      CollectionName: 'BOArsbaseradStatistik2',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArsbaseradStatistik2',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'BOArsbaseradStatistik2s primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'BOArsbaseradStatistik2s versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'BOArsbaseradStatistik2s id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'BOArsbaseradStatistik2s fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ID: {
          AttributeName: 'ID',
          DisplayLabel: 'ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHETSID: {
          AttributeName: 'ENHETSID',
          DisplayLabel: 'FörsamlingsID',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        AR: {
          AttributeName: 'AR',
          DisplayLabel: 'År',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatIntAsYear',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        GRUPP_ID: {
          AttributeName: 'GRUPP_ID',
          DisplayLabel: 'Grupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        KATEGORI: {
          AttributeName: 'KATEGORI',
          DisplayLabel: 'Kategori',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        VARDE: {
          AttributeName: 'VARDE',
          DisplayLabel: 'Värde',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        VARDE_AVENY: {
          AttributeName: 'VARDE_AVENY',
          DisplayLabel: 'Värde hämtat från Aveny',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        SKAPAD_AV: {
          AttributeName: 'SKAPAD_AV',
          DisplayLabel: 'Skapad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        SKAPAD_DATUM: {
          AttributeName: 'SKAPAD_DATUM',
          DisplayLabel: 'Skapad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANDRAD_AV: {
          AttributeName: 'ANDRAD_AV',
          DisplayLabel: 'Ändrad av',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ANDRAD_DATUM: {
          AttributeName: 'ANDRAD_DATUM',
          DisplayLabel: 'Ändrad datum',
          DataType: 'DateTime',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDateTime',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        StatistikSenastUppdaterad: {
          AttributeName: 'StatistikSenastUppdaterad',
          DisplayLabel: 'Statistik',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNone',
        },
      },
      Associations: {
      },
    },
    BOSKKAmnesomraden: {
      CollectionName: 'BOSKKAmnesomraden',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SKKAmnesomraden',
        Abstract: false,
        SOLabel: 'Ämnesområde',
        SOGLabel: 'Ämnesområde',
        SBLabel: 'Ämnesområdet',
        SBGLabel: 'Ämnesområdet',
        POLabel: 'Ämnesområde',
        POGLabel: '',
        PBLabel: 'Ämnesområdena',
        PBGLabel: 'Ämnesområdena',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ämnesområdet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ämnesområdet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ämnesområdet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        HEADLINE: {
          AttributeName: 'HEADLINE',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 50,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.contains, T.equals, T.notequals, T.interval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        DESCRIPTION: {
          AttributeName: 'DESCRIPTION',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 255,
        },
        COUNT: {
          AttributeName: 'COUNT',
          DisplayLabel: 'Count behövs nog ej',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ORG_ID: {
          AttributeName: 'ORG_ID',
          DisplayLabel: 'Organisations id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        SKK_REGION_ID: {
          AttributeName: 'SKK_REGION_ID',
          DisplayLabel: 'RegionID/ProjektID',
          Hint: 'ID för de enheter som inte har OrgID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKK_API22_EXT_ID: {
          AttributeName: 'SKK_API22_EXT_ID',
          DisplayLabel: 'Externt ID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    BOSKKAktivitetAmnesomrade: {
      CollectionName: 'BOSKKAktivitetAmnesomrade',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'SKKAktivitetAmnesomrade',
        Abstract: false,
        SOLabel: 'Ämnesområdei för en aktivitet',
        SOGLabel: 'Ämnesområde för en aktivitet',
        SBLabel: 'Ämnesområdet f??r en aktivitet',
        SBGLabel: 'Ämnesområdet för en aktivitet',
        POLabel: 'Ämnesområden för en aktivitet',
        POGLabel: 'Ämnesområden för en aktivitet',
        PBLabel: 'Ämnesområdena för en aktivitet',
        PBGLabel: 'Ämnesområdena för en aktivitet',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Ämnesområdet för en aktivitet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Ämnesområdet för en aktivitet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Ämnesområdet för en aktivitet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        AKT_ID: {
          AttributeName: 'AKT_ID',
          DisplayLabel: 'Aktivitets id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        SKK_AMNESOMRADE_ID: {
          AttributeName: 'SKK_AMNESOMRADE_ID',
          DisplayLabel: 'Ämnesområde id',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Aktivitet: {
          AssociationName: 'Aktivitet',
          DisplayLabel: 'Aktivitet',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOAktivitet',
          AssociatedComponentName: 'Aktivitet',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Amnesomrade: {
          AssociationName: 'Amnesomrade',
          DisplayLabel: 'Ämnesområde',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'BOSKKAmnesomraden',
          AssociatedComponentName: 'SKKAmnesomraden',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
  },
};

export default BO;
